{
  "accept_invite": {
    "back_to_home": "Tilbage til forsiden",
    "choose_password": "Vælg adgangskode",
    "heading": "Accepter invitation",
    "loading": "Indlæser",
    "save_button": "Accepter invitation",
    "text": "Du er blevet inviteret til Moxso. Vælg venligst en adgangskode for at acceptere invitationen."
  },
  "automation": {
    "audience": "Denne målgruppe indeholder én aktiv medarbejder | Denne målgruppe indeholder {count} aktive medarbejdere",
    "automation_updated": "Automatisering opdateret",
    "delete": {
      "are_you_sure": "Er du sikker på, at du vil slette denne sekvens? Denne handling kan ikke fortrydes.",
      "automation_deleted": "Sekvensen blev slettet",
      "button": "Slet"
    },
    "details": {
      "heading": "Detaljer",
      "text": "Detaljer for automatiseringsflowet"
    },
    "edit": {
      "subtitle": "Opbyg automatiseringsflowet ved at tilføje handlinger",
      "title": "Handlinger"
    },
    "edit_automation": "Rediger indstillinger",
    "employee_already_enrolled": "Denne medarbejder er allerede tilmeldt",
    "enroll_employees": "Tilmeld medarbejdere",
    "enrolled_employees": "Gruppe opdateret",
    "flow": {
      "actions": {
        "assign_lesson": {
          "custom_label": "Brugerdefineret"
        },
        "assign_quiz": {
          "custom_help": "Når dette er deaktiveret, vælger Moxso Intelligence den mest relevante træning baseret på medarbejderens risikoprofil.",
          "custom_label": "Brugerdefineret vurdering",
          "risk_categories": "Risikokategorier"
        },
        "delete": {
          "button": "Slet handling",
          "text": "Er du sikker på, at du vil slette denne handling?"
        },
        "editing": {
          "add_tag_action": "Tilføj tag",
          "assign_course_action": "Tildel kursus",
          "assign_lesson_action": "Tildel lektion",
          "assign_quiz_action": "Tildel vurdering",
          "assign_video_action": "Tildel video",
          "halt_action": "Stop automatiseringsflowet",
          "remove_tag_action": "Fjern tag",
          "wait_action": "Afvent en varighed"
        },
        "preview": "Vis aktivitet",
        "repeat_enabled": "Flowet gentages for hver medarbejder",
        "status": {
          "active": "Aktiv: {count}",
          "completed": "Afsluttet: {count}",
          "halted": "Stoppet: {count}"
        },
        "step": "Trin {step}",
        "wait_units": {
          "days": "dag | dage",
          "months": "måned | måneder",
          "weeks": "uge | uger"
        }
      },
      "edit": "Rediger",
      "length": "Længde",
      "save_step": "Gem trin",
      "title": {
        "preview": {
          "assign_lesson_action": {
            "text": "Moxso AI vil automatisk tildele den bedste lektion til hver medarbejder baseret på deres færdighedsniveau og læringsstil.",
            "title": "Lad Moxso AI tildele en lektion"
          },
          "halt_action": {
            "text": "Automatiseringsflowet stoppes for medarbejderen, når personen når til dette trin.",
            "title": "Stop automatisering"
          }
        },
        "wait_action": "Afvent i {duration} {unit}"
      },
      "unit": "Enhed"
    },
    "form_new_automation": {
      "button": "Opret en sekvens",
      "group": "Gruppe",
      "group_placeholder": "Vælg gruppe",
      "name": "Navn",
      "template": {
        "label": "Skabelon",
        "placeholder": "Vælg skabelon"
      },
      "title": "Opret en sekvens"
    },
    "funnel": {
      "button": "Rediger forløb",
      "start": "Start",
      "title": "Sekvenstragt"
    },
    "hide_advanced_settings": "Skjul avancerede indstillinger",
    "notification_frequency": "Notifikationsfrekvens",
    "notifications": "Notifikationer",
    "notifications_active": "Aktiv",
    "notifications_inactive": "Inaktiv",
    "participants": {
      "filter": {
        "status": {
          "active": "Aktive ({count})",
          "all": "Alle ({count})",
          "completed": "Afsluttede ({count})",
          "halted": "Stoppede ({count})"
        }
      },
      "heading": "Deltagere",
      "statistics": {
        "participant_coverage": "Deltagerdækning",
        "participant_coverage_text": "Beregnet score baseret på procentdelen af medarbejdere, der er tilmeldt denne øvelse."
      },
      "text": "Statistik over deltagelse"
    },
    "pause": "Sæt på pause",
    "play": "Aktiver",
    "search": {
      "placeholder": "Søg efter medarbejdere",
      "results": "Søgeresultater for: {query}"
    },
    "sequence": {
      "subtitle": "Oversigt over automatiseringsflow",
      "title": "Sekvens"
    },
    "settings": {
      "create_segment": "Opret segment",
      "help": {
        "content_skipping_enabled": "Tillad medarbejdere at springe trin i automatiseringen over, hvis deres kompetenceniveau er tilstrækkeligt.",
        "notification_flow_enabled": "Send automatiske notifikationer til medarbejdere, der ikke har gennemført flowet.",
        "notification_past_deadline_enabled": "Send ugentlige notifikationer i en måned efter overskredet deadline",
        "notification_prelude_enabled": "Send en notifikation til medarbejderen, når træningsøvelsen er tildelt.",
        "relative_deadlines_enabled": "En medarbejder fortsætter ikke i automatiseringsflowet, før den foregående frist er opfyldt.",
        "relative_progression_enabled": "En medarbejder fortsætter i automatiseringsflowet, uagtet om den foregående lektion er gennemført.",
        "repeat_enabled": "Giv medarbejderne mulighed for at gennemgå automatiseringen mere end én gang",
        "repeat_only_after_halt": "Gennemgå kun automatiseringen igen, hvis medarbejderen ikke har gennemført hele automatiseringen",
        "repeatable_assignments_enabled": "En medarbejder kan få tildelt lektioner der allerede er gennemført.",
        "segment": "Indsnævre automatiseringsflowet til et specifikt segment.",
        "trigger": "Vælg udløseren for dette automatiseringsflow."
      },
      "labels": {
        "content_skipping_enabled": "Spring indhold over",
        "date": "Dato",
        "group": "Gruppe",
        "name": "Navn",
        "notification_flow_enabled": "Aktiver notifikationsflow",
        "notification_frequency": "Frekvens for notifikationer",
        "notification_past_deadline_enabled": "Aktiver påmindelser efter deadline",
        "notification_prelude_enabled": "Send tildelelsesnotifikationer",
        "relative_deadlines_enabled": "Aktiver relative deadlines",
        "relative_progression_enabled": "Aktiver relativ progression",
        "repeat_enabled": "Gentag automatiseringsflow",
        "repeat_only_after_halt": "Gentag kun efter stop",
        "repeatable_assignments_enabled": "Gentag tildelinger",
        "segment": "Segment",
        "tag": "Tag",
        "trigger": "Udløser",
        "use_segment": "Benyt et segment"
      },
      "no_segment_found": "Ingen segment fundet for denne gruppe",
      "not_editable_text": "Sæt automatiseringsflowet på pause for at redigere indstillingerne",
      "not_editable_title": "Dette automatiseringsflow er i gang",
      "placeholder": {
        "course": "Vælg kursus",
        "date": "Vælg dato",
        "lesson": "Vælg lektion",
        "segment": "Vælg segment",
        "tag": "Vælg tag",
        "video": "Vælg video"
      },
      "repeatable_assignments_enabled": "Da du har valgt at en medarbejder kan få tildelt øvelser de allerede har gennemført på tidligere tidspunkt, skal sekvensen følge relative deadlines.",
      "save_settings": "Gem indstillinger",
      "settings_saved": "Indstillinger gemt"
    },
    "show_advanced_settings": "Vis avancerede indstillinger"
  },
  "billing": {
    "missing_payment_banner": "Handling påkrævet: manglende betaling"
  },
  "breaches": {
    "breached_accounts": "Konti med databrud",
    "compromised_info": "Kompromitterede data",
    "data_types": "Typer af data i denne lækage",
    "date": "Dato for brud",
    "disabled": {
      "button": "Gå til indstillinger",
      "heading": "Databrudsmodulet er deaktiveret",
      "text": "Underret dine medarbejdere, hvis de har været involveret i et databrud, så de hurtigt kan tage handling for at beskytte følsomme oplysninger og minimere risici, samtidig med at du får et omfattende overblik over alle brud, der påvirker dit team, for bedre sikkerhedshåndtering og hurtig respons."
    },
    "high": "Høj",
    "medium": "Medium",
    "untitled_data_breach": "Unavngivet databrud"
  },
  "buttons": {
    "back": "Tilbage",
    "cancel": "Annuller",
    "copy": "Kopier",
    "delete": "Slet",
    "download_csv": "Download CSV",
    "download_pdf": "Hent PDF",
    "view_details": "Vis detaljer"
  },
  "charts": {
    "donut": {
      "amount_share": "Antal / Andel",
      "category": "Kategori"
    },
    "resilience": {
      "score": "Score"
    }
  },
  "competency_profile": {
    "current_level": "Nuværende niveau",
    "target_level": "Målniveau",
    "thresholds_info_text": "Grænseværdierne er tilpasset hver medarbejders rolle og deres nuværende færdighedsniveau.",
    "title": "Kompetenceprofil"
  },
  "demo_data": {
    "automations": {
      "onboarding_new_employees": "Onboarding - Nye medarbejdere",
      "security_awareness_essentials_training": "Grundlæggende træning i sikkerhedsbevidsthed",
      "upskilling_all_employees": "Opkvalificering - Alle medarbejdere"
    },
    "campaign_templates": {
      "templates": {
        "annual_benefits_enrollment_deadline": {
          "html": "<p>Hej <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Dette er en venlig påmindelse om, at den årlige tilmeldingsperiode for personalegoder for medarbejdere i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> snart udløber. Du har indtil <strong>fredag den 15. september</strong> til at foretage dine valg for det kommende år.</p><p><strong>Vigtige ændringer i år:</strong></p><ul><li>Nye sundhedsforsikringsmuligheder med bedre dækning</li><li>Øget arbejdsgiver-match på pensionsordning op til 6 %</li><li>Forbedrede tand- og synsordninger</li><li>Nye grænser for fleksible udgiftskonti</li></ul><p>Hvis du ikke gennemfører din tilmelding inden fristen, bliver du automatisk tilmeldt basisordningen, som muligvis ikke matcher dine nuværende behov.</p><p>Gennemgå venligst dine muligheder og foretag dine valg via vores sikre personalegodeportal:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Gennemfør tilmelding til personalegoder</a></strong></u></p><p>Hvis du har spørgsmål om dine muligheder, er du velkommen til at kontakte vores HR-team.</p><p>Tak,<br/><strong>HR-afdelingen</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Handling påkrævet: Frist for årlig tilmelding til personalegoder"
        },
        "security_breach_immediate_action": {
          "html": "<p>Kære <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Vi har registreret mistænkelig aktivitet på din konto i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>, som kræver øjeblikkelig opmærksomhed. Vores sikkerhedssystemer har markeret flere uautoriserede loginforsøg fra en ukendt enhed.</p><p>For at beskytte din konto og virksomhedens data har vi midlertidigt begrænset adgangen til din konto. Du skal bekræfte din identitet og nulstille dine legitimationsoplysninger inden for de næste 24 timer for at undgå permanent suspension.</p><p><strong>Det skal du gøre:</strong></p><ol><li>Klik på det sikre verificeringslink nedenfor</li><li>Bekræft din identitet ved hjælp af multifaktorgodkendelse</li><li>Opdater dit kodeord med det samme</li></ol><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Verificer kontosikkerhed nu</a></strong></u></p><p>Hvis du ikke gennemfører verificeringsprocessen inden for 24 timer, vil din konto blive permanent suspenderet af sikkerhedsmæssige årsager.</p><p>Med venlig hilsen,<br/><strong>IT-sikkerhedsteamet</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Haster: Sikkerhedsbrud - øjeblikkelig handling påkrævet"
        },
        "upcoming_organizational_changes": {
          "html": "<p>Kære <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Jeg kontakter dig for at informere om nogle vigtige kommende ændringer i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>. På grund af ændrede forretningsbehov vil vi omstrukturere visse afdelinger, og desværre vil nogle stillinger blive nedlagt.</p><p>Det er vigtigt, at du gennemgår de detaljerede oplysninger om disse ændringer så hurtigt som muligt for at forstå, hvordan de kan påvirke dig og dit team.</p><p>Klik venligst på linket nedenfor for at læse det officielle blogindlæg, der beskriver de næste skridt og den tilgængelige støtte:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Læs CEO'ens organisatoriske opdatering</a></strong></u></p><p>Din hurtige opmærksomhed på denne sag værdsættes meget.</p><p>Med venlig hilsen,<br/><strong>Ledelsen,</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Kommende organisatoriske ændringer"
        }
      }
    },
    "campaigns": {
      "completed_events": {
        "event_0": {
          "filename": "event_0.da.html",
          "from_name": "Slack-teamet",
          "title": "[Slack] Din adgangskode udløber snart"
        },
        "event_1": {
          "filename": "event_1.da.html",
          "from_name": "Team Firmaløberen",
          "title": "Nyt løbetøj til alle"
        },
        "event_10": {
          "filename": "event_10.da.html",
          "from_name": "Maria Caroline Thomsen",
          "title": "Kaffemøde"
        },
        "event_11": {
          "filename": "event_11.da.html",
          "from_name": "SAS",
          "title": "Laveste pris nogensinde!"
        },
        "event_12": {
          "filename": "event_12.da.html",
          "from_name": "Filippa",
          "title": "Tilmelding til DHL-stafetten!"
        },
        "event_13": {
          "filename": "event_13.da.html",
          "from_name": "Slacks sikkerhedsteam",
          "title": "[Slack] Vigtigt: Ny privatlivspolitik"
        },
        "event_14": {
          "filename": "event_14.da.html",
          "from_name": "HubSpot",
          "title": "[HubSpot] Dit kodeord vil blive ændret"
        },
        "event_15": {
          "filename": "event_15.da.html",
          "from_name": "Dit SAP ID Service-team",
          "title": "[SAP] Meddelelse om nulstilling af adgangskode"
        },
        "event_16": {
          "filename": "event_16.da.html",
          "from_name": "1Password",
          "title": "[1Password] Din hovedadgangskode er blevet opdateret"
        },
        "event_17": {
          "filename": "event_17.da.html",
          "from_name": "LinkedIn",
          "title": "[LinkedIn] Dine engagementindsigter er klare"
        },
        "event_18": {
          "filename": "event_18.da.html",
          "from_name": "DocuSign",
          "title": "[DocuSign] Gennemgå dokument"
        },
        "event_2": {
          "filename": "event_2.da.html",
          "from_name": "Lars",
          "title": "Invitation til performance-workshop"
        },
        "event_3": {
          "filename": "event_3.da.html",
          "from_name": "Microsoft",
          "title": "Advarsel: 4.214 filer er blevet slettet - Microsoft"
        },
        "event_4": {
          "filename": "event_4.da.html",
          "from_name": "Pia Berggren",
          "title": "Vores familiehistorie"
        },
        "event_5": {
          "filename": "event_5.da.html",
          "title": "Forslag til betalingsløsning for kaffe"
        },
        "event_6": {
          "filename": "event_6.da.html",
          "from_name": "e-Boks A/S",
          "title": "Du har fået ny post fra Rigspolitiet"
        },
        "event_7": {
          "filename": "event_7.da.html",
          "from_name": "Facebook",
          "title": "Forny din adgangskode - Facebook"
        },
        "event_8": {
          "filename": "event_8.da.html",
          "title": "[Slack] Vigtigt: Ny privatlivspolitik"
        },
        "event_9": {
          "filename": "event_9.da.html",
          "from_name": "Microsoft",
          "title": "Kvote overskredet - Microsoft"
        }
      },
      "completed_sms_events": {
        "event_0": {
          "body": "TrackIt: Vi kunne ikke levere din pakke i dag. Bekræft din leveringsadresse inden kl. 18:00: https://trk-it.example/delivery",
          "from_name": "TrackIt"
        },
        "event_1": {
          "body": "Løn: Din lønseddel for april er klar. Gennemgå det sikre dokument her: https://payroll-example.test/review",
          "from_name": "Løn"
        },
        "event_2": {
          "body": "IT Support: Vi har registreret et nyt login på din mailkonto. Hvis det ikke var dig, så bekræft din identitet nu: https://it-help.example/verify",
          "from_name": "IT Support"
        },
        "event_3": {
          "body": "Kontor: Du er blevet tilføjet til morgendagens adgangsliste til bygningen. Åbn gæstepasset her: https://office-pass.example/access",
          "from_name": "Kontor"
        },
        "event_4": {
          "body": "Bank: En kortbetaling er blevet sat på pause. Bekræft transaktionen for at undgå en midlertidig spærring: https://bank-secure.example/check",
          "from_name": "Bank"
        }
      },
      "names": {
        "automatic_campaign": "Automatisk kampagne",
        "christmas": "Jul",
        "sms_campaign": "SMS-kampagne",
        "test": "Test"
      }
    },
    "custom_courses": {
      "names": {
        "access_control_principles": "Principper for adgangskontrol",
        "backup_and_recovery_procedures": "Procedurer for backup og gendannelse",
        "business_continuity_planning": "Planlægning af forretningskontinuitet",
        "cloud_security_basics": "Grundlæggende cloud-sikkerhed",
        "cybersecurity_awareness_training": "Træning i cybersikkerhedsbevidsthed",
        "data_protection_fundamentals": "Grundlæggende databeskyttelse",
        "digital_ethics_and_compliance": "Digital etik og overholdelse",
        "email_security_guidelines": "Retningslinjer for e-mailsikkerhed",
        "gdpr_compliance_essentials": "Grundlæggende GDPR-overholdelse",
        "incident_response_training": "Træning i hændelsesrespons",
        "information_classification": "Informationsklassificering",
        "mobile_device_security": "Sikkerhed for mobile enheder",
        "network_security_fundamentals": "Grundlæggende netværkssikkerhed",
        "password_security_best_practices": "Bedste praksis for adgangskodesikkerhed",
        "phishing_prevention": "Forebyggelse af phishing",
        "privacy_by_design": "Databeskyttelse gennem design",
        "remote_work_security": "Sikkerhed ved fjernarbejde",
        "secure_coding_practices": "Sikker kodningspraksis",
        "social_engineering_defense": "Forsvar mod social engineering",
        "vendor_risk_management": "Risikostyring af leverandører"
      }
    },
    "custom_videos": {
      "videos": {
        "creating_strong_passwords": {
          "description": "Bedste praksis for at oprette og administrere stærke, sikre adgangskoder.",
          "title": "Opret stærke adgangskoder"
        },
        "data_privacy_basics": {
          "description": "Det vigtigste om databeskyttelse og hvordan du beskytter dine personoplysninger.",
          "title": "Grundlæggende om databeskyttelse"
        },
        "introduction_to_cyber_security": {
          "description": "En oversigt over grundlæggende cybersikkerhed og hvorfor det er vigtigt.",
          "title": "Introduktion til cybersikkerhed"
        },
        "multi_factor_authentication": {
          "description": "Sådan fungerer multifaktorgodkendelse, og hvorfor du bør bruge det.",
          "title": "Multifaktorgodkendelse"
        },
        "new_employee_security_awareness": {
          "description": "En introduktionsvideo for nye medarbejdere om grundlæggende sikkerhedspraksis.",
          "title": "Sikkerhedsbevidsthed for nye medarbejdere"
        },
        "recognizing_phishing_emails": {
          "description": "Lær at identificere og undgå phishingmails for at beskytte dine oplysninger.",
          "title": "Genkend phishingmails"
        },
        "safe_internet_browse": {
          "description": "Tips og teknikker til at surfe sikkert paa internettet.",
          "title": "Sikker internetbrowsing"
        },
        "securing_mobile_devices": {
          "description": "Lær, hvordan du beskytter dine mobile enheder mod trusler.",
          "title": "Sikring af mobile enheder"
        },
        "social_engineering_attacks": {
          "description": "Forstaa social engineering-taktikker, og hvordan du forsvarer dig mod dem.",
          "title": "Social engineering-angreb"
        },
        "understanding_ransomware": {
          "description": "En introduktion til ransomware, og hvordan du beskytter dine data mod det.",
          "title": "Forstå ransomware"
        }
      }
    },
    "policies": {
      "content": {
        "heading_second_paragraph": "Andet afsnit",
        "paragraph_1": "Hos [Company Name] er vi forpligtet til at opretholde de højeste standarder for datasikkerhed i alle dele af vores drift. Vi anerkender, at fortrolighed, integritet og tilgængelighed af personlige og følsomme oplysninger er afgørende for at bevare tilliden hos vores kunder, medarbejdere, partnere og myndigheder.",
        "paragraph_2": "Derfor har vi etableret denne datasikkerhedspolitik for at definere de principper og praksisser, der styrer vores indsats for at beskytte data mod uautoriseret adgang, misbrug, tab, ændring eller ødelæggelse. Politikken gælder alle personoplysninger, vi indsamler, behandler eller opbevarer, i både digital og fysisk form, og er i overensstemmelse med anerkendte branchestandarder og lovkrav, herunder [indsæt relevante love, f.eks. GDPR, CCPA, HIPAA].",
        "paragraph_3": "Vores mål er at implementere proaktive sikkerhedsforanstaltninger, der reducerer risiko, sikrer compliance og understøtter vores overordnede governance af information. Vi anvender en kombination af tekniske, administrative og fysiske beskyttelsesforanstaltninger for at beskytte data gennem hele dets livscyklus.",
        "paragraph_4": "Dette omfatter adgangskontrolmekanismer, kryptering, sikker softwareudvikling, planlægning af hændelsesrespons, medarbejdertræning og regelmæssige revisioner. Enhver medarbejder, konsulent og tredjepartsleverandør, der håndterer personoplysninger, forventes at forstå og efterleve de sikkerhedsansvar, der er beskrevet i denne politik.",
        "paragraph_5": "Gennem løbende evaluering og forbedring af vores sikkerhedsniveau sigter vi mod at være på forkant med udviklende trusler og sikre, at personoplysninger betroet til os håndteres med størst mulig omhu og grundighed."
      },
      "names": {
        "acceptable_use_policy": "Politik for acceptabel brug",
        "access_control_policy": "Politik for adgangskontrol",
        "bring_your_own_device_byod_policy": "Politik for medbragte enheder (BYOD)",
        "business_continuity_and_disaster_recovery_policy": "Politik for forretningskontinuitet og disaster recovery",
        "change_management_policy": "Politik for ændringsstyring",
        "cloud_usage_policy": "Politik for brug af cloud",
        "code_of_conduct": "Adfærdskodeks",
        "company_it_security_policy": "Virksomhedens IT-sikkerhedspolitik",
        "data_protection_and_privacy_policy": "Politik for databeskyttelse og privatliv",
        "email_and_communication_policy": "Politik for e-mail og kommunikation",
        "employee_onboarding_policy": "Politik for onboarding af medarbejdere",
        "encryption_policy": "Krypteringspolitik",
        "incident_response_policy": "Politik for hændelseshåndtering",
        "internet_usage_policy": "Politik for internetbrug",
        "mobile_device_management_policy": "Politik for håndtering af mobile enheder",
        "monitoring_and_logging_policy": "Politik for overvågning og logning",
        "network_security_policy": "Politik for netværkssikkerhed",
        "password_management_policy": "Politik for adgangskodehåndtering",
        "patch_management_policy": "Politik for patchhåndtering",
        "physical_security_policy": "Politik for fysisk sikkerhed",
        "remote_work_policy": "Politik for fjernarbejde",
        "secure_development_policy": "Politik for sikker udvikling",
        "social_media_policy": "Politik for sociale medier",
        "software_installation_policy": "Politik for softwareinstallation",
        "third_party_vendor_security_policy": "Politik for sikkerhed hos tredjepartsleverandører"
      }
    },
    "simulations": {
      "subjects": {
        "new_work_phones": "Vi får nye arbejdstelefoner",
        "slack_privacy_policy": "[Slack] Vigtigt: Ny privatlivspolitik",
        "warning_files_deleted": "Advarsel: 4.214 filer blev slettet - Microsoft"
      }
    },
    "threats": {
      "emails": {
        "free_gift_card_sender": "no-reply@ing.dk"
      },
      "subjects": {
        "free_gift_card_opportunity_open": "👉 Din mulighed for et gratis gavekort på 300 kr er stadig åben!",
        "free_gift_card_opportunity_short": "Din mulighed for et gratis gavekort på 300 kr e...",
        "free_gift_card_opportunity_short_with_space": " Din mulighed for et gratis gavekort på 300 kr e..."
      }
    },
    "training": {
      "courses": {
        "10564bf8-aa3e-4295-9cf0-d350276455da": "Grundlæggende om cybersikkerhed",
        "19a78f09-8c46-4090-b2aa-e2d655efb9cf": "Behandling af personoplysninger",
        "27ad50e1-7967-49bd-a85a-3c8a4a97975a": "En introduktion til GDPR",
        "2ba7b31b-c23c-4195-9506-6dd064f9c72d": "Phishing",
        "69e29286-5079-4053-bd59-f59e64b41cf2": "For begyndere",
        "9dadf2a3-6883-4929-b77d-ac424f690a7c": "Adgangskoder",
        "a07d3c2d-0414-43bd-b8a7-6555af86c065": "Ransomware",
        "cdf2ba12-d0cd-4c71-a58e-267ec870007a": "Fysisk sikkerhed"
      },
      "videos": {
        "a_secure_network": "Et sikkert netværk",
        "ai_impact_on_phishing": "AI's påvirkning af phishing",
        "ai_powered_social_engineering_tactics": "AI-drevne social engineering-taktikker",
        "beware_of_public_networks": "Pas på offentlige netværk",
        "beware_of_usbs_and_other_hard_drives": "Pas på USB-stik og andre harddiske",
        "black_white_and_grey_hat_hackers": "Black hat-, white hat- og grey hat-hackere",
        "cybersecurity_on_mobile_devices": "Cybersikkerhed på mobile enheder",
        "data_leak_monitoring": "Overvågning af datalæk",
        "gdpr_and_security_breaches": "GDPR og sikkerhedsbrud",
        "hacking_of_hashes": "Hacking af hashes",
        "how_has_cryptocurrency_changed_hacking": "Hvordan har kryptovaluta ændret hacking?",
        "how_to_create_strong_passwords": "Sådan laver du stærke adgangskoder",
        "how_to_detect_phishing": "Sådan opdager du phishing",
        "how_to_prevent_tailgating": "Sådan forhindrer du tailgating",
        "how_to_protect_confidential_data_in_llms": "Sådan beskytter du fortrolige data i LLM'er",
        "how_to_strengthen_your_physical_security": "Sådan styrker du din fysiske sikkerhed",
        "multi_factor_authentication": "Multifaktorgodkendelse",
        "password_managers": "Adgangskodeadministratorer",
        "phishing_from_a_trusted_sender": "Phishing fra en betroet afsender",
        "processing_of_personal_data": "Behandling af personoplysninger"
      }
    }
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "at_least_two_options": "Indtast venligst mindst to valgmuligheder for hvert spørgsmål",
        "invalid_locale": "Vælg venligst et gyldigt sprog",
        "network": "En fejl er opstået",
        "noResponse": "Der opstod en serverfejl",
        "no_audience": "Vælg venligst en målgruppe",
        "no_date": "Indtast venligst en dato",
        "no_group": "Vælg venligst en gruppe",
        "no_lesson": "Vælg venligst en lektion",
        "no_manager": "Vælg venligst en manager",
        "no_phone_country_code": "Vælg venligst en landekode til telefonnummeret",
        "no_role": "Vælg venligst en rolle",
        "no_tag": "Vælg venligst et tag",
        "no_timezone": "Vælg venligst en tidszone",
        "unknown": "En ukendt fejl er opstået"
      },
      "messages": {
        "at_least_one_manager": "Der skal være mindst én manager i din organisation",
        "auth_failed": "Ugyldig email og/eller adgangskode",
        "course_could_not_be_published": "Kan ikke udgive kurset. Sørg for, at alle trin er udfyldt på alle sprog, og at ingen mangler en titel.",
        "deepl_translation_failed": "AI-oversættelse mislykkedes. Prøv igen senere.",
        "duplicate_field_identifier": "Dette datapunkt er allerede oprettet",
        "duplicate_goal": "Der findes allerede et mål med denne type og slutdato.",
        "general_exception": "En fejl er opstået",
        "goal_expired": "Et udløbet mål kan ikke opdateres.",
        "group_has_automation": "Denne gruppe kan ikke slettes, da den er en del af en aktiv automation.",
        "group_has_campaign": "Denne gruppe kan ikke slettes, da den er knyttet til en aktiv kampagne.",
        "invalid_domain": "Ugyldigt domæne",
        "invalid_invite": "Ugyldig invitation",
        "invalid_metadata": "Metadata-URL'en kunne ikke hentes eller indeholdt ikke brugbar SAML-metadata. Sørg for, at SAML-konfigurationerne er indtastet i din IdP.",
        "invalid_phone_number": "Ugyldigt telefonnummer",
        "invalid_provider": "Den valgte integrationsudbyder er ugyldig.",
        "invalid_provider_id": "Det integrationsudbyder ID, du har angivet, er ugyldigt.",
        "invalid_request": "Teknisk fejl",
        "invalid_request_signature": "Linket, du brugte, er ugyldigt eller ikke længere aktivt. Kontakt venligst din administrator for en ny invitation.",
        "invalid_response": "Identitetsudbyderen returnerede et ugyldigt svar.",
        "missing_calculation": "Det har ikke været muligt at beregne data for denne periode",
        "missing_teams_app_installation": "Teams-appen er ikke installeret. Installer Moxso Teams-appen.",
        "missing_user": "Vi kan ikke finde en bruger med den e-mail-adresse.",
        "no_available_integration": "Ingen integration er tilgængelig for den valgte integrationsudbyder.",
        "not_found": "Kunne ikke finde det ønskede element",
        "passwords_dont_match": "De indtastede koder stemmer ikke overens",
        "policy_has_active_audit": "Kan ikke slettes, da politikken har en aktiv audit.",
        "policy_not_approved": "Kan ikke oprette audit, da politikken ikke er godkendt.",
        "provider_resource_not_found": "Gruppen blev ikke fundet hos integrationsudbyderen.",
        "saml_provider_not_found": "SAML-forbindelsen blev ikke fundet.",
        "sync_conflict": "Medarbejdersynkronisering er allerede aktiveret via en anden katalogintegration eller SCIM-forbindelse. Deaktiver den anden forbindelse til medarbejdersynkronisering, før du aktiverer denne.",
        "sync_provider_missing": "Der opstod problemer med kontakte udbyderen",
        "sync_provider_response_failure": "Medarbejdere kunne ikke synkroniseres",
        "too_many_requests": "For mange forsøg. Prøv igen om et par minutter.",
        "two_factor_challenge_invalid": "Loginudfordringen er udløbet. Log ind igen.",
        "two_factor_code_invalid": "Godkendelseskoden er ugyldig.",
        "unexpected_error": "Der opstod en uventet fejl. Prøv igen.",
        "upcoming_action_has_data": "Der er allerede planlagt handlinger for efterfølgende trin i denne sekvens. Slet disse handlinger først.",
        "user_already_active": "Brugeren findes allerede.",
        "user_exists_in_different_workspace": "Brugeren findes allerede, men i et andet arbejdsområde. Kontakt support for at føje brugeren til dette arbejdsområde.",
        "user_not_found": "Linket, du brugte, er ugyldigt eller ikke længere aktivt. Kontakt venligst din administrator for en ny invitation.",
        "video_could_not_be_uploaded": "Videoen kunne ikke uploades"
      },
      "validations": {
        "messages": {
          "accepted_if": "Ugyldige felter angivet",
          "after_or_equal": "Slutdatoen skal være en dato efter eller lig med startdatoen",
          "alpha": "{_field_} må kun indeholde bogstaver",
          "alpha_dash": "{_field_} må kun indeholde tal, bogstaver, bindestreger og underscores",
          "alpha_num": "{_field_} må kun indeholde tal og bogstaver",
          "alpha_spaces": "{_field_} må kun indeholde bogstaver og mellemrum",
          "between": "{_field_} skal være mellem {min} og {max}",
          "boolean": "{_field_} har en ugyldig værdi",
          "confirmed": "{_field_} skal matche {target}",
          "currentPassword": "Kodeordet er ikke gyldigt",
          "date": "{_field_} skal være en gyldig dato",
          "date_format": "{_field_} skal være en gyldig dato",
          "digits": "{_field_} skal være et tal på {length} cifre",
          "dimensions": "{_field_} skal være {width} pixels gange {height} pixels",
          "double": "{_field_} skal være en gyldig decimal",
          "email": "{_field_} skal være en gyldig email",
          "excluded": "{_field_} skal være en gyldig værdi",
          "ext": "{_field_} skal være en gyldig filtype",
          "image": "{_field_} skal være et billede",
          "in": "{_field_} har en ugyldig værdi",
          "integer": "{_field_} skal være en numerisk værdi",
          "invalid_domain": "Du kan ikke oprette brugere fra dette domæne, da det ikke er verificeret",
          "invalid_field": "Ugyldige felter angivet",
          "invalid_phone_number": "Ugyldigt telefonnummer",
          "length": "{_field_} må maksimalt være {length} tegn langt",
          "max": "{_field_} må maksimalt være {length} karakterer",
          "max_value": "{_field_} må maksimalt være {max} eller mindre",
          "mimes": "{_field_} skal være en gyldig filtype",
          "min": "{_field_} skal minimum være {length} karakterer",
          "min_value": "{_field_} skal være minimum {min} eller mere",
          "missing_user": "Vi kan ikke finde en bruger med den e-mail-adresse.",
          "non_disposable_email": "{_field_} skal være en gyldig email",
          "not_found": "{_field_} blev ikke fundet",
          "numeric": "{_field_} skal være numerisk",
          "oneOf": "{_field_} skal være en gyldig værdi",
          "regex": "{_field_} skal have et gyldigt format",
          "required": "{_field_} skal udfyldes",
          "required_if": "{_field_} skal udfyldes",
          "size": "{_field_} må maksimalt have en størrelse på {size}KB",
          "string": "{_field_} må kun indeholde bogstaver",
          "true": "{_field_} skal accepteres",
          "unique": "{_field_} er allerede taget",
          "unique_provider_id": "Denne gruppe er allerede oprettet"
        }
      }
    },
    "automation": {
      "flow": {
        "title": {
          "action_selector": "Vælg handling",
          "add_tag_action": "Tilføj tag",
          "assign_course_action": "Tildel kursus",
          "assign_lesson_action": "Tildel lektion",
          "assign_quiz_action": "Tildel vurdering",
          "assign_video_action": "Tildel video",
          "halt_action": "Stop automatiseringsflowet",
          "missing_action": "Handling ikke tilgængelig",
          "remove_tag_action": "Fjern tag",
          "wait_action": "Afvent en varighed"
        }
      },
      "frequency": {
        "intense": "Høj",
        "loose": "Lav",
        "normal": "Normal"
      },
      "status": {
        "paused": "pauset",
        "running": "aktiv",
        "started": "kører"
      },
      "templates": {
        "advanced-it-security-training": {
          "description": "Avanceret sikkerhedstræning for it- og teknisk personale.",
          "title": "Avanceret it-sikkerhedstræning"
        },
        "blank": {
          "description": "Start fra bunden med en tom automatisering.",
          "title": "Tom automatisering"
        },
        "cybersecurity-and-physical-security-awareness-intense": {
          "description": "Omfattende sikkerhedstræning for avancerede brugere.",
          "title": "Cyber- og fysisk sikkerhedsbevidsthed (Intensiv)"
        },
        "cybersecurity-and-physical-security-awareness-light": {
          "description": "Introducerende sikkerhedstræning for medarbejdere uden pc-adgang.",
          "title": "Cyber- og fysisk sikkerhedsbevidsthed (Let)"
        },
        "cybersecurity-and-physical-security-awareness-medium": {
          "description": "Sikkerhedsbevidsthedstræning for medarbejdere med pc-adgang.",
          "title": "Cyber- og fysisk sikkerhedsbevidsthed (Middel)"
        },
        "cybersecurity-fundamentals": {
          "description": "Kerneprincipper og best practice inden for cybersikkerhed.",
          "title": "Grundlæggende cybersikkerhed"
        },
        "management-training-in-it-security": {
          "description": "Cybersikkerhedsbevidsthed for ledere og chefer.",
          "title": "Ledelsestræning i it-sikkerhed"
        },
        "security-awareness-essentials-training": {
          "description": "Grundlæggende cybersikkerhedsbevidsthed for alle medarbejdere.",
          "title": "Grundlæggende træning i sikkerhedsbevidsthed"
        }
      },
      "triggers": {
        "date_trigger": "På en bestemt dato",
        "employee_added_to_audience_trigger": "Når en medarbejder tilføjes til sekvensens målgruppe",
        "employee_created_trigger": "Når en medarbejder oprettes",
        "simulation_link_clicked_trigger": "Når en medarbejder klikker på et link i en simulation",
        "tag_added_trigger": "Når en medarbejder bliver tagget",
        "tag_removed_trigger": "Når en medarbejder mister et tag"
      },
      "triggers_help": {
        "date_trigger": "Tilmeld alle i den valgte målgruppe, når triggeren aktiveres. Medarbejdere, der føjes til målgruppen efter denne dato, bliver ikke automatisk tilmeldt.",
        "employee_added_to_audience_trigger": "Tilmeld en medarbejder, når vedkommende føjes til den målgruppe, der er knyttet til automatiseringen.",
        "employee_created_trigger": "Tilmeld en medarbejder, så snart vedkommende føjes til Moxso.",
        "simulation_link_clicked_trigger": "Tilmeld en medarbejder, når vedkommende klikker på et link i en phishingsimulation, så du kan tildele målrettet opfølgende træning."
      },
      "wait_units": {
        "days": "dag | dage",
        "hours": "time | timer",
        "minutes": "minut | minutter",
        "months": "måned | måneder",
        "seconds": "sekund | sekunder",
        "weeks": "uge | uger"
      }
    },
    "employees": {
      "deactivation_notice": {
        "account_disabled": "Denne konto er blevet manuelt deaktiveret af en administrator den {date}.",
        "active_directory": "Denne konto er blevet deaktiveret på grund af en ændring i dit Active Directory den {date}.",
        "simulation_bounce": "Denne konto er blevet deaktiveret på grund af en afvist simulation den {date}. Afvisningsårsag: Hard bounce.",
        "simulation_complaint": "Denne konto er blevet deaktiveret på grund af en afvist simulation den {date}. Afvisningsårsag: Complaint."
      },
      "recent_activity": {
        "type": {
          "clicked": "{name} klikkede på et simulations link",
          "completed_course": "{name} gennemførte et kursus",
          "correct": "{name} besvarede en phishing quiz korrekt",
          "delivered": "{name} modtog en simulation",
          "incorrect": "{name} besvarede en phishing quiz forkert",
          "mc_correct": "{name} besvarede et multiple-choice-spørgsmål korrekt",
          "mc_incorrect": "{name} besvarede et multiple-choice-spørgsmål forkert",
          "reported": "{name} rapporterede en simulation",
          "sms_clicked": "{name} klikkede på et link i en smishing simulation",
          "sms_delivered": "{name} modtog en smishing simulation",
          "submission": "{name} loggede ind på en simulation",
          "submit_delivered": "{name} modtog en simulation",
          "watched_video": "{name} så en video"
        }
      },
      "status": {
        "active": "aktiv",
        "inactive": "inaktiv"
      }
    },
    "export_form_fields": {
      "clicked_count": "Klik på simulationer",
      "created_at": "Oprettelsesdato",
      "department": "Afdeling",
      "dynamic_group_memberships": "Dynamiske gruppe-medlemskaber",
      "email": "Email",
      "first_name": "Fornavn",
      "group_count": "Antal grupper",
      "last_name": "Efternavn",
      "locale": "Sprog",
      "manager_name": "Manager",
      "onboarded": "Onboarding status",
      "phishing_quizzes_count": "Afsluttede phishing quizzer",
      "phone_number": "Telefonnummer",
      "point_count": "Point total",
      "provider": "Integrationsudbyder",
      "received_count": "Modtagne simulationer",
      "reported_count": "Simulationer rapporteret",
      "score": "Score",
      "status": "Status",
      "submitted_count": "Login på simulationer",
      "video_quizzes_count": "Besvarede video quizzer",
      "watched_count": "Viste videoer"
    },
    "feature_upsell": {
      "bring-your-own-content": {
        "items": [
          "Upload jeres egne videoer og læringsmaterialer",
          "Lokaliser uploads på tværs af sprog og teams",
          "Del onboarding- og compliance-indhold tilpasset jeres organisation",
          "Automatiser planlægning, opfølgninger og rapportering for eget indhold."
        ],
        "summary": "Kombinér Moxso-træning med jeres eget materiale og lever indhold, der matcher jeres arbejdsgange, værktøjer og interne kommunikation.",
        "title": "Eget indhold"
      },
      "compliance-integration": {
        "items": [
          "Forbind Drata og Vanta med mindre opsætningsfriktion.",
          "Reducér manuel indsamling af compliance-dokumentation.",
          "Kortlæg træningsaktivitet i revisionsvenlige workflows.",
          "Understøt tilbagevendende reviews med færre overdragelser."
        ],
        "summary": "Synkronisér compliance-dokumentation og forbind Moxso-aktivitet med Drata- og Vanta-workflows med mindre manuelt opfølgningsarbejde.",
        "title": "Drata- og Vanta-complianceintegration"
      },
      "goal-setting": {
        "items": [
          "Sæt målbare mål for centrale performance-målinger.",
          "Følg fremskridt mod målet over tid.",
          "Brug forventede trends til at se, om målet er realistisk.",
          "Se tidligt, om performance er på rette spor."
        ],
        "summary": "Sæt et mål, følg fremskridt over tid, og sammenlign det med en forventet trendlinje for at se, om målet er realistisk og på rette spor.",
        "title": "Målsætning"
      },
      "human-risk-intelligence": {
        "items": [
          "Overvåg menneskelige risikosignaler ét sted.",
          "Følg tildelinger og interventioner over tid.",
          "Forstå nye adfærdsbaserede risici tidligere.",
          "Prioritér handlinger med mere risikokontekst."
        ],
        "summary": "Følg menneskelige risikosignaler, interventioner og tildelinger i én visning for at forstå nye adfærdsbaserede risici.",
        "title": "Indsigt i menneskelig risiko"
      },
      "industry-benchmarking": {
        "items": [
          "Sammenlign performance med benchmark fra lignende virksomheder.",
          "Tilføj kontekst til robustheds- og træningsmålinger.",
          "Opdag afvigelser hurtigere på tværs af centrale KPI'er.",
          "Styrk rapportering til interessenter og ledelse."
        ],
        "summary": "Sammenlign robusthed og træningsperformance med benchmark fra lignende virksomheder for at sætte jeres sikkerhedsmålinger i kontekst.",
        "title": "Branchebenchmarking"
      },
      "phishing-reporting-add-in": {
        "items": [
          "Gør det nemmere for medarbejdere at rapportere mistænkelige e-mails med det samme.",
          "Synliggør angreb hurtigt, før de når at sprede sig.",
          "Hold sikkerhedsrapportering enkel og top of mind for alle.",
          "Integrer rapportering i det daglige arbejde uden ekstra friktion."
        ],
        "summary": "Mailklient-tilføjelse, der lader medarbejdere rapportere phishing og mistænkelige e-mails direkte fra deres indbakke.",
        "title": "Phishing-rapportering"
      },
      "policy-management": {
        "items": [
          "Opret og opdater interne politikker ét sted",
          "Tildel politikker til de rigtige teams på det rigtige tidspunkt",
          "Indsaml medarbejdernes kvitteringer for politikker",
          "Følg status og bevar et revisionsspor"
        ],
        "summary": "Udgiv interne politikker, følg kvitteringer og hold dokumentationen organiseret på tværs af organisationen.",
        "title": "Politikstyring"
      },
      "risk-based-training": {
        "items": [
          "Adaptiv læring baseret på adfærd og risikosignaler.",
          "Reducer menneskelig cyberrisiko med personlig træning.",
          "Fokusér på reelle sårbarheder, ikke hypotetiske trusler.",
          "Minimér træthed for brugere med lav risiko."
        ],
        "summary": "Awareness-træning, der tilpasser indhold og intensitet ud fra medarbejdernes risikosignaler og risikoprofil, baseret på simulationer og observeret adfærd.",
        "title": "Risikobaseret træning"
      },
      "simulation-builder": {
        "items": [
          "Tilpas simulationer til din organisation og dens trusler.",
          "Tildel kampagner til de brugere, roller eller grupper, der betyder mest.",
          "Brug velkendte afsendere, budskaber og temaer for autenticitet.",
          "Design kampagner på dine egne vilkår og fokuser på prioriteter.",
          "Generér realistiske phishing-simulationer med AI."
        ],
        "summary": "Konfigurationsværktøjer til at oprette og administrere phishing-simulationskampagner, inklusive skabeloner, afsenderprofiler og domæner.",
        "title": "Simulationsbygger"
      },
      "smishing": {
        "items": [
          "Kør SMS-baserede phishing-simulationer.",
          "Test hvordan medarbejdere reagerer på mobile enheder.",
          "Udvid awareness-træning ud over indbakken.",
          "Mål robusthed over for mobilfokuserede angrebsmønstre."
        ],
        "summary": "Udvid simulationer ud over e-mail med SMS- og QR-baserede phishing-scenarier, der er tilpasset mobilfokuserede angreb.",
        "title": "Smishing og quishing"
      },
      "spear-phishing": {
        "items": [
          "Simulér softwaremålretning og direktørsvindel.",
          "Test høst af loginoplysninger i mere realistiske scenarier.",
          "Udvid phishingprogrammer med avancerede angrebstyper.",
          "Forbered medarbejdere på social engineering med højere risiko."
        ],
        "summary": "Opret avancerede phishing-simulationer til softwaremålretning, direktør-efterligning og scenarier med høst af loginoplysninger.",
        "title": "Spear phishing"
      },
      "teams-slack-integration": {
        "items": [
          "Forbind samarbejdskanaler med sikkerhedsworkflows.",
          "Send relevante notifikationer derhen, hvor teams allerede arbejder.",
          "Udvid rapportering og awareness til den daglige kommunikation.",
          "Understøt hurtigere opfølgning på tværs af sikkerhed og drift."
        ],
        "summary": "Forbind samarbejdsplatforme for at synkronisere notifikationer og udvide sikkerhedsworkflows til de daglige kommunikationskanaler.",
        "title": "MS Teams- og Slack-integration"
      },
      "threat-management": {
        "items": [
          "Realtidsindsigt i rapporterede trusler",
          "Branchespecifikke advarsler om nye angrebsmønstre",
          "Analyse af trusselsudvikling i organisationen",
          "Virker direkte med Outlook og Gmail."
        ],
        "summary": "Undersøg mistænkelige emails, forstå risikosignaler og reager på trusler fra ét samlet workflow til sikkerhedsteams.",
        "title": "Trusselshåndtering"
      }
    },
    "frameworks": {
      "ai_act": "AI Act",
      "dora": "DORA",
      "gdpr": "GDPR",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "nis2": "NIS2",
      "soc_2": "SOC 2"
    },
    "goals": {
      "metric": {
        "click_rate": "Klikrate",
        "employees_behind": "Medarbejdere bagefter",
        "report_rate": "Rapporteringsrate",
        "resilience_score": "Robusthedsscore"
      },
      "outcome": {
        "achieved": "Opnået",
        "missed": "Ikke opnået"
      },
      "status": {
        "ahead": "Foran",
        "at_risk": "I risiko",
        "on_track": "På rette spor"
      }
    },
    "group": {
      "sync_failure": {
        "invalid_provider": {
          "subtitle": "Vælg venligst en gyldig integrationsudbyder og opdater data."
        },
        "invalid_provider_id": {
          "subtitle": "Vælg venligst et gyldigt integrationsudbyder ID og opdater data."
        },
        "no_available_integration": {
          "subtitle": "Vælg venligst en tilgængelig integration."
        },
        "provider_resource_not_found": {
          "subtitle": "Opdatér venligst gruppens integrationsudbyder ID."
        },
        "recommended_action": "Anbefalet handling",
        "title": "Synkronisering mislykkedes"
      }
    },
    "groups": {
      "adaptive_conditions": {
        "fields": {
          "department": "Afdeling",
          "email": "E-mail",
          "locale": "Sprog",
          "manager_id": "Manager",
          "onboarded": "Onboardingstatus",
          "organizational_role_id": "Rolle",
          "provider": "Integrationsudbyder",
          "score": "Score",
          "status": "Status",
          "timezone": "Tidszone"
        },
        "operators": {
          "contains": "indeholder",
          "ends_with": "slutter med",
          "equals": "er",
          "greater_than": "er større end",
          "greater_than_or_equal": "er større end eller lig med",
          "is_empty": "er tom",
          "is_not_empty": "er ikke tom",
          "less_than": "er mindre end",
          "less_than_or_equal": "er mindre end eller lig med",
          "not_equals": "er ikke",
          "starts_with": "starter med"
        },
        "values": {
          "active": "Aktiv",
          "false": "Falsk",
          "google": "Google Workspace",
          "google_scim": "Google SCIM",
          "inactive": "Inaktiv",
          "microsoft": "Microsoft Entra ID",
          "microsoft_scim": "Microsoft Entra SCIM",
          "okta_scim": "Okta SCIM",
          "slack": "Slack",
          "true": "Sand"
        }
      }
    },
    "hri_integration_tags": {
      "access_permissions": {
        "description": "Adgangshændelser, autorisation, rettigheder og applikationsadgang.",
        "headline": "Adgang"
      },
      "account_security": {
        "description": "Kontostatus, beskyttelse, ændringer, livscyklus og risikofyldte brugere.",
        "headline": "Kontosikkerhed"
      },
      "audit_administration": {
        "description": "Revisionslogfiler, administrative hændelser og ændringer i sikkerhedsindstillinger.",
        "headline": "Revisionslogfiler"
      },
      "authentication_mfa": {
        "description": "Logins, loginaktivitet, autentificeringsresultater og MFA-hændelser.",
        "headline": "Autentificering"
      },
      "data_protection_insider_risk": {
        "description": "Forebyggelse af datatab (DLP) og hændelser vedrørende insiderrisiko.",
        "headline": "Databeskyttelse"
      },
      "device_management": {
        "description": "Administrationsdækning, agentstatus og sikkerhedsniveau for enhedsadgang.",
        "headline": "Enhedsadministration"
      },
      "device_security": {
        "description": "Kryptering, skærmlåse, endpointbeskyttelse og enhedscompliance.",
        "headline": "Enhedssikkerhed"
      },
      "email_security": {
        "description": "E-mailtrusler og kontoovertagelse.",
        "headline": "E-mailsikkerhed"
      },
      "incidents_investigations": {
        "description": "Sikkerhedshændelser, alvorlighed og undersøgelsesstatus.",
        "headline": "Sikkerhedshændelser"
      },
      "remediation_control_gaps": {
        "description": "Mangler i beskyttelsen, fund vedrørende kontroller og fremdrift i afhjælpningen.",
        "headline": "Kontrolmangler"
      },
      "service_health": {
        "description": "Driftshændelser, komponentstatus og planlagt vedligeholdelse.",
        "headline": "Driftsstatus"
      },
      "sharing_data_activity": {
        "description": "Ændringer i deling, dataflytning, brug af elementer og Git-aktivitet.",
        "headline": "Dataaktivitet"
      },
      "threats_detections": {
        "description": "Sikkerhedsadvarsler, trusselssignaler og risikodetektioner.",
        "headline": "Trusler"
      },
      "vulnerabilities_exposure": {
        "description": "Sårbarheder, cloudfund, fund fra penetrationstest og eksponering.",
        "headline": "Sårbarheder"
      },
      "workforce_organization": {
        "description": "Roller, teams, ansættelse og arbejdsforhold.",
        "headline": "Medarbejdere"
      }
    },
    "hri_integrations": {
      "abnormal_ai": {
        "bullets": [
          {
            "label": "Reelle e-mailtrusler",
            "text": "{label}: Registreret phishing og andre understøttede e-mailangreb giver dokumentation ud over simulationer."
          },
          {
            "label": "Kompromitterede konti",
            "text": "{label}: Fund vedrørende kontoovertagelse hjælper med at identificere konti, der kan kræve en akut undersøgelse."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevant dokumentation om angreb til at gøre vejledning om phishing og kontosikkerhed mere konkret."
          },
          {
            "label": "Kontekst for indsatsen",
            "text": "{label}: Registreret afhjælpning og sagsstatus hjælper med at forklare, hvad der allerede er håndteret."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om trusler og indsats uden at fjerne beskeder eller udføre handlinger på konti."
          }
        ],
        "description_long": "Abnormal AI registrerer e-mailangreb og kontoovertagelse. Forbind integrationen, så Moxso kan bruge reelle angrebssignaler til at målrette opfølgning på menneskelig risiko mod de trusler, medarbejderne møder i jeres miljø.",
        "description_short": "Brug e-mailtrusler og fund om kontoovertagelse til at målrette sikkerhedsopfølgningen.",
        "title": "Abnormal AI"
      },
      "aikido": {
        "bullets": [
          {
            "label": "Sikkerhedsfund",
            "text": "{label}: Sårbarheder og andre understøttede problemer identificerer områder, der kræver teknisk opmærksomhed."
          },
          {
            "label": "Eksponeringskontekst",
            "text": "{label}: Alvorlighed og oplysninger om berørte ressourcer hjælper med at forklare betydningen af et fund."
          },
          {
            "label": "Målrettet indsats",
            "text": "{label}: Brug relevante fund til at rette teknisk afhjælpning og sikkerhedsvejledning mod de rette teams."
          },
          {
            "label": "Fremdrift over tid",
            "text": "{label}: Ændringer i fundenes status hjælper med at skelne mellem udestående problemer og arbejde, der allerede er håndteret."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsfund uden at ændre kode eller anvende rettelser."
          }
        ],
        "description_long": "Aikido Security identificerer svagheder i software og infrastruktur. Forbind integrationen for at inddrage relevant teknisk eksponering i vurderinger af menneskelig risiko og sikkerhedsopfølgning.",
        "description_short": "Føj sårbarheder i software og infrastruktur til jeres risikovurderinger.",
        "title": "Aikido Security"
      },
      "airtable": {
        "bullets": [
          {
            "label": "Kontobeskyttelse",
            "text": "{label}: Tilgængelige indikatorer for autentificering og rettigheder hjælper med at fremhæve adgangsproblemer."
          },
          {
            "label": "Reel aktivitet",
            "text": "{label}: Udvalgte revisionshændelser dokumenterer sikkerhedsrelevante handlinger og ændringer."
          },
          {
            "label": "Målrettet vejledning",
            "text": "{label}: Brug relevante hændelser til at målrette råd om kontobeskyttelse og ansvarlig adgang til delte oplysninger."
          },
          {
            "label": "Løbende vurdering",
            "text": "{label}: Vurder ændringer i kontosikkerhed og tilbagevendende hændelser sammen med anden dokumentation."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsoplysninger uden at tilgå tabelposter. Adgang til Enterprise API kræver et abonnement, der understøtter det."
          }
        ],
        "description_long": "Airtable hjælper teams med at arbejde med delte forretningsoplysninger. Forbind integrationen, så Moxso kan bruge relevante signaler om kontosikkerhed og revision som grundlag for menneskelig risiko og målrettet opfølgning.",
        "description_short": "Gennemgå signaler om kontosikkerhed og revisionsaktivitet omkring delte forretningsoplysninger.",
        "title": "Airtable"
      },
      "asana": {
        "bullets": [
          {
            "label": "Adgangssignaler",
            "text": "{label}: Understøttede revisionshændelser identificerer aktivitet, der påvirker adgangen til konti og projekter."
          },
          {
            "label": "Ændringer i deling",
            "text": "{label}: Udvalgte hændelser om medlemskab og linkadgang dokumenterer ændringer i adgangen til samarbejde."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug omstændighederne ved en hændelse til at målrette adgangsgennemgange og vejledning om sikker deling."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder tilbagevendende adgangsændringer sammen med anden sikkerhedsdokumentation."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte revisionsmetadata uden at tilgå opgavebeskrivelser eller projektindhold. Tilgængeligheden af revisionsdata afhænger af jeres Asana-abonnement."
          }
        ],
        "description_long": "Asana hjælper teams med at organisere og dele arbejde. Forbind integrationen, så Moxso kan bruge udvalgte adgangs- og delingshændelser som grundlag for menneskelig risiko og understøtte sikrere samarbejde.",
        "description_short": "Brug adgangs- og delingshændelser til at understøtte sikrere samarbejde.",
        "title": "Asana"
      },
      "atlassian": {
        "bullets": [
          {
            "label": "Signaler om kontosikkerhed",
            "text": "{label}: Understøttede revisionshændelser dokumenterer adgangsrelateret aktivitet."
          },
          {
            "label": "Følsomme ændringer",
            "text": "{label}: Administrative handlinger hjælper med at identificere ændringer, der bør gennemgås nærmere."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevante hændelser som grundlag for adgangsgennemgange og råd om kontosikkerhed."
          },
          {
            "label": "Løbende opmærksomhed",
            "text": "{label}: Vurder tilbagevendende aktivitet sammen med anden dokumentation, før I beslutter jer for en handling."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte revisionsmetadata uden at tilgå indholdet af Jira-sager eller Confluence-sider."
          }
        ],
        "description_long": "Atlassian understøtter samarbejde på tværs af organisationen. Forbind integrationen, så Moxso kan bruge udvalgte konto- og administrationshændelser som grundlag for menneskelig risiko og relevant opfølgning.",
        "description_short": "Gennemgå kontoaktivitet og administrativ aktivitet på tværs af jeres samarbejdsværktøjer.",
        "title": "Atlassian"
      },
      "auth0": {
        "bullets": [
          {
            "label": "Reelle loginsignaler",
            "text": "{label}: Udvalgte mislykkede logins, MFA-hændelser og angrebsrelaterede hændelser afdækker adgangsproblemer."
          },
          {
            "label": "Kontobeskyttelse",
            "text": "{label}: Ændringer i loginoplysninger og sikkerhedsrelaterede kontoændringer giver yderligere dokumentation til gennemgang."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug aktivitet, der kan knyttes til medarbejdere, som grundlag for undersøgelser og råd om kontosikkerhed."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gentagne autentificeringsproblemer i sammenhæng med den berørte applikation."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgt aktivitet uden at ændre applikationskonti eller autentificeringsindstillinger."
          }
        ],
        "description_long": "Auth0 håndterer login til jeres applikationer. Forbind integrationen, så Moxso kan bruge relevante signaler om autentificering og kontosikkerhed som grundlag for menneskelig risiko, når aktiviteten vedrører jeres medarbejdere.",
        "description_short": "Brug medarbejdernes login- og kontosikkerhedshændelser som grundlag for risikovurderinger.",
        "title": "Auth0"
      },
      "clerk": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgængelige statusser for låste og blokerede konti hjælper med at identificere konti, der kan kræve nærmere gennemgang."
          },
          {
            "label": "Adgangskontekst",
            "text": "{label}: Organisationsmedlemskab hjælper med at sætte applikationsadgang i perspektiv."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevant kontokontekst som grundlag for adgangsgennemgange og samtaler om kontosikkerhed."
          },
          {
            "label": "Aktuelt overblik",
            "text": "{label}: Vurder den seneste kontostatus sammen med anden dokumentation, når I beslutter, hvad der kræver opmærksomhed."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser konto- og adgangsoplysninger uden at ændre Clerk-indstillinger. Denne forbindelse indsamler ikke loginhændelser eller sessionsaktivitet."
          }
        ],
        "description_long": "Clerk administrerer adgang til jeres applikationer. Forbind integrationen, så Moxso kan inddrage kontekst om kontoadgang sammen med menneskelig risiko og gøre opfølgning på kontosikkerhed mere relevant.",
        "description_short": "Brug kontostatus og organisationsmedlemskab som grundlag for adgangsgennemgange.",
        "title": "Clerk"
      },
      "cloudflare_zero_trust": {
        "bullets": [
          {
            "label": "Sikkerhedsændringer",
            "text": "{label}: Udvalgte revisionshændelser identificerer ændringer i adgangsrelaterede indstillinger og ressourcer."
          },
          {
            "label": "Adgangskontekst",
            "text": "{label}: Tilgængelige detaljer om aktør, handling og resultat hjælper med at forklare betydningen af en hændelse."
          },
          {
            "label": "Målrettet gennemgang",
            "text": "{label}: Brug følsomme ændringer til at identificere, hvor der er behov for en adgangsgennemgang eller sikkerhedsopfølgning."
          },
          {
            "label": "Løbende indsigt",
            "text": "{label}: Vurder gentagne administrative ændringer sammen med anden sikkerhedsdokumentation."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsoplysninger uden at ændre adgangspolitikker. Denne forbindelse tilbyder ikke trafikovervågning eller logintelemetri fra Access."
          }
        ],
        "description_long": "Cloudflare Zero Trust beskytter adgangen til virksomhedens ressourcer. Forbind integrationen, så Moxso kan bruge udvalgte ændringer i sikkerhed og adgangskontrol som kontekst for menneskelig risiko og undersøgelser.",
        "description_short": "Gennemgå ændringer i sikkerhed og adgangskontrol, der påvirker virksomhedens ressourcer.",
        "title": "Cloudflare Zero Trust"
      },
      "comp_ai": {
        "bullets": [
          {
            "label": "Sikkerhedsfund",
            "text": "{label}: Understøttede fund fremhæver forhold, der kræver gennemgang eller afhjælpning."
          },
          {
            "label": "Beskyttelseskontekst",
            "text": "{label}: Tilgængelige enhedssikkerhedskontroller, herunder krypteringsstatus, hjælper med at forklare problemet."
          },
          {
            "label": "Praktisk indsats",
            "text": "{label}: Brug relevant dokumentation til at målrette opfølgning med medarbejderen, IT-teamet eller den kontrolansvarlige."
          },
          {
            "label": "Ændrede forhold",
            "text": "{label}: Opdateringer af fund og beskyttelsesstatus hjælper med at skelne mellem vedvarende problemer og løste opgaver."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgt sikkerhedsdokumentation uden at fuldføre opgaver eller ændre politikker."
          }
        ],
        "description_long": "Comp AI følger sikkerhedskontroller og compliancefund. Forbind integrationen, så Moxso kan inddrage relevante mangler i beskyttelsen ved vurdering af menneskelig risiko og beslutninger om, hvor opfølgning er nødvendig.",
        "description_short": "Brug sikkerhedsfund og mangler i enhedsbeskyttelsen til at målrette opfølgning.",
        "title": "Comp AI"
      },
      "crowdstrike": {
        "bullets": [
          {
            "label": "Reelle angrebssignaler",
            "text": "{label}: Endpointadvarsler dokumenterer mistænkelig eller ondsindet aktivitet."
          },
          {
            "label": "Eksponeringskontekst",
            "text": "{label}: Alvorlighed, berørte ressourcer og tilgængelige sårbarhedsdetaljer hjælper med at sætte fund i perspektiv."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevante fund til at koordinere undersøgelser, afhjælpning på enheder og medarbejdervejledning."
          },
          {
            "label": "Undersøgelsens fremdrift",
            "text": "{label}: Status for fund og sager hjælper med at vise, hvilke problemer der stadig kræver opmærksomhed."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsfund uden at isolere værter eller ændre undersøgelser."
          }
        ],
        "description_long": "CrowdStrike Falcon registrerer trusler på arbejdsenheder. Forbind integrationen, så Moxso kan bruge relevante endpointfund som grundlag for menneskelig risiko og målrette opfølgning mod reelle sikkerhedsproblemer.",
        "description_short": "Inddrag endpointadvarsler og sårbarhedsfund i jeres risikovurderinger.",
        "title": "CrowdStrike"
      },
      "datadog": {
        "bullets": [
          {
            "label": "Sikkerhedssignaler",
            "text": "{label}: Udvalgte fund dokumenterer aktivitet, der bør undersøges."
          },
          {
            "label": "Kontoaktivitet",
            "text": "{label}: Understøttede hændelser om autentificering, adgang og sikkerhedskonfiguration tilføjer kontekst."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug medarbejderrelateret dokumentation som grundlag for gennemgang af kontosikkerhed og relevante råd."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder tilbagevendende hændelser og opdateringer af fund sammen med anden risikodokumentation."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsoplysninger uden at importere generelle applikationsmålinger eller ændre indstillinger."
          }
        ],
        "description_long": "Datadog identificerer sikkerhedsaktivitet på tværs af overvågede miljøer. Forbind integrationen, så Moxso kan bruge relevante sikkerhedsfund og kontohændelser som grundlag for vurderinger af menneskelig risiko.",
        "description_short": "Tilføj sikkerhedsfund og kontoaktivitet fra overvågede miljøer.",
        "title": "Datadog"
      },
      "deel": {
        "bullets": [
          {
            "label": "Rollekontekst",
            "text": "{label}: Ansvarsområder og afdelinger hjælper med at sætte sikkerhedsproblemer i perspektiv."
          },
          {
            "label": "Medarbejderændringer",
            "text": "{label}: Ændringer i ansættelsesstatus giver kontekst til vurdering af, om adgang fortsat er passende."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Tag højde for den enkeltes arbejdssituation, når I vælger sikkerhedsråd og emner til bevidsthedstræning."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug rolle- og livscykluskontekst sammen med sikkerhedsdokumentation som grundlag for samtaler med de rette personer."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser relevante medarbejderoplysninger uden at ændre ansættelsesoplysninger eller behandle løn."
          }
        ],
        "description_long": "Deel hjælper med at administrere medarbejdere på tværs af roller og arbejdsforhold. Forbind integrationen, så Moxso kan inddrage relevant medarbejderkontekst ved vurdering af menneskelig risiko og planlægning af sikkerhedsopfølgning.",
        "description_short": "Tilføj medarbejderkontekst fra globale medarbejderregistre.",
        "title": "Deel"
      },
      "drata": {
        "bullets": [
          {
            "label": "Beskyttelsessignaler",
            "text": "{label}: Understøttede kontroller af kryptering, antivirus, firewall, opdateringer og skærmlås hjælper med at identificere svagheder."
          },
          {
            "label": "Sikkerhed i hverdagen",
            "text": "{label}: Kontroller af adgangskodeadministratorer og andre tilgængelige kontroller giver kontekst til praktiske sikkerhedsvaner."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug konkrete mangler til at afgøre, hvad der kræver medarbejdervejledning, og hvad der kræver en IT-indsats."
          },
          {
            "label": "Løbende forbedring",
            "text": "{label}: Vurder ændringer i kontrolresultater sammen med anden dokumentation om menneskelig risiko."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgt sikkerhedsdokumentation uden at ændre kontrolresultater eller enhedsindstillinger."
          }
        ],
        "description_long": "Drata indsamler dokumentation om sikkerhedskontroller på arbejdspladsen. Forbind integrationen, så Moxso kan bruge relevante kontrolmangler som kontekst for menneskelig risiko og mere målrettet opfølgning.",
        "description_short": "Brug sikkerhedskontroller af enheder og arbejdsplads til at identificere mangler i beskyttelsen.",
        "title": "Drata"
      },
      "duo": {
        "bullets": [
          {
            "label": "Reelle autentificeringssignaler",
            "text": "{label}: Vellykkede, afviste og mislykkede hændelser samt hændelser med rapporteret svindel hjælper med at identificere aktivitet, der kræver gennemgang."
          },
          {
            "label": "Nyttig kontekst",
            "text": "{label}: Tilgængelige autentificeringsfaktorer og begrundelser for resultater hjælper med at forklare, hvad der skete."
          },
          {
            "label": "Målrettet vejledning",
            "text": "{label}: Målret råd om at genkende uventede anmodninger og beskytte adgang dér, hvor relevante hændelser forekommer."
          },
          {
            "label": "Gentagen aktivitet",
            "text": "{label}: Vurder tilbagevendende afvisninger eller fejl sammen med anden dokumentation, før I beslutter jer for en handling."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser autentificeringsaktivitet og udvalgt sikkerhedsaktivitet uden at godkende anmodninger eller ændre Duo-politikker."
          }
        ],
        "description_long": "Duo hjælper med at beskytte konti med multifaktorautentificering. Forbind integrationen, så Moxso kan bruge reelle autentificeringsresultater som grundlag for opfølgning på MFA-vaner og kontosikkerhed.",
        "description_short": "Brug autentificeringsresultater som grundlag for opfølgning på MFA og kontosikkerhed.",
        "title": "Duo"
      },
      "fortinet_fortianalyzer": {
        "bullets": [
          {
            "label": "Adgangssignaler",
            "text": "{label}: Understøttede autentificeringsresultater hjælper med at identificere kontoaktivitet, der er værd at undersøge."
          },
          {
            "label": "Følsomme ændringer",
            "text": "{label}: Administrative hændelser giver yderligere dokumentation om ændringer, der påvirker jeres miljø."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevant kontoaktivitet som grundlag for undersøgelser og råd om adgangssikkerhed."
          },
          {
            "label": "Tilbagevendende mønstre",
            "text": "{label}: Vurder gentagne adgangsproblemer sammen med andre signaler, før I vælger en indsats."
          },
          {
            "label": "Dataadgang",
            "text": "{label}: Bruger logsøgningsopgaver til at læse udvalgte hændelser uden at ændre firewallkonfigurationen."
          }
        ],
        "description_long": "FortiAnalyzer indsamler sikkerhedsaktivitet fra jeres Fortinet-miljø. Forbind integrationen, så Moxso kan bruge udvalgte adgangs- og administrationshændelser som grundlag for vurderinger af menneskelig risiko.",
        "description_short": "Gennemgå autentificeringshændelser og administrative hændelser fra jeres Fortinet-miljø.",
        "title": "FortiAnalyzer"
      },
      "github_enterprise": {
        "bullets": [
          {
            "label": "Følsomme ændringer",
            "text": "{label}: Udvalgte revisionshændelser fremhæver ændringer i adgang, tilladelser og kontosikkerhed."
          },
          {
            "label": "Kodeadgangsaktivitet",
            "text": "{label}: Understøttede Git-hændelser giver yderligere dokumentation om adgang til kodearkiver."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Brug medarbejderrelaterede hændelser til at målrette råd om beskyttelse af loginoplysninger og sikker udviklingspraksis."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gentagen adgangsaktivitet og følsomme ændringer i deres arbejdsmæssige sammenhæng."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte aktivitetsmetadata uden at tilgå kildekoden i kodearkiver."
          }
        ],
        "description_long": "GitHub Enterprise beskytter adgangen til jeres kildekode og udviklingsprocesser. Forbind integrationen, så Moxso kan bruge relevant aktivitet på udviklerkonti som grundlag for menneskelig risiko og målrettet sikkerhedsopfølgning.",
        "description_short": "Brug aktivitet på udviklerkonti og adgang til kodearkiver som grundlag for sikkerhedsopfølgning.",
        "title": "GitHub Enterprise"
      },
      "google_workspace": {
        "bullets": [
          {
            "label": "Reelle aktivitetssignaler",
            "text": "{label}: Udvalgte login-, kontosikkerheds- og administratorhændelser fremhæver aktivitet, der er værd at gennemgå."
          },
          {
            "label": "Delingsrisiko",
            "text": "{label}: Understøttede downloads, ændringer i deling og hændelser om applikationsautorisation dokumenterer, hvordan oplysninger tilgås."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Målret vejledning om kontobeskyttelse, tredjepartsapps og sikker deling dér, hvor dokumentationen peger på et behov."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gentagne hændelser og ændret adgangsadfærd sammen med resultater fra bevidsthedstræning."
          },
          {
            "label": "Læseadgang",
            "text": "{label}: Læser udvalgte sikkerhedsmetadata uden at læse Gmail-beskeder eller indholdet af Drive-filer."
          }
        ],
        "description_long": "Google Workspace er stedet, hvor medarbejdere logger ind, deler filer og autoriserer applikationer. Forbind integrationen, så Moxso kan bruge sikkerhedsrelevant aktivitet som grundlag for menneskelig risiko og gøre opfølgning mere relevant for det daglige arbejde.",
        "description_short": "Gennemgå login-, delings- og applikationsadgangsaktivitet som grundlag for menneskelig risiko.",
        "title": "Google Workspace"
      },
      "gusto": {
        "bullets": [
          {
            "label": "Indsigt i roller",
            "text": "{label}: Job- og afdelingskontekst hjælper med at forklare arbejdet bag en kontos aktivitet."
          },
          {
            "label": "Ansættelsesændringer",
            "text": "{label}: Tilgængelige oplysninger om ansættelsesstatus understøtter samtaler om adgang, når forholdene ændrer sig."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Tag højde for ansvarsområder, når I vælger emner til bevidsthedstræning og praktiske sikkerhedsråd."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Brug ansættelseskontekst sammen med sikkerhedssignaler, når I beslutter, hvad der kræver opmærksomhed."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser relevante ansættelsesoplysninger uden at ændre aflønning eller køre løn."
          }
        ],
        "description_long": "Gusto vedligeholder ansættelsesoplysninger, når medarbejdere starter, skifter rolle og fratræder. Forbind integrationen, så Moxso kan inddrage denne kontekst ved vurdering af menneskelig risiko og gøre opfølgning relevant for den enkeltes ansvarsområder.",
        "description_short": "Tilføj medarbejderkontekst fra medarbejderregistre.",
        "title": "Gusto"
      },
      "hibob": {
        "bullets": [
          {
            "label": "Rollekontekst",
            "text": "{label}: Ansvarsområder og afdelinger hjælper med at sætte sikkerhedsaktivitet i perspektiv."
          },
          {
            "label": "Arbejdsmiljø",
            "text": "{label}: Tilgængelige oplysninger om arbejdssted giver kontekst til forståelsen af den enkeltes situation."
          },
          {
            "label": "Livscyklusændringer",
            "text": "{label}: Ændringer i ansættelsesstatus kan danne grundlag for samtaler om kontoadgang og sikkerhedsansvar."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug arbejdskonteksten sammen med konkret sikkerhedsdokumentation som grundlag for praktiske råd."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser relevante medarbejderoplysninger uden at ændre HR-oplysninger eller tilgå præstationsvurderinger via denne forbindelse."
          }
        ],
        "description_long": "HiBob giver kontekst om medarbejdernes roller og arbejdsmiljø. Forbind integrationen, så Moxso kan inddrage denne kontekst sammen med menneskelig risiko og gøre sikkerhedsopfølgning mere relevant for det daglige arbejde.",
        "description_short": "Tilføj kontekst om medarbejdere og jobroller fra jeres HR-system.",
        "title": "HiBob"
      },
      "hubspot": {
        "bullets": [
          {
            "label": "Loginsignaler",
            "text": "{label}: Vellykkede og mislykkede loginhændelser hjælper med at identificere problemer med kontoadgang."
          },
          {
            "label": "Følsomme handlinger",
            "text": "{label}: Udvalgte hændelser om tilladelser, loginoplysninger, integrationer og dataflytning tilføjer kontekst."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Brug medarbejderrelateret aktivitet til at målrette råd om kontosikkerhed og håndtering af kundeoplysninger."
          },
          {
            "label": "Tilbagevendende problemer",
            "text": "{label}: Vurder gentagne hændelser sammen med anden risikodokumentation, før I vælger en indsats."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgt sikkerhedsaktivitet uden at tilgå CRM-kontakter, salgsaftaler eller marketingindhold."
          }
        ],
        "description_long": "HubSpot understøtter arbejde med kundeoplysninger. Forbind integrationen, så Moxso kan bruge relevante hændelser om kontoadgang og sikkerhed som grundlag for menneskelig risiko og tilpasse opfølgning til dette arbejde.",
        "description_short": "Gennemgå login- og sikkerhedsaktivitet omkring adgang til kundeoplysninger.",
        "title": "HubSpot"
      },
      "iru": {
        "bullets": [
          {
            "label": "Beskyttelsesdækning",
            "text": "{label}: Indikatorer for administrations- og agentstatus hjælper med at identificere enheder, der kræver opmærksomhed."
          },
          {
            "label": "Enhedstilgængelighed",
            "text": "{label}: Seneste indtjekning og indikatorer for manglende enheder giver kontekst om, hvorvidt beskyttelsesoplysningerne er aktuelle."
          },
          {
            "label": "Relevant aktivitet",
            "text": "{label}: Udvalgte sikkerhedsrelaterede revisionshændelser hjælper med at forklare ændringer, der bør gennemgås."
          },
          {
            "label": "Praktisk opfølgning",
            "text": "{label}: Brug mangler i beskyttelsen som grundlag for handling sammen med medarbejdere og IT."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte oplysninger om enhedssikkerhed uden at udføre handlinger på enheder."
          }
        ],
        "description_long": "Iru hjælper organisationer med at administrere og beskytte arbejdsenheder. Forbind integrationen, så Moxso kan inddrage huller i enhedsadministrationens dækning ved vurdering af menneskelig risiko.",
        "description_short": "Identificer huller i enhedsadministrationens dækning og agentbeskyttelsen.",
        "title": "Iru"
      },
      "jamf_pro": {
        "bullets": [
          {
            "label": "Enhedsbeskyttelse",
            "text": "{label}: Understøttede oplysninger om FileVault og adgangskoder kan fremhæve sikkerhedsindstillinger, der kræver opmærksomhed."
          },
          {
            "label": "Administrationsdækning",
            "text": "{label}: Tilgængelig administrationsstatus hjælper med at fastslå, om en enhed er under organisationens kontrol."
          },
          {
            "label": "Praktisk opfølgning",
            "text": "{label}: Mangler i beskyttelsen kan danne grundlag for samtaler med medarbejdere og det IT-team, der er ansvarligt for deres enheder."
          },
          {
            "label": "Velunderbyggede vurderinger",
            "text": "{label}: Vurder enhedernes tilstand sammen med anden dokumentation frem for at betragte en fejlet kontrol som bevis på usikker adfærd."
          },
          {
            "label": "Forbindelsesstatus",
            "text": "{label}: Denne integration kan i øjeblikket ikke tilsluttes i det registrerede udbyderkatalog."
          }
        ],
        "description_long": "Tilgængelighed: Ikke tilgængelig i øjeblikket. Jamf Pro hjælper med at beskytte de Apple-enheder, medarbejdere bruger til arbejde. Oplysninger om enhedssikkerhed kan sætte menneskelig risiko i kontekst og skelne mellem mangler i beskyttelsen og problemer, der kræver medarbejdervejledning.",
        "description_short": "Administration af Apple-enheder. Denne integration er ikke tilgængelig i øjeblikket.",
        "title": "Jamf Pro"
      },
      "jumpcloud": {
        "bullets": [
          {
            "label": "Autentificeringsdokumentation",
            "text": "{label}: Udvalgte Directory Insights-hændelser viser vellykkede og mislykkede adgangsforsøg."
          },
          {
            "label": "Følsom aktivitet",
            "text": "{label}: Understøttede administrative hændelser og hændelser om privilegeret adgang fremhæver ændringer, der kræver opmærksomhed."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug kontorelateret dokumentation som grundlag for undersøgelser og vejledning om adgangssikkerhed."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Gennemgå tilbagevendende autentificeringsproblemer og følsomme ændringer sammen med andre signaler."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsoplysninger uden at ændre JumpCloud-indstillinger."
          }
        ],
        "description_long": "JumpCloud hjælper med at sikre adgang til applikationer og enheder. Forbind integrationen, så Moxso kan bruge reelle autentificerings- og administrationssignaler som grundlag for menneskelig risiko og målrette opfølgning mod relevante adgangsproblemer.",
        "description_short": "Brug autentificeringshændelser og administrative hændelser til at vurdere adgangsrisici.",
        "title": "JumpCloud"
      },
      "lattice": {
        "bullets": [
          {
            "label": "Indsigt i roller",
            "text": "{label}: Job- og afdelingskontekst hjælper med at forklare den enkeltes ansvarsområder."
          },
          {
            "label": "Kontolivscyklus",
            "text": "{label}: Tilgængelige oplysninger om kontostatus giver kontekst, når personer tilføjes til eller forlader en applikation."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Tag højde for arbejdsansvar, når I vælger sikkerhedsemner og praktiske råd."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Brug organisationskontekst sammen med sikkerhedsdokumentation, når I drøfter adgang og opfølgning."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser relevante konto- og organisationsoplysninger uden at tilgå præstationsvurderinger, feedback eller aflønning via denne forbindelse."
          }
        ],
        "description_long": "Lattice giver kontekst om roller og organisatoriske ansvarsområder. Forbind integrationen, så Moxso kan inddrage denne kontekst ved vurdering af menneskelig risiko og valg af relevant sikkerhedsopfølgning.",
        "description_short": "Tilføj kontekst om medarbejderprofiler og teamstruktur.",
        "title": "Lattice"
      },
      "linear": {
        "bullets": [
          {
            "label": "Kontoændringer",
            "text": "{label}: Understøttede revisionshændelser identificerer sikkerhedsrelevante ændringer såsom suspendering af konti."
          },
          {
            "label": "Adgangskontekst",
            "text": "{label}: Tilgængelige detaljer om aktør og handling hjælper med at forklare, hvad der skete."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevante hændelser som grundlag for gennemgang af kontoadgang og samtaler om sikkerhed."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder tilbagevendende ændringer sammen med andre sikkerhedssignaler."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte revisionsmetadata uden at tilgå sagsindhold. Revisionslogfiler kræver et Enterprise-abonnement, der understøtter dem."
          }
        ],
        "description_long": "Linear understøtter samarbejde mellem produkt- og udviklingsteams. Forbind integrationen, så Moxso kan bruge udvalgte konto- og adgangsændringer som grundlag for menneskelig risiko og hjælpe med at målrette sikkerhedsopfølgning.",
        "description_short": "Gennemgå konto- og adgangsændringer på tværs af produkt- og udviklingsteams.",
        "title": "Linear"
      },
      "microsoft_defender_xdr": {
        "bullets": [
          {
            "label": "Reelle trusselssignaler",
            "text": "{label}: Advarsler og sikkerhedshændelser identificerer aktivitet, som Microsoft vurderer som mistænkelig eller ondsindet."
          },
          {
            "label": "Eksponeringskontekst",
            "text": "{label}: Tilgængelige endpointfund og sårbarheder hjælper med at forklare omstændighederne omkring en hændelse."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Prioriter undersøgelser og relevant sikkerhedsvejledning, når fund vedrører personer eller deres arbejdsenheder."
          },
          {
            "label": "Undersøgelsens fremdrift",
            "text": "{label}: Ændringer i fundenes status hjælper med at skelne mellem aktive problemer og løste opgaver."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte fund uden at isolere enheder, lukke sikkerhedshændelser eller anvende rettelser."
          }
        ],
        "description_long": "Microsoft Defender XDR identificerer trusler på tværs af jeres Microsoft-miljø. Forbind integrationen, så Moxso kan bruge relevante advarsler og sikkerhedshændelser til at forankre vurderinger af menneskelig risiko i reelle sikkerhedshændelser.",
        "description_short": "Inddrag Microsoft-sikkerhedsadvarsler, sikkerhedshændelser og sårbarheder i risikovurderinger.",
        "title": "Microsoft Defender XDR"
      },
      "microsoft_entra": {
        "bullets": [
          {
            "label": "Reelle angrebssignaler",
            "text": "{label}: Lækkede loginoplysninger, password spraying, usædvanlige rejsemønstre og ukendte logins kan afdække konti, der kræver opmærksomhed."
          },
          {
            "label": "Kontekst for menneskelig risiko",
            "text": "{label}: Risikoniveauer og detektionsdetaljer hjælper med at sætte mistænkelig aktivitet i perspektiv."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Målret undersøgelser og vejledning om kontosikkerhed mod de personer, der er berørt af relevante hændelser."
          },
          {
            "label": "Risiko over tid",
            "text": "{label}: Ændringer fra aktiv risiko til afhjulpet eller afvist hjælper med at belyse, hvad der stadig kræver opmærksomhed."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser status for risikofyldte brugere og risikodetektioner. Signalernes detaljeringsgrad afhænger af Microsoft-licenser; premiumdetektioner kan kræve Entra ID P2."
          }
        ],
        "description_long": "Entra ID Protection markerer logins og konti, der ser ud til at være kompromitterede. Forbind integrationen, så Moxso kan bruge reelle identitetsrisikosignaler som grundlag for opfølgning baseret på, hvad der sker i jeres miljø, sammen med simulationer.",
        "description_short": "Brug risikofyldte logins og signaler om kompromitterede konti til at målrette sikkerhedsopfølgning.",
        "title": "Microsoft Entra ID Protection"
      },
      "microsoft_intune": {
        "bullets": [
          {
            "label": "Signaler om enhedssikkerhed",
            "text": "{label}: Tilgængelige compliance- og krypteringsstatusser fremhæver mangler i beskyttelsen."
          },
          {
            "label": "Relevante ændringer",
            "text": "{label}: Udvalgte administrationshændelser giver kontekst om handlinger, der påvirker enhedssikkerheden."
          },
          {
            "label": "Praktisk opfølgning",
            "text": "{label}: Hjælp med at skelne mellem et enhedsproblem, der kræver IT's opmærksomhed, og et emne, der egner sig til medarbejdervejledning."
          },
          {
            "label": "Ændret sikkerhedsniveau",
            "text": "{label}: Vurder den aktuelle beskyttelsesstatus og tilbagevendende mangler ved risikovurdering."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte enhedssikkerheds- og revisionsoplysninger uden at ændre enhedsindstillinger. Kræver den relevante Intune-adgang og -licens."
          }
        ],
        "description_long": "Microsoft Intune hjælper med at beskytte de enheder, medarbejdere bruger til arbejde. Forbind integrationen, så Moxso kan inddrage endpointsikkerhedsniveauet sammen med menneskelig risiko og understøtte praktisk opfølgning.",
        "description_short": "Gennemgå enhedscompliance og krypteringsmangler sammen med menneskelig risiko.",
        "title": "Microsoft Intune"
      },
      "microsoft_purview": {
        "bullets": [
          {
            "label": "Databeskyttelsessignaler",
            "text": "{label}: Understøttede DLP-hændelser identificerer aktivitet, der udløste en regel for datahåndtering."
          },
          {
            "label": "Yderligere risikokontekst",
            "text": "{label}: Udvalgte hændelser om insiderrisiko giver yderligere dokumentation til undersøgelser, hvor de er tilgængelige."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Brug omstændighederne ved en hændelse til at målrette råd om sikker håndtering og deling af virksomhedens oplysninger."
          },
          {
            "label": "Velunderbygget vurdering",
            "text": "{label}: Vurder gentagne signaler og deres kontekst, før I drager konklusioner om adfærd eller hensigt."
          },
          {
            "label": "Begrænset adgang",
            "text": "{label}: Læser udvalgte aktivitetsmetadata og kan initialisere de nødvendige feeds. Ændrer ikke databeskyttelsespolitikker."
          }
        ],
        "description_long": "Microsoft Purview hjælper med at identificere risikabel håndtering af følsomme oplysninger. Forbind integrationen, så Moxso kan bruge relevante databeskyttelsessignaler som grundlag for vurderinger af menneskelig risiko og mere målrettet opfølgning.",
        "description_short": "Brug databeskyttelses- og insiderrisikohændelser som grundlag for sikker informationshåndtering.",
        "title": "Microsoft Purview"
      },
      "microsoft_sentinel": {
        "bullets": [
          {
            "label": "Reelle sikkerhedshændelser",
            "text": "{label}: Alvorlighed og hændelsesdetaljer dokumenterer sikkerhedsproblemer, der allerede undersøges."
          },
          {
            "label": "Nyttig kontekst",
            "text": "{label}: Tilgængelige kilde- og angrebsoplysninger hjælper med at forklare, hvorfor en sikkerhedshændelse er vigtig."
          },
          {
            "label": "Koordineret opfølgning",
            "text": "{label}: Brug relevant dokumentation om sikkerhedshændelser til at afstemme medarbejdervejledning med sikkerhedsteamets indsats."
          },
          {
            "label": "Undersøgelsens fremdrift",
            "text": "{label}: Statusændringer hjælper med at skelne mellem nye, aktive og løste problemer."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om sikkerhedshændelser uden at ændre undersøgelser eller udføre generelle logsøgninger."
          }
        ],
        "description_long": "Microsoft Sentinel samler sikkerhedshændelser til undersøgelse. Forbind integrationen, så Moxso kan inddrage relevante sikkerhedshændelser sammen med menneskelig risiko og hjælpe med at koordinere opfølgning med jeres sikkerhedsteam.",
        "description_short": "Brug sikkerhedshændelser og undersøgelsesstatus til at koordinere opfølgning.",
        "title": "Microsoft Sentinel"
      },
      "monday": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgængelige aktive og inaktive statusser hjælper med at identificere konti, der kan kræve gennemgang."
          },
          {
            "label": "Adgangskontekst",
            "text": "{label}: Kontotyper og teamrelationer hjælper med at sætte applikationsadgang i perspektiv."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Vurder kontokontekst sammen med sikkerhedssignaler, når I beslutter, hvor der er behov for opmærksomhed."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug denne kontekst som grundlag for samtaler om kontosikkerhed og passende adgang."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om kontoadgang uden at ændre monday.com-indstillinger eller tilgå indholdet af tavler og elementer."
          }
        ],
        "description_long": "monday.com hjælper teams med at organisere arbejde og samarbejde på tværs af afdelinger. Forbind integrationen, så Moxso kan inddrage kontekst om applikationsadgang sammen med menneskelig risiko og gøre opfølgning på kontosikkerhed mere relevant.",
        "description_short": "Brug kontostatus og teamrelationer som grundlag for adgangsgennemgange.",
        "title": "monday.com"
      },
      "new_relic": {
        "bullets": [
          {
            "label": "Adgangskontekst",
            "text": "{label}: Tilgængelige kontorelationer hjælper med at sætte adgang til jeres overvågningsmiljø i perspektiv."
          },
          {
            "label": "Organisationskontekst",
            "text": "{label}: Gruppemedlemskab giver baggrund for at gennemgå, hvordan adgang er organiseret."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Vurder applikationsadgang sammen med anden dokumentation, når I beslutter, hvad der kræver opmærksomhed."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug adgangskontekst som grundlag for samtaler om kontosikkerhed med de ansvarlige teams."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om kontoadgang uden at ændre New Relic-indstillinger. Denne forbindelse indsamler ikke overvågningsadvarsler, applikationstelemetri eller revisionshændelser."
          }
        ],
        "description_long": "New Relic understøtter de teams, der er ansvarlige for at overvåge jeres systemer. Forbind integrationen, så Moxso kan inddrage kontekst om applikationsadgang sammen med menneskelig risiko og hjælpe med at målrette gennemgange af kontosikkerhed.",
        "description_short": "Tilføj kontekst om brugerkatalog og gruppemedlemskab fra New Relic.",
        "title": "New Relic"
      },
      "okta": {
        "bullets": [
          {
            "label": "Autentificeringssignaler",
            "text": "{label}: Loginresultater og udvalgte sikkerhedshændelser dokumenterer, hvordan konti bruges."
          },
          {
            "label": "Følsomme ændringer",
            "text": "{label}: Konto- og tilladelsesændringer hjælper med at identificere adgang, der bør gennemgås nærmere."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Brug relevante hændelser som grundlag for undersøgelser og praktiske råd om kontosikkerhed."
          },
          {
            "label": "Tilbagevendende problemer",
            "text": "{label}: Vurder gentagne autentificeringsproblemer sammen med anden dokumentation om menneskelig risiko."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsoplysninger uden at ændre Okta-konti eller adgangspolitikker."
          }
        ],
        "description_long": "Okta beskytter adgangen til virksomhedens applikationer. Forbind integrationen, så Moxso kan bruge autentificerings- og kontosikkerhedssignaler til at forstå reelle adgangsrisici og understøtte mere relevant opfølgning.",
        "description_short": "Gennemgå autentificerings- og kontosikkerhedshændelser for at forstå adgangsrisici.",
        "title": "Okta"
      },
      "oneleet": {
        "bullets": [
          {
            "label": "Bekræftede svagheder",
            "text": "{label}: Tilgængelige fund fra penetrationstest beskriver problemer identificeret under sikkerhedstest."
          },
          {
            "label": "Risikokontekst",
            "text": "{label}: Prioritet, berørte mål og vejledning om afhjælpning hjælper med at forklare, hvad der kræver opmærksomhed."
          },
          {
            "label": "Målrettet indsats",
            "text": "{label}: Brug relevante fund som grundlag for teknisk afhjælpning og sikkerhedssamtaler med de ansvarlige teams."
          },
          {
            "label": "Fremdrift over tid",
            "text": "{label}: Fundenes status hjælper med at skelne mellem åbne problemer og arbejde, der allerede er håndteret."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser fund uden at køre test eller ændre deres løsningsstatus."
          }
        ],
        "description_long": "Oneleet identificerer sikkerhedssvagheder gennem penetrationstest og compliancearbejde. Forbind integrationen for at føje relevante tekniske fund til den kontekst, der bruges til vurderinger af menneskelig risiko og sikkerhedsopfølgning.",
        "description_short": "Tilføj fund fra penetrationstest og kontekst om afhjælpning til sikkerhedsgennemgange.",
        "title": "Oneleet"
      },
      "onepassword": {
        "bullets": [
          {
            "label": "Loginsignaler",
            "text": "{label}: Vellykkede og mislykkede forsøg dokumenterer aktivitet vedrørende kontoadgang."
          },
          {
            "label": "Følsomme handlinger",
            "text": "{label}: Understøttede hændelser om brug af elementer og administrative hændelser giver kontekst om, hvordan adgangskodeadministratoren bruges."
          },
          {
            "label": "Målrettet opfølgning",
            "text": "{label}: Målret vejledning om sikkerhed for loginoplysninger og undersøgelser mod relevant aktivitet."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder gentagne adgangsproblemer sammen med anden dokumentation om kontosikkerhed."
          },
          {
            "label": "Intet hemmeligt indhold",
            "text": "{label}: Læser aktivitetsmetadata uden at tilgå adgangskoder, sikre noter eller dokumenter i bokse."
          }
        ],
        "description_long": "1Password hjælper medarbejdere med at beskytte og bruge deres loginoplysninger. Forbind integrationen, så Moxso kan bruge loginaktivitet og aktivitet i adgangskodeadministratoren som grundlag for menneskelig risiko uden at tilgå hemmelighederne i jeres bokse.",
        "description_short": "Gennemgå loginaktivitet og aktivitet i adgangskodeadministratoren uden at tilgå gemte hemmeligheder.",
        "title": "1Password"
      },
      "ping_one": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tilgængelig status for aktiverede konti giver kontekst til adgangsgennemgange."
          },
          {
            "label": "Adgangsrelationer",
            "text": "{label}: Gruppemedlemskab hjælper med at forklare, hvordan konti er organiseret."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Vurder adgangskontekst sammen med sikkerhedshændelser fra jeres øvrige tilsluttede værktøjer."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug den samlede dokumentation som grundlag for samtaler om kontosikkerhed og adgangsgennemgange."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om kontoadgang uden at ændre PingOne-politikker. Denne forbindelse indsamler ikke autentificeringshændelser."
          }
        ],
        "description_long": "PingOne hjælper med at administrere adgang til virksomhedens applikationer. Forbind integrationen, så Moxso kan inddrage relevant kontekst om kontoadgang sammen med menneskelig risiko og understøtte mere målrettede sikkerhedsgennemgange.",
        "description_short": "Tilføj kontekst om brugerkatalog og medlemskab fra PingOne.",
        "title": "PingOne"
      },
      "remote": {
        "bullets": [
          {
            "label": "Rollekontekst",
            "text": "{label}: Tilgængelige oplysninger om ansvarsområder og afdelinger hjælper med at sætte sikkerhedsproblemer i perspektiv."
          },
          {
            "label": "Arbejdsforhold",
            "text": "{label}: Kontekst om land og ansættelsesmodel kan hjælpe med at tilpasse råd til den enkeltes situation."
          },
          {
            "label": "Ansættelsesændringer",
            "text": "{label}: Tilgængelige livscyklusoplysninger understøtter samtaler om adgang, når arbejdsforhold ændrer sig."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Vurder medarbejderkontekst sammen med sikkerhedsdokumentation, når I vælger praktisk vejledning."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser relevante ansættelsesoplysninger uden at ændre kontrakter eller behandle løn."
          }
        ],
        "description_long": "Remote hjælper med at administrere medarbejdere på tværs af lande og ansættelsesformer. Forbind integrationen, så Moxso kan inddrage relevant arbejdskontekst ved vurdering af menneskelig risiko og planlægning af sikkerhedsopfølgning.",
        "description_short": "Tilføj medarbejderkontekst for globale og geografisk spredte teams.",
        "title": "Remote"
      },
      "rippling": {
        "bullets": [
          {
            "label": "Indsigt i roller",
            "text": "{label}: Oplysninger om job og arbejdskontekst hjælper med at forklare ansvaret bag kontoaktivitet."
          },
          {
            "label": "Ansættelseskontekst",
            "text": "{label}: Tilgængelig medarbejderstatus giver baggrund for adgangsgennemgange, når forholdene ændrer sig."
          },
          {
            "label": "Relevant vejledning",
            "text": "{label}: Tag højde for den enkeltes ansvarsområder, når I vælger sikkerhedsråd og emner til bevidsthedstræning."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Brug ansættelseskontekst sammen med sikkerhedsdokumentation som grundlag for drøftelser om adgang og opfølgning."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser relevante medarbejderoplysninger uden at ændre løn, personalegoder eller adgangsindstillinger i Rippling."
          }
        ],
        "description_long": "Rippling vedligeholder kontekst om medarbejdernes roller og ansættelse. Forbind integrationen, så Moxso kan inddrage denne kontekst sammen med menneskelig risiko og gøre sikkerhedsopfølgning relevant, når ansvarsområder ændrer sig.",
        "description_short": "Tilføj medarbejder- og personalekontekst fra Rippling.",
        "title": "Rippling"
      },
      "sentinel_one": {
        "bullets": [
          {
            "label": "Reelle trusselssignaler",
            "text": "{label}: Trusler og advarsler identificerer mistænkelig aktivitet, der påvirker arbejdsenheder."
          },
          {
            "label": "Risikokontekst",
            "text": "{label}: Tilgængelige oplysninger om alvorlighed, klassificering og sårbarheder hjælper med at forklare, hvad der kræver opmærksomhed."
          },
          {
            "label": "Målrettet indsats",
            "text": "{label}: Brug dokumentationen til at koordinere undersøgelser og afgøre, om opfølgningen hører hjemme hos IT, sikkerhedsteamet eller en medarbejder."
          },
          {
            "label": "Ændret status",
            "text": "{label}: Opdateringer af fund hjælper med at skelne mellem vedvarende problemer og aktivitet, der allerede er håndteret."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte sikkerhedsoplysninger uden at isolere enheder eller afhjælpe trusler."
          }
        ],
        "description_long": "SentinelOne registrerer og undersøger endpointtrusler. Forbind integrationen, så Moxso kan bruge relevante trusselssignaler som grundlag for menneskelig risiko og hjælpe med at målrette sikkerhedsopfølgning.",
        "description_short": "Brug endpointtrusler og sårbarhedsfund til at målrette sikkerhedsopfølgning.",
        "title": "SentinelOne"
      },
      "slack": {
        "bullets": [
          {
            "label": "Reel kontoaktivitet",
            "text": "{label}: Understøttede login- og adgangshændelser hjælper med at afdække problemer med kontosikkerhed."
          },
          {
            "label": "Delingssignaler",
            "text": "{label}: Udvalgte filrelaterede hændelser og delingshændelser giver yderligere dokumentation om, hvordan oplysninger håndteres."
          },
          {
            "label": "Målrettet vejledning",
            "text": "{label}: Målret råd om sikkert samarbejde, kontobeskyttelse og informationsdeling dér, hvor relevante hændelser forekommer."
          },
          {
            "label": "Mønstre over tid",
            "text": "{label}: Vurder tilbagevendende aktivitet sammen med resultater fra bevidsthedstræning og simulationer."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte revisionsmetadata uden at læse beskeder eller filindhold. Revisionsadgang kræver en Slack Enterprise-organisation, der understøtter det."
          }
        ],
        "description_long": "Slack er stedet, hvor medarbejdere samarbejder og deler oplysninger i løbet af dagen. Forbind integrationen, så Moxso kan bruge relevante login- og delingssignaler som grundlag for menneskelig risiko og mere praktisk opfølgning.",
        "description_short": "Brug login- og delingsaktivitet til at understøtte sikrere samarbejde i hverdagen.",
        "title": "Slack"
      },
      "splunk": {
        "bullets": [
          {
            "label": "Sikkerhedsfund",
            "text": "{label}: Udvalgte fund fremhæver aktivitet, som jeres sikkerhedsovervågning har identificeret som opmærksomhedskrævende."
          },
          {
            "label": "Kontoaktivitet",
            "text": "{label}: Understøttede autentificeringshændelser og administrative hændelser giver yderligere dokumentation til undersøgelser."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug fund, der vedrører personer eller deres konti, som grundlag for sikkerhedsindsats og råd."
          },
          {
            "label": "Ændret risiko",
            "text": "{label}: Opdateret status for fund hjælper med at sætte vedvarende problemer i kontekst."
          },
          {
            "label": "Dataadgang",
            "text": "{label}: Bruger søgninger til at læse udvalgte sikkerhedsoplysninger uden at ændre de underliggende fund."
          }
        ],
        "description_long": "Splunk samler sikkerhedsdokumentation fra hele jeres miljø. Forbind integrationen, så Moxso kan bruge udvalgte fund og kontorelaterede hændelser som grundlag for menneskelig risiko og målrettet opfølgning.",
        "description_short": "Saml sikkerhedsfund og kontoaktivitet til vurderinger af menneskelig risiko.",
        "title": "Splunk"
      },
      "statuspage": {
        "bullets": [
          {
            "label": "Driftshændelser",
            "text": "{label}: Offentliggjorte hændelsesoplysninger forklarer driftsforstyrrelser, som tjenesteejeren har rapporteret."
          },
          {
            "label": "Berørte tjenester",
            "text": "{label}: Komponentstatus hjælper med at identificere, hvilke dele af en tjeneste der er berørt."
          },
          {
            "label": "Planlagt vedligeholdelse",
            "text": "{label}: Vedligeholdelsesmeddelelser giver kontekst om forventede afbrydelser."
          },
          {
            "label": "Indsatsens fremdrift",
            "text": "{label}: Hændelsesopdateringer hjælper med at forklare, om et problem undersøges eller er blevet løst."
          },
          {
            "label": "Driftskontekst",
            "text": "{label}: En driftsforstyrrelse er ikke i sig selv bevis på en kompromitteret konto eller usikker medarbejderadfærd."
          }
        ],
        "description_long": "Redaktionel status: Udkast; omfanget af Moxso-integrationen er ikke verificeret i dette kodearkiv. Statuspage kommunikerer driftshændelser og vedligeholdelse. Oplysninger om driftsstatus kan give nyttig baggrund ved sikkerhedsopfølgning og hjælpe teams med at forstå, hvornår et adgangsproblem falder sammen med en kendt driftsforstyrrelse.",
        "description_short": "Kontekst om driftshændelser og vedligeholdelse. Integrationens omfang er endnu ikke verificeret.",
        "title": "Statuspage"
      },
      "tailscale": {
        "bullets": [
          {
            "label": "Adgangssikkerhed",
            "text": "{label}: Enhedsautorisation og status for ekstern adgang hjælper med at identificere forhold, der er værd at kontrollere."
          },
          {
            "label": "Beskyttelseskontekst",
            "text": "{label}: Oplysninger om nøgleudløb og forbindelsesstatus giver yderligere kontekst om netværksadgang."
          },
          {
            "label": "Praktisk opfølgning",
            "text": "{label}: Brug relevante adgangsproblemer som grundlag for enhedssikkerhedskontroller med det ansvarlige team."
          },
          {
            "label": "Aktuelle forhold",
            "text": "{label}: Gennemgå adgangssikkerheden, efterhånden som den ændrer sig, frem for at betragte et gammelt øjebliksbillede som permanent."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om enhedsadgang uden at ændre netværksautorisation eller opsamle trafik."
          }
        ],
        "description_long": "Tailscale forbinder enheder til jeres private netværk. Forbind integrationen for at føje netværksadgangens sikkerhedsniveau til den sikkerhedskontekst, der bruges ved vurdering af menneskelig risiko.",
        "description_short": "Gennemgå enhedsautorisation og beskyttelse af netværksadgang sammen med menneskelig risiko.",
        "title": "Tailscale"
      },
      "vanta": {
        "bullets": [
          {
            "label": "Signaler fra sikkerhedskontroller",
            "text": "{label}: Tilgængelige kontroller af kryptering, skærmlås, antivirus og adgangskodeadministrator fremhæver mangler i beskyttelsen."
          },
          {
            "label": "Tydeligere kontekst",
            "text": "{label}: Resultater fra de enkelte kontroller giver mere brugbare detaljer end én samlet compliancemærkning."
          },
          {
            "label": "Praktisk opfølgning",
            "text": "{label}: Brug relevante mangler som grundlag for handling sammen med medarbejdere og IT."
          },
          {
            "label": "Ændringer over tid",
            "text": "{label}: Vurder aktuelle kontrolresultater og tilbagevendende fejl ved risikovurdering."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgt sikkerhedsdokumentation uden at ændre complianceresultater eller enhedsindstillinger."
          }
        ],
        "description_long": "Vanta kontrollerer, om vigtige sikkerhedskontroller er på plads. Forbind integrationen, så Moxso kan inddrage relevante mangler i beskyttelsen sammen med menneskelig risiko og hjælpe med at gøre opfølgningen praktisk.",
        "description_short": "Brug krypterings-, skærmlås- og endpointkontroller til at identificere mangler i beskyttelsen.",
        "title": "Vanta"
      },
      "wiz": {
        "bullets": [
          {
            "label": "Cloudsikkerhedsfund",
            "text": "{label}: Understøttede problemer fremhæver eksponeringer, der kræver undersøgelse eller afhjælpning."
          },
          {
            "label": "Nyttig kontekst",
            "text": "{label}: Alvorlighed og oplysninger om berørte ressourcer hjælper med at forklare omstændighederne bag et fund."
          },
          {
            "label": "Målrettet indsats",
            "text": "{label}: Brug relevant eksponering som grundlag for drøftelser om ansvar og teknisk opfølgning."
          },
          {
            "label": "Ændret eksponering",
            "text": "{label}: Opdateringer af fund hjælper med at skelne mellem aktive problemer og løste opgaver."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser udvalgte cloudfund uden at ændre cloudkonfigurationen."
          }
        ],
        "description_long": "Wiz identificerer sikkerhedsrisici i cloudmiljøer. Forbind integrationen for at føje relevant cloudeksponering til den kontekst, der bruges til vurderinger af menneskelig risiko og koordineret sikkerhedsopfølgning.",
        "description_short": "Tilføj cloudsikkerhedsfund og eksponeringskontekst til jeres risikovurderinger.",
        "title": "Wiz"
      },
      "workos": {
        "bullets": [
          {
            "label": "Kontotilstand",
            "text": "{label}: Tilgængelige oplysninger om kontostatus giver kontekst til gennemgang af applikationsadgang."
          },
          {
            "label": "Adgangsrelationer",
            "text": "{label}: Organisations- og grupperelationer hjælper med at sætte kontoadgang i perspektiv."
          },
          {
            "label": "Målrettede gennemgange",
            "text": "{label}: Vurder kontokontekst sammen med sikkerhedshændelser fra andre tilsluttede værktøjer."
          },
          {
            "label": "Relevant opfølgning",
            "text": "{label}: Brug den samlede dokumentation som grundlag for adgangsgennemgange og samtaler om kontosikkerhed."
          },
          {
            "label": "Skrivebeskyttet",
            "text": "{label}: Læser oplysninger om katalogadgang uden at ændre konti. Denne forbindelse indsamler ikke loginhændelser eller sessionsaktivitet."
          }
        ],
        "description_long": "WorkOS forbinder applikationer med organisationers adgangssystemer. Forbind integrationen, så Moxso kan inddrage relevant kontekst om kontoadgang sammen med menneskelig risiko og hjælpe med at målrette sikkerhedsgennemgange.",
        "description_short": "Tilføj kontekst om katalog og organisationsmedlemskab fra WorkOS.",
        "title": "WorkOS"
      }
    },
    "human_risk_intelligence": {
      "assignment": {
        "rule_labels": {
          "cooldown_days": "Nedkølingsvindue",
          "interval_days": "Tildelingsinterval",
          "respect_mandatory_training": "Respekter obligatorisk træning"
        }
      },
      "assignment_status": {
        "awaiting_assignment": "Ikke planlagt endnu",
        "completed": "Fuldført",
        "due_soon": "Forfalder snart",
        "overdue": "Forsinket"
      },
      "intervention": {
        "notification_type": {
          "hri_employee_intervention_email": "Interventionsmail til medarbejder",
          "hri_intervention_email": "Interventionsmail til medarbejder"
        }
      },
      "onboarding": {
        "glance": {
          "notifications_behavior": {
            "continue_until_completion": "Notifikationer sendes efter deadline er overskredet, indtil fuldførelse",
            "stop_after_deadline": "Notifikationer stopper, når deadline er overskredet"
          },
          "notifications_frequency": {
            "intense": "Intens",
            "loose": "Løs",
            "normal": "Normalt"
          }
        }
      },
      "polarity": {
        "neutral": "Neutral",
        "risky": "Risikabel",
        "vigilant": "Årvågen"
      },
      "risk_level": {
        "critical": "Kritisk",
        "high": "Høj",
        "low": "Lav",
        "minimal": "Minimal",
        "moderate": "Moderat",
        "severe": "Alvorlig"
      },
      "risk_matrix": {
        "columns": {
          "somewhat_likely": "Nogenlunde sandsynlig",
          "very_likely": "Meget sandsynlig",
          "very_unlikely": "Meget usandsynlig"
        },
        "rows": {
          "high": "Høj",
          "low": "Lav",
          "medium": "Moderat"
        }
      },
      "settings": {
        "interventions": {
          "actions": {
            "assignment": "Tildel ny lektion",
            "notify_admin": "Underret administratorer",
            "notify_employee": "Underret medarbejder",
            "notify_manager": "Underret leder"
          },
          "groups": {
            "breach_exposure": {
              "description": "Reagér, når en medarbejder optræder i et kendt databrud.",
              "title": "Brudeksponering"
            },
            "critical_phishing_interactions": {
              "description": "Reagér, når en medarbejder udfører en kritisk phishing-handling, såsom at indsende loginoplysninger, åbne en vedhæftet fil eller svare.",
              "title": "Kritiske phishing-interaktioner"
            },
            "phishing_interactions": {
              "description": "Reagér, når en medarbejder klikker på et link i en e-mail- eller SMS-phishing-simulation.",
              "title": "Phishing-interaktioner"
            },
            "simulation_non_reporting": {
              "description": "Reagér, når en medarbejder ikke rapporterer en phishing-simulation inden for 2 eller 7 dage.",
              "title": "Manglende rapportering af simulation"
            },
            "training_inactivity": {
              "description": "Reagér, når en medarbejders påkrævede træning er overskredet.",
              "title": "Træningsinaktivitet"
            }
          },
          "severities": {
            "high": "Høj (60+ dage overskredet)",
            "low": "Lav (7 dage overskredet)",
            "medium": "Mellem (30 dage overskredet)"
          },
          "timeframe_options": {
            "intense": "Intens",
            "loose": "Løs",
            "normal": "Normal"
          }
        },
        "strategy": {
          "compliance": {
            "description": "Tildeler træning for at opfylde dokumenterede krav i ISO 27001, SOC 2 og relaterede compliance-rammeværk.",
            "glance": "for at opfylde organisationens compliance-krav",
            "title": "Compliance-træning"
          },
          "group": {
            "description": "Justerer træning ved hjælp af aggregerede adfærdstendenser på tværs af teams og afdelinger uden at målrette enkeltpersoner.",
            "glance": "baseret på aggregerede adfærdsmæssige risikosignaler",
            "title": "Gruppebaseret træning"
          },
          "intervention": {
            "description": "Udruller målrettede interventioner drevet af medarbejdernes adfærdssignaler. Tilbyder skræddersyet træning og korrigerende handlinger for at adressere identificerede risikomønstre og målbart reducere organisationens eksponering.",
            "title": "Interventionsstrategi"
          },
          "risk": {
            "description": "Tildeler træning baseret på jobrolle, adgangsniveau og ansvarsdrevet risiko i tråd med NIS2-forventninger.",
            "glance": "baseret på hver medarbejders rollerisikoprofil",
            "title": "Risikobaseret træning"
          }
        },
        "summary_signals": {
          "impact": {
            "high": "Høj påvirkning",
            "low": "Lav påvirkning",
            "medium": "Mellem påvirkning"
          },
          "signal_labels": {
            "failed_simulation": "Mislykket phishing-simulation",
            "low_score": "Lav træningsscore"
          }
        }
      },
      "trend": {
        "down": "Ned",
        "stable": "Stabil",
        "up": "Op"
      }
    },
    "indicators": {
      "A_10": "A.10",
      "A_11": "A.11",
      "A_13": "A.13",
      "A_14": "A.14",
      "A_15": "A.15",
      "A_16": "A.16",
      "A_17": "A.17",
      "A_19": "A.19",
      "A_21_2_A": "A.21(2)(a)",
      "A_21_2_B": "A.21(2)(b)",
      "A_21_2_C": "A.21(2)(c)",
      "A_21_2_D": "A.21(2)(d)",
      "A_21_2_F": "A.21(2)(f)",
      "A_21_2_G": "A.21(2)(g)",
      "A_21_2_I": "A.21(2)(i)",
      "A_23": "A.23",
      "A_24": "A.24",
      "A_26": "A.26",
      "A_28": "A.28",
      "A_30": "A.30",
      "A_32": "A.32",
      "A_33": "A.33",
      "A_34": "A.34",
      "A_39_1_B": "A.39(1)(b)",
      "A_4": "A.4",
      "A_5": "A.5",
      "A_5_15": "A.5.15",
      "A_5_17": "A.5.17",
      "A_5_1_C": "A.5(1)(c)",
      "A_5_1_E": "A.5(1)(e)",
      "A_5_1_F": "A.5(1)(f)",
      "A_5_23": "A.5.23",
      "A_5_24": "A.5.24",
      "A_5_25": "A.5.25",
      "A_5_26": "A.5.26",
      "A_5_27": "A.5.27",
      "A_5_28": "A.5.28",
      "A_5_31": "A.5.31",
      "A_5_34": "A.5.34",
      "A_5_7": "A.5.7",
      "A_6": "A.6",
      "A_6_3": "A.6.3",
      "A_6_7": "A.6.7",
      "A_7_1": "A.7.1",
      "A_7_2": "A.7.2",
      "A_7_3": "A.7.3",
      "A_7_4": "A.7.4",
      "A_8": "A.8",
      "A_8_1": "A.8.1",
      "A_8_2": "A.8.2",
      "A_8_23": "A.8.23",
      "A_8_5": "A.8.5",
      "A_8_7": "A.8.7",
      "A_8_9": "A.8.9",
      "A_9": "A.9",
      "CC1_1": "CC1.1",
      "CC2_1": "CC2.1",
      "CC3_2": "CC3.2",
      "CC4_1": "CC4.1",
      "CC5_2": "CC5.2",
      "CC6_1": "CC6.1",
      "CC7_2": "CC7.2",
      "CC8_1": "CC8.1",
      "CC9_2": "CC9.2",
      "C_10": "C.10",
      "C_6": "C.6",
      "C_7": "C.7",
      "C_8": "C.8",
      "C_9": "C.9",
      "administration": "Administration",
      "ai_act": "AI Act",
      "customer-support-success": "Kundesupport og kundesucces",
      "data-analytics": "Data og analyse",
      "dora": "DORA",
      "education-training": "Uddannelse og træning",
      "elevated": "Udvidet adgang",
      "engineering-development": "Engineering og udvikling",
      "executive-leadership": "Øverste ledelse",
      "facilities-services": "Faciliteter og services",
      "finance": "Finans",
      "human-resources": "HR",
      "individual_contributor": "Individuel bidragsyder",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "it-systems": "IT og systemer",
      "leadership": "Ledelse",
      "legal-compliance": "Jura og compliance",
      "management-team-leadership": "Ledelse og teamansvar",
      "managerial": "Lederansvar",
      "marketing-communications": "Marketing og kommunikation",
      "nis2": "NIS2",
      "operations": "Drift",
      "product-design": "Produkt og design",
      "project-program-management": "Projekt- og programledelse",
      "quality-process": "Kvalitet og proces",
      "research-science": "Forskning og videnskab",
      "sales": "Salg",
      "security": "Sikkerhed",
      "soc_2": "SOC 2",
      "standard": "Standardadgang",
      "supply-chain-logistics": "Forsyningskæde og logistik"
    },
    "industries": {
      "aerospace_defence": "Rumfart og forsvar",
      "automotive": "Bilindustrien",
      "banking": "Bank- og kapitalmarkeder",
      "capital_infrastructure": "Kapitalprojekter og infrastruktur",
      "consumer_markets": "Forbrugermarkeder",
      "energy_resources": "Energi og forsyningsselskaber",
      "engineering_construction": "Ejendomsudvikling og konstruktion",
      "financial_services": "Finansielle tjenester",
      "government_public": "Regering og offentlige tjenester",
      "healthcare": "Sundhedspleje",
      "hospitality_leisure": "Hotel og fritid",
      "industrial_manufacturing": "Industriel produktion",
      "insurance": "Forsikring",
      "media": "Medier",
      "paper_packaging": "Papir og emballage",
      "pharmaceuticals": "Lægemidler og biovidenskab",
      "private_equity": "Private equity",
      "technology": "Teknologi",
      "telecommunications": "Telekommunikation",
      "transportation": "Transport og logistik",
      "wealth_management": "Formueforvaltning"
    },
    "integrations": {
      "conzentrate": {
        "description": "Synkroniser træningsdata til Learning Arena",
        "title": "Learning Arena"
      },
      "csv": {
        "description": "Importer medarbejdere fra en CSV-fil",
        "title": "CSV-import"
      },
      "drata": {
        "description": "Synkroniser dokumentation for gennemført træining til Drata",
        "title": "Drata"
      },
      "google": {
        "description": "Synkroniser medarbejdere og grupper fra Google Workspace",
        "group_description": "Importer grupper fra Google Workspace",
        "title": "Google Workspace"
      },
      "google_scim": {
        "title": "Google"
      },
      "microsoft": {
        "description": "Synkroniser medarbejdere og grupper fra Microsoft Entra ID",
        "group_description": "Importer grupper fra Microsoft Entra ID",
        "title": "Microsoft Entra ID"
      },
      "microsoft_scim": {
        "title": "Microsoft Entra ID"
      },
      "microsoft_teams": {
        "description": "Send træningsnotifikationer direkte i Teams",
        "title": "Microsoft Teams"
      },
      "okta_scim": {
        "title": "Okta"
      },
      "sabacloud": {
        "description": "Synkroniser træningsdata til Saba Cloud",
        "title": "Saba Cloud"
      },
      "slack": {
        "description": "Synkroniser medarbejdere og grupper fra Slack",
        "group_description": "Importer grupper fra Slack",
        "title": "Slack"
      },
      "slack_notifications": {
        "description": "Send træningsnotifikationer direkte i Slack",
        "title": "Slack-notifikationer"
      },
      "sync_failures": {
        "default": "Synkroniseringen af denne integration mislykkedes.",
        "unauthorized": "Synkroniseringen mislykkedes. Opdater venligst autentificerings indstillingerne for denne integration."
      },
      "vanta": {
        "description": "Synkroniser dokumentation for gennemført træining til Vanta",
        "title": "Vanta"
      }
    },
    "invalid_user": "Den nuværende adgangskode er forkert.",
    "language": {
      "da_DK": "Dansk",
      "de_DE": "Tysk",
      "en_US": "Engelsk",
      "es_ES": "Spansk",
      "fi_FI": "Finsk",
      "fr_FR": "Fransk",
      "nb_NO": "Norsk (Bokmål)",
      "nl_NL": "Hollandsk",
      "pl_PL": "Polsk",
      "pt_PT": "Portugisisk",
      "sv_SE": "Svenska"
    },
    "learning_profile": {
      "data_privacy": {
        "description": "Sikring af privatliv og beskyttelse af følsomme data",
        "long": "Databeskyttelse (GDPR)",
        "short": "Databeskyttelse"
      },
      "device_security": {
        "description": "Sikkerhed for fysiske enheder og slutpunkter",
        "long": "Enhedssikkerhed",
        "short": "Enhedssikkerhed"
      },
      "digital_threats": {
        "description": "Beskyttelse mod forskellige online trusler",
        "long": "Digitale Trusler",
        "short": "Digitale Trusler"
      },
      "hybrid_work": {
        "description": "Sikkerhedsmæssige overvejelser ved fjern- og kontorarbejde",
        "long": "Hybridarbejde",
        "short": "Hybridarbejde"
      },
      "incidents_breaches": {
        "description": "Håndtering og forebyggelse af sikkerhedshændelser",
        "long": "Hændelser & Brud",
        "short": "Hændelser & Brud"
      },
      "passwords_accounts": {
        "description": "Styrke og administration af adgangskoder og konti",
        "long": "Adgangskoder & Konti",
        "short": "Adgangskoder & Konti"
      },
      "phishing": {
        "description": "Bevidsthed og forebyggelse af phishing-angreb",
        "long": "Phishing",
        "short": "Phishing"
      },
      "physical_security": {
        "description": "Beskyttelse af fysiske aktiver og områder",
        "long": "Fysisk Sikkerhed",
        "short": "Fysisk Sikkerhed"
      },
      "secure_browsing": {
        "description": "Sikre praksisser for internetbrug",
        "long": "Sikker Browsing",
        "short": "Sikker Browsing"
      }
    },
    "onboarding": {
      "data_privacy": {
        "category": "Databeskyttelse (GDPR)",
        "options": {
          "high": "Vi har klare politikker og håndhæver strenge databeskyttelsesforanstaltninger",
          "low": "Vi håndterer ikke aktivt overholdelse af persondataregler",
          "medium": "Vi indsamler data, men har ikke formelle politikker på plads"
        },
        "question": "Hvordan håndterer din virksomhed persondata i henhold til GDPR?"
      },
      "device_security": {
        "category": "Enhedssikkerhed",
        "options": {
          "high": "Enheder er centralt administreret, krypteret og overvåget",
          "low": "Medarbejdere bruger deres egne enheder uden sikkerhedspolitikker",
          "medium": "Nogle sikkerhedsforanstaltninger er på plads, men ikke konsekvent"
        },
        "question": "Hvilke sikkerhedsforanstaltninger er der for virksomhedens enheder?"
      },
      "digital_threats": {
        "category": "Digitale trusler",
        "options": {
          "high": "Vi bruger endpoint-sikkerhed, firewalls og træning af medarbejdere",
          "low": "Vi stoler på, at medarbejdere selv håndterer deres sikkerhed",
          "medium": "Nogle beskyttelser er på plads, men ikke på tværs af hele virksomheden"
        },
        "question": "Hvordan beskytter din virksomhed sig mod malware og cybertrusler?"
      },
      "hybrid_work": {
        "category": "Hybridarbejde",
        "options": {
          "high": "Medarbejdere bruger VPN, sikre Wi-Fi-netværk og godkendte enheder",
          "low": "Medarbejdere bruger personlige enheder og usikrede netværk",
          "medium": "Nogle sikkerhedsforanstaltninger opfordres der til, men de er ikke påkrævet"
        },
        "question": "Hvordan håndteres sikkerhed for fjernarbejdende medarbejdere?"
      },
      "incidents_breaches": {
        "category": "Hændelser og sikkerhedsbrud",
        "options": {
          "high": "Vi har en beredskabsplan for hændelser og tester den regelmæssigt",
          "low": "Vi håndterer hændelser reaktivt uden en formel plan",
          "medium": "Vi har en plan, men den er aldrig blevet testet"
        },
        "question": "Hvordan håndterer din virksomhed sikkerhedshændelser?"
      },
      "passwords_accounts": {
        "category": "Adgangskoder & konti",
        "options": {
          "high": "Adgangskodeadministratorer og MFA er påkrævet for alle medarbejdere",
          "low": "Medarbejdere administrerer selv deres adgangskoder uden krav",
          "medium": "MFA er valgfrit, og adgangskodepolitikker håndhæves ikke strengt"
        },
        "question": "Hvordan håndhæver din virksomhed adgangskodesikkerhed?"
      },
      "phishing": {
        "category": "Phishing",
        "options": {
          "high": "Medarbejdere gennemgår regelmæssig træning i phishing-bevidsthed",
          "low": "Der er ingen formel phishing-træning på plads",
          "medium": "Nogle træningsforløb tilbydes, men ikke regelmæssigt"
        },
        "question": "Hvordan mindsker din virksomhed risikoen for phishing?"
      },
      "physical_security": {
        "category": "Fysisk sikkerhed",
        "options": {
          "high": "Adgangskontrol, besøgslogning og sikker opbevaring er på plads",
          "low": "Der er ingen formelle fysiske sikkerhedsforanstaltninger",
          "medium": "Nogle sikkerhedsforanstaltninger eksisterer, men anvendes ikke konsekvent"
        },
        "question": "Hvordan håndteres fysisk sikkerhed på jeres kontor?"
      },
      "secure_browsing": {
        "category": "Sikker browsing",
        "options": {
          "high": "Medarbejdere bruger sikre browsere med indholdsfiltrering",
          "low": "Der er ingen restriktioner eller sikkerhedspolitikker for browsing",
          "medium": "Nogle sikkerhedsforanstaltninger er på plads, men ikke håndhævet"
        },
        "question": "Hvordan sikrer din virksomhed sikker internetbrowsing?"
      }
    },
    "organizational_role": {
      "access_level": {
        "elevated": "Udvidet adgang",
        "standard": "Standardadgang"
      },
      "responsibility_tier": {
        "individual_contributor": "Individuel bidragsyder",
        "leadership": "Ledelse",
        "managerial": "Lederansvar"
      }
    },
    "policies": {
      "audit_notifications_frequency": {
        "intense": "Høj",
        "loose": "Lav",
        "normal": "Normal"
      },
      "audit_status": {
        "canceled": "Annulleret",
        "completed": "Gennemført",
        "draft": "Inaktiv",
        "expired": "Udløbet",
        "running": "Under audit"
      }
    },
    "report": {
      "labels": {
        "assignment": "Tildeling",
        "assignment_completion": "Opgavefuldførelse",
        "click_rate": "Klikrate",
        "clicked": "Klikket",
        "company_score": "Virksomhedsscore",
        "completed": "Fuldført",
        "course": "Kursus",
        "course_completed": "Gennemførte kurser",
        "critical": "Kritisk",
        "handling_rate": "Trusselsbehandlingsrate",
        "handling_time": "Behandlingstid for trusler",
        "high": "Høj",
        "in_progress": "I gang",
        "interventions": "Indsatser",
        "low": "Lav",
        "medium": "Mellem",
        "missed_deadlines": "Overskredne deadlines",
        "negative": "Negativ",
        "neutral": "Neutral",
        "notify_admin": "Administrator underrettet",
        "notify_employee": "Medarbejder underrettet",
        "notify_manager": "Leder underrettet",
        "onboarding": "Introduktionsrate",
        "overdue": "Overskredet",
        "phishing_quizzes": "Phishingquizzer",
        "phishing_susceptibility": "Phishingmodtagelighed",
        "policy": "Politik",
        "positive": "Positiv",
        "report_rate": "Rapporteringsrate",
        "reported": "Rapporteret",
        "reporting_behavior": "Rapporteringsadfærd",
        "resilience_score": "Modstandsdygtighedsscore",
        "score": "Robusthedsscore",
        "sent": "Sendte simuleringer",
        "signals": "Signaler",
        "simulations_received": "Modtagne simuleringer",
        "team_score": "Teamscore",
        "video": "Video",
        "video_quizzes": "Videoquizzer",
        "videos_watched": "Sete videoer"
      }
    },
    "reports": {
      "frequencies": {
        "bimonthly": "Hver anden måned",
        "monthly": "Månedlig",
        "quarterly": "Kvartalvis",
        "weekly": "Ugentlig",
        "yearly": "Årlig"
      },
      "periods": {
        "prev_month": "Forrige måned",
        "prev_quarter": "Forrige kvartal",
        "prev_week": "Forrige uge",
        "prev_year": "Seneste 12 måneder",
        "ytd": "År til dato"
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "types": {
        "manager": "Manager rapport",
        "workspace": "Organisationsrapport"
      }
    },
    "risk_categories": {
      "agentic_ai": "Agentisk AI",
      "communication_security": "Kommunikationssikkerhed",
      "data_protection": "Databeskyttelse",
      "digital_exposure_risk": "Risiko for digital eksponering",
      "endpoint_device_security": "Sikkerhed for slutenheder",
      "engagement_awareness": "Engagement og opmærksomhed",
      "human_use_of_ai": "Menneskelig brug af AI",
      "identity_access_risk": "Identitets- og adgangsrisiko",
      "incident_response_readiness": "Beredskab til hændelsesrespons",
      "mobile_security": "Mobilsikkerhed",
      "physical_security": "Fysisk sikkerhed",
      "policy_regulatory_compliance": "Politik og lovgivningsmæssig overholdelse",
      "remote_work_risk": "Risiko ved fjernarbejde",
      "social_engineering_risks": "Risici ved social engineering",
      "third_party_risk": "Tredjepartsrisiko",
      "web_cloud_usage": "Brug af web og cloud"
    },
    "roles": {
      "administration": "Administration",
      "customer-support-success": "Kundesupport og kundesucces",
      "data-analytics": "Data og analyse",
      "education-training": "Uddannelse og træning",
      "engineering-development": "Teknik og udvikling",
      "executive-leadership": "Øverste ledelse",
      "facilities-services": "Faciliteter og services",
      "finance": "Finans",
      "human-resources": "HR",
      "it-systems": "IT og systemer",
      "legal-compliance": "Jura og compliance",
      "management-team-leadership": "Ledelse og teamansvar",
      "marketing-communications": "Marketing og kommunikation",
      "operations": "Drift",
      "product-design": "Produkt og design",
      "project-program-management": "Projekt- og programledelse",
      "quality-process": "Kvalitet og processer",
      "research-science": "Forskning og videnskab",
      "sales": "Salg",
      "security": "Sikkerhed",
      "supply-chain-logistics": "Forsyningskæde og logistik"
    },
    "saml": {
      "name_id_formats": {
        "emailAddress": "E-mailadresse",
        "persistent": "Persistent",
        "transient": "Transient",
        "unspecified": "Uspecificeret"
      },
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "scim": {
      "providers": {
        "auth0_scim": "Auth0",
        "google_scim": "Google",
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "services": {
      "category": {
        "authentication": "Autentificering",
        "collaboration": "Samarbejde",
        "crm": "CRM",
        "digital_signature": "Digital signatur",
        "document_management": "Dokumenthåndtering",
        "file_sharing": "Filoverførsel",
        "hrm": "HRM",
        "marketing": "Marketing",
        "other": "Andet",
        "support": "Kundesupport",
        "survey": "Spørgeskema",
        "video_conferencing": "Videokonference"
      },
      "target": {
        "all": "Alle",
        "design": "Design",
        "engineering": "Udvikler værktøjer",
        "finance": "Finance",
        "marketing": "Marketing",
        "sales": "Salg",
        "support": "Support"
      }
    },
    "signals": {
      "key": {
        "access_level": "Adgangsniveau",
        "ai_act_reference": "AI Act-reference",
        "breach_found": "Brud fundet",
        "cybersecurity_culture_initiative_participated": "Deltager i cybersikkerhedsinitiativer",
        "dora_reference": "DORA-reference",
        "email_simulation_clicked": "E-mail-simulation klikket",
        "email_simulation_credentials_submitted": "Legitimationsoplysninger indsendt i e-mail-simulation",
        "email_simulation_delivered": "E-mail-simulation leveret",
        "email_simulation_reported": "E-mail-simulation rapporteret",
        "email_simulation_reported_without_clicking": "E-mail-simulation rapporteret uden at klikke",
        "employee_imported": "Medarbejder importeret",
        "frameworks": "Rammeværk",
        "high_confidence_in_phishing_self_assessment": "Besvarede gentagne gange phishingquizzer korrekt",
        "iso27001_reference": "ISO27001-reference",
        "iso27005_reference": "ISO27005-reference",
        "legitimate_email_reported_as_phishing": "Rapporterer legitime e-mails som phishing-e-mails",
        "low_confidence_in_phishing_self_assessment": "Besvarede gentagne gange phishingquizzer forkert",
        "low_score": "Lav score",
        "missed_deadline_30_days": "Påkrævet træning 30 dage overskredet",
        "missed_deadline_60_days": "Påkrævet træning 60 dage overskredet",
        "missed_deadline_7_days": "Påkrævet træning 7 dage overskredet",
        "multiple_choice_answered_correctly": "Multiple choice-spørgsmål besvaret korrekt",
        "multiple_choice_answered_incorrectly": "Multiple choice-spørgsmål besvaret forkert",
        "nis2_reference": "NIS2-reference",
        "optional_training_engaged": "Gennemførte valgfri træning",
        "real_phishing_email_clicked": "Klikkede på en ægte phishing-e-mail",
        "real_phishing_email_opened": "Åbnede ægte phishing-e-mail",
        "real_phishing_email_opened_attachment": "Åbnede en vedhæftet fil i en ægte phishing-e-mail",
        "real_phishing_email_reported": "Rapporterede ægte phishing-e-mail",
        "real_phishing_email_targeted": "Målrettet i ægte phishing-e-mails",
        "responsibility_tier": "Ansvarsniveau",
        "risk_level": "Risikoniveau",
        "risk_themes": "Risikotemaer",
        "risk_threshold": "Risikotærskel",
        "role": "Rolle",
        "role_fallback_used": "Fallback-rolle anvendt",
        "simulation_not_reported_2_days": "Simulation ikke rapporteret efter 2 dage",
        "simulation_not_reported_7_days": "Simulation ikke rapporteret efter 7 dage",
        "sms_simulation_clicked": "SMS-simulation klikket",
        "sms_simulation_delivered": "SMS-simulation leveret",
        "sms_simulation_reported": "SMS-simulation rapporteret",
        "soc2_reference": "SOC2-reference",
        "threat_reported": "Trussel rapporteret",
        "training_completed": "Tildelt træning fuldført",
        "training_completed_after_deadline": "Fuldførelse efter deadline",
        "training_completed_on_time": "Tildelt træning fuldført til tiden",
        "training_inactivity": "Træningsinaktivitet",
        "training_video_watched": "Træningsvideo set"
      },
      "sentiment": {
        "negative": "Negativ",
        "neutral": "Neutralt",
        "positive": "Positiv"
      },
      "severity": {
        "critical": "Kritisk",
        "high": "Høj",
        "low": "Lav",
        "medium": "Mellem",
        "neutral": "Neutralt"
      }
    },
    "simulations": {
      "delivery_method": {
        "email": "Email",
        "sms": "SMS"
      },
      "delivery_rate": {
        "high": "Høj",
        "low": "Lav",
        "medium": "Medium"
      },
      "failures": {
        "failed_to_deliver": "Leveringsfejl",
        "failed_to_send": "Afsendelsesfejl",
        "invalid_receiver": "Modtagerfejl",
        "invalid_template": "Skabelonfejl",
        "no_template_available": "Skabelonfejl"
      },
      "preview": {
        "CampaignClick": "{name} trykkede på et link",
        "CampaignReport": "{name} rapporterede simulationen",
        "CampaignSent": "Simulationen blev sendt til {name}",
        "CampaignSubmission": "{name} loggede ind på en simulation",
        "activity": "Aktivitet",
        "title": "Forhåndsvisning"
      },
      "schedule_type": {
        "missing": "Ingen frekvens",
        "one_off": "Enkeltstående",
        "recurring": "Automatisk"
      },
      "status": {
        "cancelled": "Annulleret",
        "completed": "Afsluttet",
        "draft": "Kladde",
        "paused": "Pauset",
        "running": "Aktiv",
        "sending": "Sender"
      },
      "templates": {
        "editor": {
          "sidebar_blocks": {
            "button": "Knap",
            "columns": "Kolonner",
            "container": "Container",
            "divider": "Skillelinje",
            "heading1": "Overskrift 1",
            "heading2": "Overskrift 2",
            "heading3": "Overskrift 3",
            "image": "Billede",
            "spacer": "Mellemrum",
            "text": "Tekst"
          }
        }
      }
    },
    "statistics": {
      "activities_by_type": {
        "completed_courses": "Gennemførte kurser",
        "phishing_quiz_correct_answers": "Korrekte phishing-quiz svar",
        "phishing_quiz_incorrect_answers": "Forkerte phishing-quiz svar",
        "quiz_answers": "Quiz-svar",
        "quiz_correct_answers": "Korrekte quiz-svar",
        "quiz_incorrect_answers": "Forkerte quiz-svar",
        "simulations_delivered": "Simulationer leveret",
        "simulations_failed": "Mislykkede simulationer",
        "simulations_passed": "Beståede simulationer",
        "simulations_reported": "Rapporterede simulationer",
        "text": "Hvordan dine medarbejdere træner",
        "threats_reported": "Trusler rapporteret",
        "title": "Udførte aktiviteter",
        "videos_watched": "Videoer set"
      },
      "benchmarks": {
        "above_benchmark_tooltip": "Værdien er over grænseværdien.",
        "below_benchmark_tooltip": "Værdien er under grænseværdien.",
        "benchmark_tooltip": "Grænseværdi"
      },
      "breaches": {
        "critical": "Kritisk",
        "noncritical": "Ikke kritisk"
      },
      "employees": {
        "beginner": "Nybegynder",
        "expert": "Ekspert",
        "intermediate": "Øvet"
      },
      "onboarding": {
        "not_onboarded": "Ikke onboarded",
        "onboarded": "Onboarded"
      },
      "participant_partition": {
        "active": "Aktiv",
        "completed": "Afsluttet",
        "halted": "Stoppet"
      },
      "threats": {
        "status_partition": {
          "forwarded": "Videresendt",
          "fraudulent": "Bedrageri",
          "legitimate": "Legitim",
          "spam": "Spam"
        }
      },
      "time_units": {
        "days": "Dag | Dage",
        "hours": "Time | Timer",
        "minutes": "Minut | Minutter",
        "seconds": "Sekund | Sekunder",
        "weeks": "Uge | Uger"
      },
      "training": {
        "quizzing": {
          "correct": "Korrekt",
          "incorrect": "Forkert"
        }
      }
    },
    "tables": {
      "columns": {
        "actor": "Aktør",
        "app": "App",
        "automation_status": "Status",
        "available_at": "Tilgængelig",
        "breached_at": "Lækket",
        "click_rate": "@:simulations.click_rate.title",
        "completed": "Fuldført",
        "completed_at": "Fuldført",
        "content_id": "Indhold",
        "content_type": "Indholdstype",
        "created_at": "Oprettet",
        "data_class": "Dataklasse",
        "deadline_at": "Deadline",
        "delivery": "@:simulations.summary.schedule_type",
        "delivery_type": "@:tables.delivery_method",
        "employee_id": "Medarbejder",
        "employee_status": "Status",
        "event": "Hændelse",
        "group_id": "Gruppe",
        "key": "Signal",
        "last_learning_interaction": "Seneste interaktion",
        "published_at": "Udgivet",
        "report_rate": "@:simulations.report_rate.title",
        "risk_matrix": "Risikomatrix",
        "role": "Rolle",
        "sentiment": "Sentiment",
        "severity": "Alvorlighed",
        "signal_group": "Signalgruppe",
        "submission_rate": "@:simulations.submission_rate.title",
        "test": "@:simulations.summary.test",
        "translations": "Oversættelser",
        "type": "Type",
        "zone": "Zone"
      },
      "date_operators": {
        "<": "før",
        "<=": "på eller før",
        "<>": "ikke på",
        "=": "på",
        ">": "efter",
        ">=": "på eller efter"
      },
      "enum_values": {
        "access": "Adgang",
        "access_revoke": "Adgang fjernet",
        "active": "Aktiv",
        "admin": "Admin",
        "all": "Alle",
        "analyst": "Analytiker",
        "api_token_create": "API-token oprettet",
        "api_token_delete": "API-token slettet",
        "assignment": "Tildeling",
        "auth_activity": "Autentificeringsaktivitet",
        "authenticate": "Autentificering",
        "authentication_activity": "Autentificeringsaktivitet",
        "authorized_integration": "Autoriserede integration",
        "breach_config": "Brudindstillinger opdateret",
        "breach_exposure": "Brudeksponering",
        "breach_found": "Brud fundet",
        "cancelled": "@:dynamic_keys.simulations.status.cancelled",
        "change": "Ændring",
        "changed_data": "Ændrede data",
        "completed": "@:dynamic_keys.simulations.status.completed",
        "course": "Kursus",
        "course_delete": "Kursus slettet",
        "created_campaign_domain": "Oprettede kampagnedomain",
        "created_integration": "Oprettede integration",
        "created_warehouse_token": "Oprettede warehouse-token",
        "credential_update": "Legitimationsoplysninger opdateret",
        "critical": "Kritisk",
        "critical_phishing_interactions": "Indsendte phishing-loginoplysninger",
        "cybersecurity_culture_initiative_participated": "Deltager i cybersikkerhedsinitiativer",
        "data_change": "Data ændret",
        "deleted_warehouse_token": "Slettede warehouse-token",
        "domain_create": "Domæne oprettet",
        "draft": "@:dynamic_keys.simulations.status.draft",
        "email": "@:dynamic_keys.simulations.delivery_method.email",
        "email_simulation_clicked": "Klikkede på e-mailsimulering",
        "email_simulation_credentials_submitted": "Indsendte legitimationsoplysninger i e-mailsimulering",
        "email_simulation_delivered": "E-mailsimulering leveret",
        "email_simulation_reported": "E-mailsimulering rapporteret",
        "email_simulation_reported_without_clicking": "E-mailsimulering rapporteret uden at klikke",
        "employee_training_exclude": "Medarbejder ekskluderet fra træning",
        "employee_training_exclusion_expire": "Medarbejderens træningsekskludering udløbet",
        "employee_training_include": "Medarbejder inkluderet i træning",
        "high": "Høj",
        "high-somewhat_likely": "Høj effekt / Nogenlunde sandsynlig",
        "high-very_likely": "Høj effekt / Meget sandsynlig",
        "high-very_unlikely": "Høj effekt / Meget usandsynlig",
        "high_confidence_in_phishing_self_assessment": "Besvarede gentagne gange phishingquizzer korrekt",
        "hub": "Hub",
        "inactive": "Inaktiv",
        "integration_auth": "Integration autoriseret",
        "integration_config": "Integrationsindstillinger opdateret",
        "integration_create": "Integration oprettet",
        "integration_delete": "Integration slettet",
        "integration_update": "Integration opdateret",
        "intel_config": "Human risk intelligence-indstillinger opdateret",
        "invited_user": "Inviterede bruger",
        "legitimate_email_reported_as_phishing": "Rapporterer legitime e-mails som phishing-e-mails",
        "login": "Loggede ind",
        "login_verify": "Verificeret login",
        "logout": "Loggede ud",
        "low": "Lav",
        "low-somewhat_likely": "Lav effekt / Nogenlunde sandsynlig",
        "low-very_likely": "Lav effekt / Meget sandsynlig",
        "low-very_unlikely": "Lav effekt / Meget usandsynlig",
        "low_confidence_in_phishing_self_assessment": "Besvarede gentagne gange phishingquizzer forkert",
        "manage": "Administration",
        "med-somewhat_likely": "Moderat effekt / Nogenlunde sandsynlig",
        "med-very_likely": "Moderat effekt / Meget sandsynlig",
        "med-very_unlikely": "Moderat effekt / Meget usandsynlig",
        "medium": "Moderat",
        "missed_deadline_30_days": "Påkrævet træning 30 dage overskredet",
        "missed_deadline_60_days": "Påkrævet træning 60 dage overskredet",
        "missed_deadline_7_days": "Påkrævet træning 7 dage overskredet",
        "multiple_choice_answered_correctly": "Multiple choice-spørgsmål besvaret korrekt",
        "multiple_choice_answered_incorrectly": "Multiple choice-spørgsmål besvaret forkert",
        "negative": "Negative",
        "neutral": "Neutral",
        "notification": "Notifikation",
        "notify_admin": "Underret administratorer",
        "notify_employee": "Underret medarbejder",
        "notify_manager": "Underret leder",
        "one_off": "@:dynamic_keys.simulations.schedule_type.one_off",
        "optional_training_engaged": "Gennemførte valgfri træning",
        "paused": "Pauset",
        "phishing_interactions": "Phishing-interaktioner",
        "policy": "Politik",
        "positive": "Positive",
        "privacy_config": "Privatlivsindstillinger opdateret",
        "quiz": "Quiz",
        "real_phishing_email_opened": "Åbnede ægte phishing-e-mail",
        "real_phishing_email_reported": "Rapporterede ægte phishing-e-mail",
        "real_phishing_email_targeted": "Målrettet i ægte phishing-e-mails",
        "recurring": "@:dynamic_keys.simulations.schedule_type.recurring",
        "register": "Registrering",
        "removed_user_access": "Fjernede brugeradgang",
        "running": "@:dynamic_keys.simulations.status.running",
        "sending": "@:dynamic_keys.simulations.status.sending",
        "signed_in": "Loggede ind",
        "signed_out": "Loggede ud",
        "simulation_config": "Simulationsindstillinger opdateret",
        "simulation_non_reporting": "Manglende rapportering af simulation",
        "simulation_not_reported_2_days": "Simulation ikke rapporteret efter 2 dage",
        "simulation_not_reported_7_days": "Simulation ikke rapporteret efter 7 dage",
        "sms": "@:dynamic_keys.simulations.delivery_method.sms",
        "sms_simulation_clicked": "Klikkede på sms-simulering",
        "sms_simulation_delivered": "Sms-simulering leveret",
        "started": "Startet",
        "support": "Support",
        "switched_workspace": "Skiftede arbejdsområde",
        "threat_analyst": "Trusselsanalytiker",
        "threat_config": "Threat management-indstillinger opdateret",
        "threat_reported": "Trussel rapporteret",
        "training_completed": "Tildelt træning fuldført",
        "training_completed_after_deadline": "Fuldførelse efter deadline",
        "training_completed_on_time": "Tildelt træning fuldført til tiden",
        "training_config": "Træningsindstillinger opdateret",
        "training_inactivity": "Træningsinaktivitet",
        "training_video_watched": "Træningsvideo set",
        "updated_breach_settings": "Opdaterede brudindstillinger",
        "updated_gdpr_settings": "Opdaterede GDPR-indstillinger",
        "updated_human_risk_intelligence_settings": "Opdaterede human risk intelligence-indstillinger",
        "updated_integration": "Opdaterede integration",
        "updated_integration_settings": "Opdaterede integrationsindstillinger",
        "updated_integration_token": "Opdaterede integrationstoken",
        "updated_simulation_settings": "Opdaterede simulationsindstillinger",
        "updated_threat_management_settings": "Opdaterede threat management-indstillinger",
        "updated_training_settings": "Opdaterede træningsindstillinger",
        "updated_workspace_settings": "Opdaterede arbejdsområdeindstillinger",
        "user_invite": "Bruger inviteret",
        "verified_sign_in": "Verificeret login",
        "video": "Video",
        "video_delete": "Video slettet",
        "viewed_resource": "Viste ressource",
        "workspace_config": "Arbejdsområdeindstillinger opdateret",
        "workspace_switch": "Arbejdsområde skiftet"
      },
      "operators": {
        "<>": "er ikke",
        "=": "er"
      }
    },
    "threats": {
      "status": {
        "all": "Alle",
        "forwarded": "Videresendt",
        "fraudulent": "Bedrageri",
        "legitimate": "Legitime",
        "spam": "Spam",
        "unhandled": "Ubehandlet"
      }
    },
    "training": {
      "courses": {
        "video_card": {
          "types": {
            "quiz": "quiz",
            "text": "tekst",
            "video": "video"
          }
        }
      },
      "type": {
        "course-type": "Kursus",
        "policy-type": "Politik",
        "quiz-type": "Quiz",
        "video-type": "Video"
      }
    },
    "types": {
      "boolean": "Ja/Nej",
      "date": "Dato",
      "number": "Tal",
      "string": "Tekst"
    },
    "users": {
      "roles": {
        "admin": {
          "text": "Admins kan administrere indstillinger, invitere brugere og konfigurere produkter.",
          "title": "Admin"
        },
        "analyst": {
          "text": "Analytikere kan se og eksportere rapporter.",
          "title": "Analytiker"
        },
        "threat_analyst": {
          "text": "Trusselsanalytikere kan håndtere trusler og analysere data.",
          "title": "Trusselsanalytiker"
        }
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "title": "Avanceret",
          "tooltip": "Bliv en hackingekspert på ingen tid"
        },
        "ai": {
          "title": "AI og cybersikkerhed",
          "tooltip": "Udforsk den komplekse rolle, som AI spiller i cybersikkerhed"
        },
        "compliance": {
          "title": "Certificeringer og compliance",
          "tooltip": "Forstå vigtigheden af certificeringer og compliance"
        },
        "gdpr": {
          "title": "GDPR",
          "tooltip": "Lær de vigtigste krav og regler i GDPR, og hvordan du kan efterleve dem i din hverdag"
        },
        "hacking": {
          "title": "Hackernes liv",
          "tooltip": "Lær menneskerne bag cyberangrebene at kende, hackerne i verden"
        },
        "money_laundering": {
          "title": "Hvidvaskning",
          "tooltip": "Lær de forskellige metoder, som kriminelle bruger til at hvidvaske penge, og hvordan man opdager og forebygger hvidvaskning"
        },
        "phishing": {
          "title": "Phishing",
          "tooltip": "Få indsigt i alle aspekter af verdens mest udbredte cyberangreb"
        },
        "physical_security": {
          "title": "Fysisk sikkerhed",
          "tooltip": "Lær hvorfor fysisk sikkerhed er en afgørende del af god cybersikkerhed"
        },
        "tips_and_tricks": {
          "title": "Tips og tricks",
          "tooltip": "Lær hvordan du kan styrke din personlige cybersikkerhed"
        },
        "types_of_hacking": {
          "title": "Typer af hacking",
          "tooltip": "Få indsigt i de forskellige metoder, hackere bruger"
        },
        "uploads": {
          "title": "Uploads",
          "tooltip": "Se videoer, som din organisation har uploadet til jeres specifikke sikkerhedsbehov"
        }
      }
    },
    "workspace_onboarding": {
      "kick_off": {
        "validation": {
          "employee_import": "Mindst 1 AD-integration er sat korrekt op",
          "invite_admins": "Inviter administratorer",
          "reporting_add_in": "Opsæt rapporterings-add-in",
          "simulation": "Opsæt simulationer",
          "training": "Opsæt træning",
          "verify_domain": "Mindst 1 domæne er verificeret",
          "whitelisting": "Allowlisting er fuldført"
        }
      }
    }
  },
  "editor": {
    "loading": "Indlæser"
  },
  "employees": {
    "active_directory": "Active Directory",
    "add_employees": "Tilføj medarbejdere",
    "anonymous_name": "Anonym",
    "bulk_actions": {
      "activate": "Aktiver bruger | Aktiver brugere",
      "deactivate": "Deaktiver bruger | Deaktiver brugere",
      "success": "Statusser opdateret",
      "x_of_n_selected": "{x} af {n} markeret"
    },
    "current_manager": "Nuværende manager",
    "deleted_user": "Slettet bruger",
    "department": "Afdeling",
    "filter": {
      "status": {
        "active": "Kun aktive medarbejdere",
        "all": "Alle medarbejdere",
        "inactive": "Kun inaktive medarbejdere"
      }
    },
    "form": {
      "department": "Afdeling",
      "edit_title": "Indstillinger",
      "email": "E-mail",
      "first_name": "Fornavn",
      "language": "Sprog",
      "last_name": "Efternavn",
      "manager": "Manager",
      "organisational_role": "Rolle",
      "placeholder": {
        "manager": "Vælg manager",
        "role": "Vælg rolle",
        "timezone": "Vælg tidszone"
      },
      "save_settings": "Gem indstillinger",
      "scim_enabled_info": "Du kan ikke redigere medarbejderens indstillinger, fordi SCIM er aktiveret for dette workspace.",
      "timezone": "Tidszone"
    },
    "manual": "Manuel",
    "no_email_found": "Ingen email fundet",
    "preview": {
      "close_edit": "Luk redigering",
      "edit": "Rediger",
      "email": "Email",
      "groups": "Grupper",
      "locale": "Sprog",
      "manager": {
        "active_directory": "Active Directory",
        "button": "Se profil",
        "email": "Email",
        "manual": "Manuel",
        "name": "Navn",
        "source": "Kilde",
        "subtitle": "Oversigt over manageroplysninger",
        "title": "Manager"
      },
      "phone_number": "Telefonnummer",
      "profile": "Se medarbejderprofil",
      "provider": "Udbyder",
      "provider_id": "Udbyder ID",
      "source": "Kilde",
      "status": "Status",
      "tags": "Tags",
      "title": "Forhåndsvisning"
    },
    "recent_activity": "Seneste aktivitet",
    "resilience_score": {
      "text": "Individuel score for denne medarbejder baseret på simulationer og træning.",
      "title": "Modstandsdygtighed"
    },
    "search": {
      "button": "Søg",
      "empty": "Søg efter medarbejdere...",
      "no_results": "Ingen medarbejdere fundet"
    },
    "settings": {
      "settings_saved": "Indstillinger gemt",
      "status": {
        "active": {
          "description": "Denne medarbejder vil modtage simuleringer og træningsøvelser",
          "title": "Aktiv"
        },
        "inactive": {
          "description": "Denne medarbejder vil IKKE modtage simuleringer og træningsøvelser",
          "title": "Inaktiv"
        }
      }
    },
    "simulations": {
      "click_rate": {
        "title": "Klikrate",
        "tooltip": "Procentdel af simuleringer, medarbejderen har klikket på."
      },
      "email_validated": "Email valideret: {date}",
      "received": {
        "title": "Simuleringer modtaget",
        "tooltip": "Samlet antal modtagne simuleringer.",
        "unit": "Simulationer"
      },
      "report_rate": {
        "title": "Rapporteringsrate",
        "tooltip": "Procentdel af simuleringer, medarbejderen rapporteret."
      },
      "submission_rate": {
        "title": "Loginrate",
        "tooltip": "Procentdel af indsendte loginformularer.",
        "x_received": "{count} modtaget"
      }
    },
    "status": "Status",
    "training": {
      "reminder": {
        "reminder_sent": "Påmindelse afsendt",
        "subject": "Ny træningsøvelse",
        "text": "Kom i gang med din 5 minutters træning ved at gå ind på din personlige læringsportal. Ved at træne dine færdigheder inden for cybersikkerhed bliver du en vigtig del af virksomhedens cyberforsvar.",
        "title": "Hej!"
      }
    },
    "videos": {
      "title": "Videoer",
      "unit": "Videoer set"
    }
  },
  "empty": {
    "activity": {
      "title": "Ingen aktivitet"
    },
    "assigned_learning": {
      "description": "Brugeren er ikke blevet tildelt nogen træning.",
      "title": "Ingen tildelt træning"
    },
    "automations": {
      "button": "Opret en sekvens",
      "description": "Kom i gang ved at oprette en træningssekvens.",
      "title": "Ingen træningssekvenser"
    },
    "breaches": {
      "description": "Eventuelle databrud forbundet med e-mailadresser tilføjet til hubben vil være synlige her.",
      "title": "Ingen databrud"
    },
    "custom_uploads": {
      "button": "Opret video",
      "description": "Kom i gang ved at oprette en video",
      "title": "Ingen videoer fundet"
    },
    "domains": {
      "button": "Tilføj domæne",
      "description": "Kom i gang ved at tilføje et domæne.",
      "title": "Ingen domæner"
    },
    "employee_simulations": {
      "button": "Gå til simulationer",
      "description": "Kom i gang ved at tilføje en simulation.",
      "title": "Ingen simulationer"
    },
    "employees": {
      "button": "Tilføj medarbejder",
      "description_with_button": "Kom i gang ved at tilføje en medarbejder.",
      "description_without_button": "Ingen medarbejdere fundet",
      "title": "Ingen medarbejdere"
    },
    "employees_activity": {
      "description": "Der har ikke været nogen aktivitet for denne medarbejder endnu.",
      "title": "Ingen aktivitet"
    },
    "employees_group": {
      "description": "Denne gruppe har ingen tilknyttede medarbejdere.",
      "title": "Ingen medarbejdere"
    },
    "employees_training": {
      "description": "{type} ikke gennemført af nogle medarbejdere.",
      "title": "Ingen deltagere"
    },
    "generic": {
      "description": "Ingen poster fundet.",
      "title": "Ingen poster"
    },
    "groups": {
      "button": "Opret gruppe",
      "description_with_button": "Ingen grupper fundet",
      "description_without_button": "Kom i gang ved at tilføje en gruppe..",
      "title": "Ingen grupper"
    },
    "imports": {
      "description": "Der er ingen synkroniseringer for denne integration.",
      "title": "Ingen synkroniseringer"
    },
    "participants": {
      "description": "Ingen deltagere fundet.",
      "title": "Ingen deltagere"
    },
    "policies": {
      "description": "Kom i gang ved at tilføje en politik.",
      "title": "Ingen politikker"
    },
    "reports": {
      "description": "Kom i gang ved at oprette en planlagt rapport.",
      "title": "Ingen planlagte rapporter"
    },
    "scim_connections": {
      "description": "Opret en forbindelse til Microsoft Entra ID eller Okta.",
      "title": "Ingen SCIM-forbindelser"
    },
    "scim_tokens": {
      "description": "Der er ikke oprettet nogen SCIM-tokens for dette workspace.",
      "title": "Ingen SCIM-tokens"
    },
    "simulation_events": {
      "description": "Der er ingen aktiviteter til denne simulation.",
      "title": "Ingen aktivitet"
    },
    "simulations": {
      "description": "Kom i gang ved at tilføje en simulation.",
      "title": "Ingen simulationer"
    },
    "simulations_custom_templates": {
      "description": "Kom i gang ved at oprette en skabelon.",
      "title": "Ingen skabeloner"
    },
    "simulations_sequence": {
      "button": "Rediger sekvens",
      "description": "Tilføj handlinger til at opbygge automatiseringsflowet",
      "title": "Denne sekvens er tom"
    },
    "threats": {
      "attachments": "Ingen vedhæftninger fundet",
      "description": "Kom i gang ved at rapportere trusler med Moxsos email add-in",
      "title": "Ingen trusler"
    },
    "tokens": {
      "description": "Kom i gang ved at oprette en token.",
      "title": "Ingen tokens"
    },
    "training": {
      "button": "Ryd filtre",
      "description": "Der blev ikke fundet nogen undervisningsmaterialer, der matcher søgningen.",
      "title": "Ingen undervisningsmaterialer fundet"
    },
    "training_deadlines": {
      "description": "Ingen deadlines fundet.",
      "title": "Ingen deadlines"
    },
    "user_courses": {
      "description": "Der er endnu ikke tildelt nogen kurser.",
      "title": "Ingen kurser"
    },
    "users": {
      "description": "Ingen brugere blev fundet.",
      "title": "Ingen brugere"
    }
  },
  "error": {
    "button": "Tilbage til startsiden",
    "text": "Der opstod en ukendt fejl, og vi kunne ikke fuldføre din anmodning. Vi beklager ulejligheden. Prøv venligst igen senere.",
    "title": "Noget gik galt"
  },
  "forgot_password": {
    "button": "Send instruktioner",
    "heading": "Nulstil adgangskode",
    "instructions": {
      "heading": "Email sendt",
      "text": "Instruktioner er nu sendt til din email"
    },
    "text": "Indtast den e-mailadresse du benyttede, da du oprettede din konto. Vi sender herefter instruktioner til at nulstille din adgangskode"
  },
  "forms": {
    "employee": {
      "add_employees": "Tilføj medarbejdere",
      "buttons": {
        "add": "Tilføj medarbejder | Tilføj medarbejdere",
        "add_row": "Tilføj række",
        "send_reminder": "Send træningspåmindelse",
        "settings": "Indstillinger"
      },
      "delete_row": "Slet række",
      "employee_added": "Medarbejder tilføjet | Medarbejdere tilføjet",
      "import": {
        "text": "Importer medarbejdere fra en CSV-fil.",
        "title": "Importer medarbejdere"
      },
      "labels": {
        "email": "E-mail",
        "first_name": "Fornavn",
        "language": "Sprog",
        "last_name": "Efternavn",
        "phone_number": "Telefonnummer"
      },
      "manual": {
        "text": "Opret medarbejdere og deres oplysninger manuelt.",
        "title": "Opret medarbejdere manuelt"
      },
      "placeholders": {
        "email": "navn{'@'}firma.dk",
        "first_name": "Fornavn",
        "last_name": "Efternavn",
        "phone_number": "Indtast telefonnummer"
      }
    },
    "filters": {
      "all": "Alle medarbejdere",
      "completed": "Fuldført",
      "completed_default": "Alle",
      "incomplete": "Ufuldstændig",
      "only_active": "Kun aktive medarbejdere",
      "only_inactive": "Kun inaktive medarbejdere"
    },
    "group": {
      "adaptive": {
        "text": "Medlemmer tilmeldes automatisk baseret på regler.",
        "title": "Opret en adaptiv gruppe"
      },
      "add_group": "Opret gruppe",
      "buttons": {
        "add": "Opret gruppe",
        "back": "Tilbage",
        "import": "Importer grupper",
        "next": "Fortsæt",
        "save": "Gem indstillinger"
      },
      "group_added": "Gruppe tilføjet",
      "group_updated": "Gruppe opdateret",
      "import": {
        "text": "Importer grupper og medlemmer fra integration.",
        "title": "Importer grupper"
      },
      "labels": {
        "groups": "Grupper",
        "import_from_provider": "Importer fra udbyder",
        "name": "Navn",
        "provider": "Integrationsudbyder",
        "provider_id": "Integrationsudbyder gruppe ID"
      },
      "manual": {
        "text": "Medlemmer tilføjes manuelt",
        "title": "Opret gruppe manuelt"
      },
      "placeholders": {
        "name": "Gruppe navn",
        "provider": "Vælg integrationsudbyder",
        "provider_id": "ABC-123",
        "search_groups": "Søg efter gruppe"
      },
      "scim_enabled_info": "Du kan ikke redigere gruppens indstillinger, fordi SCIM er aktiveret for dette workspace."
    },
    "login": {
      "buttons": {
        "reset_password": "Nulstil adgangskode"
      },
      "labels": {
        "email": "Email",
        "password": "Adgangskode",
        "password_repeat": "Gentag adgangskode"
      },
      "placeholders": {
        "email": "navn{'@'}firma.dk"
      }
    },
    "search": "Søg"
  },
  "general": {
    "locked_feature": "Dette modul er låst"
  },
  "go_back": "Tilbage",
  "goals": {
    "actions": {
      "delete_are_you_sure": "Er du sikker på, at du vil annullere dette mål?",
      "delete_goal": "Annuller mål",
      "deleted": "Mål annulleret",
      "edit_goal": "Rediger mål",
      "edit_goal_title": "Rediger mål for {metric}",
      "new_goal": "Nyt mål for {metric}",
      "save_goal": "Gem mål",
      "target_description": "Angiv en målværdi og den dato, du vil nå den på."
    },
    "chart": {
      "lifetime": "Hele perioden",
      "recent": "Seneste"
    },
    "detail": {
      "achieved": "Opnået",
      "active_and_scheduled": "Aktive og planlagte mål",
      "actual_at_date": "Faktisk værdi på datoen",
      "in_progress": "I gang",
      "missed": "Ikke opnået",
      "no_past_goals": "Ingen tidligere mål endnu",
      "outcome": "Resultat",
      "past_goals": "Tidligere mål",
      "scheduled": "Planlagt",
      "trajectory": "Udvikling",
      "trajectory_description": "Faktisk udvikling mod hvert mål, der er sat for denne måling. Punkterne er farvekodet efter resultat — grønt for opnået, rødt for ikke opnået, blåt for i gang og gråt for planlagt."
    },
    "form": {
      "target": {
        "label": "Mål",
        "placeholder": "Mål"
      },
      "target_date": {
        "label": "Måldato",
        "placeholder": "Vælg måldato"
      }
    },
    "legend": {
      "actual": "Faktisk",
      "projected": "Forventet"
    },
    "no_data": "Ingen data",
    "overview": {
      "add_goal": "Tilføj mål",
      "current": "nuværende",
      "description": "Definér tidsbestemte mål for hver måling og skab en målbar forbedringskurve.",
      "employees_behind_tooltip": "Medarbejdere med mindst én tildeling, der er forfalden.",
      "from_now": "fra nu",
      "gap_from_previous_target": "Forskel fra forrige mål",
      "next_target": "Næste mål",
      "no_goal_description": "Denne måling følges uden et mål. Tilføj et for at måle fremskridt.",
      "no_goals": "Ingen aktive mål angivet",
      "time_elapsed": "Forløbet tid",
      "title": "Mål",
      "view": "Se"
    }
  },
  "groups": {
    "adaptive_conditions": {
      "boolean_operators": {
        "and": "og",
        "or": "eller"
      },
      "empty": "Ingen regler endnu. Tilføj en regel for at definere, hvem der tilhører denne gruppe.",
      "preview_count_label": "medarbejdere matcher kriterierne",
      "subtitle": "Medlemskab bestemmes af regler i stedet for at blive angivet manuelt.",
      "title": "Adaptiv gruppe"
    },
    "assign_manager": {
      "button": "Tildel manager",
      "description": "Tildel en manager til alle gruppemedlemmer på én gang",
      "form": {
        "overwrite_managers": {
          "help": "Hvis funktionen er slået til, vil medarbejdere der allerede har en manager, blive tildelt den valgte manager.",
          "label": "Overskriv eksisterende managere"
        },
        "select_manager": {
          "help": "Vælg en manager, der skal tildeles alle medlemmer af denne gruppe.",
          "label": "Manager",
          "placeholder": "Vælg manager"
        }
      },
      "manager_assigned": "Manager tildelt gruppemedlemmer",
      "message": "Manuel opdatering af medarbejdernes managere vil stoppe Active Directory synkroniseringen fra at opdatere dem.",
      "title": "Tildel en manager til alle medlemmer"
    },
    "assign_role": {
      "button": "Tildel rolle",
      "form": {
        "overwrite_roles": {
          "help": "Hvis funktionen er slået til, vil medarbejdere der allerede har en rolle, blive tildelt den valgte rolle.",
          "label": "Overskriv eksisterende roller"
        },
        "select_role": {
          "help": "Vælg en rolle, der skal tildeles alle medlemmer af denne gruppe.",
          "label": "Rolle",
          "placeholder": "Vælg rolle"
        }
      },
      "role_assigned": "Rolle tildelt gruppemedlemmer",
      "title": "Tildel rolle til alle medlemmer"
    },
    "assign_timezone": {
      "button": "Tildel tidszone",
      "description": "Tildel en tidszone til alle gruppemedlemmer på én gang",
      "form": {
        "overwrite_timezones": {
          "help": "Hvis funktionen er slået til, vil medarbejdere der allerede har en tidszone, blive tildelt den valgte tidszone.",
          "label": "Overskriv eksisterende tidszoner"
        },
        "select_timezone": {
          "help": "Vælg en tidszone, der skal tildeles alle medlemmer af denne gruppe.",
          "label": "Tidszone",
          "placeholder": "Vælg tidszone"
        }
      },
      "timezone_assigned": "Tidszone tildelt gruppemedlemmer",
      "title": "Tildel tidszone til alle medlemmer"
    },
    "average_resilience_score_text": "Gennemsnitlig modstandsdygtighed for medarbejdere i denne gruppe",
    "average_resilience_score_title": "Gennemsnitlig modstandsdygtighed",
    "buttons": {
      "add_rule": "Tilføj regel",
      "assign_manager": "Tildel manager",
      "assign_role": "Tildel rolle",
      "assign_timezone": "Tildel tidszone",
      "cancel": "Annuller",
      "manage_group": "Administrer medlemmer",
      "remove_managers": "Fjern managere",
      "update_group": "Opdater medlemmer"
    },
    "delete": {
      "are_you_sure": "Er du sikker på, at du vil slette denne gruppe? Denne handling kan ikke fortrydes.",
      "button": "Slet",
      "group_deleted": "Gruppen blev slettet"
    },
    "manage_members": "Rediger medlemmer",
    "members_count": "Ét medlem | {count} medlemmer",
    "membership_rules": "Medlemskabsregler",
    "provider": {
      "error": {
        "back": "Vælg en anden udbyder",
        "button": "Konfigurer integration",
        "text": "Grupper kunne ikke hentes",
        "title": "Kunne ikke kontakte integrationsudbyder"
      },
      "group_copied": "Gruppe ID kopieret",
      "heading": "Udbyder",
      "hide_id": "Skjul ID",
      "id": "ID",
      "latest_sync": "Seneste synkronisering",
      "never_synced": "Aldrig synkroniseret",
      "provider_id": "Gruppe ID",
      "refresh": "Opdater data",
      "show_id": "Vis ID",
      "sync_started": "Synkronisering tilføjet til kø",
      "synced": "Synkroniseret",
      "text": "Data synkroniseres med udbyder"
    },
    "remove_managers": {
      "button": "Fjern alle managere",
      "description": "Fjern manageren fra hvert medlem af denne gruppe.",
      "managers_removed": "Managere fjernet fra gruppemedlemmer",
      "message": "Du er ved at fjerne manageren fra alle medlemmer af denne gruppe. Er du sikker på, at du vil fortsætte? Denne handling kan ikke fortrydes.",
      "title": "Fjern alle managere"
    },
    "risk_level": {
      "calculated": "Nedarvet risikoniveau",
      "country": "Land",
      "group": "Gruppe",
      "organisation": "Organisation",
      "text": "Oversigt over risikoniveau",
      "title": "Risikoniveau"
    },
    "search": {
      "empty": {
        "title": "Ingen grupper fundet"
      }
    },
    "segment_members": "Segmenter gruppemedlemmer",
    "segmentation": "Segmentering",
    "segments": {
      "create": "Opret segment",
      "create_success": "Segment blev oprettet",
      "empty": "Ingen segmenter oprettet",
      "form": {
        "all": "Alle",
        "any": "Enhver",
        "exclude": "Ekskluder medlemmer med følgende tags:",
        "include": "Inkluder medlemmer med følgende tags:",
        "name": "Navn",
        "operator": "Operator",
        "select": "Vælg tags"
      },
      "heading": "Segmenter",
      "members_count": "Et medlem | {count} medlemmer",
      "text": "Segmentere gruppemedlemmer ud fra tags",
      "update": "Opdater segment",
      "update_success": "Segment blev opdateret"
    },
    "settings": {
      "caution": "Advarsel",
      "provider_change_warning": "{caution}: Ændring af udbyderdetaljer for denne gruppe vil udløse en ny gruppesynkronisering. Vær opmærksom på, at medarbejdere, der i øjeblikket er tildelt denne gruppe, kan blive fjernet, hvis de ikke er inkluderet i den opdaterede Active Directory-gruppe. Fortsæt med forsigtighed for at undgå utilsigtede ændringer.",
      "subtitle": "Konfigurer gruppeindstillinger",
      "title": "Gruppe indstillinger"
    },
    "sync_failed": {
      "button": "Indstillinger",
      "recommended_action": "Anbefalet handling",
      "title": "Synkronisering mislykkedes",
      "tooltip": "Synkroniseringen af denne gruppe mislykkedes."
    },
    "tags": {
      "create": "Opret tag",
      "create_success": "Tag blev oprettet",
      "delete_success": "Tag blev slettet",
      "empty": "Ingen tags oprettet",
      "heading": "Tags",
      "text": "Inddel gruppemedlemmer i tags"
    }
  },
  "human_risk_intelligence": {
    "assignment": {
      "associated_risk_categories": "Tilknyttede risikokategorier",
      "available": "Tilgængelig den",
      "completed": "Fuldført den",
      "contextual_risk_factors": "Kontekstuelle risikofaktorer",
      "deadline": "Deadline den",
      "details": "Detaljer",
      "details_title": "Tildelingsdetaljer",
      "osint": "OSINT",
      "osint_sources_summary": {
        "label": "Analyserede kilder: {count}",
        "results_count": "{count} resultat | {count} resultater"
      },
      "passed": "Bestået",
      "rules": "Regler",
      "signals": "Signaler",
      "signals_description": "Signaler, der udløste denne tildeling",
      "strategy": "Strategi",
      "title": "Tildeling"
    },
    "common": {
      "powered_by": "Drevet af {risk_framework}"
    },
    "content_preview": {
      "title": "Forhåndsvisning af indhold"
    },
    "dashboard_card": {
      "assignments_90_days": "Tildelinger",
      "enable_button": "Aktivér menneskelig risiko-intelligens",
      "interventions_90_days": "Interventioner",
      "score_90_days": "Score",
      "signals_90_days": "Signaler",
      "title": "Menneskelig risiko-intelligens"
    },
    "dashboard_signal_collection": {
      "average_day": "Gennemsnitsdag",
      "avg_daily": "Gns. dagligt",
      "last_90_days": "Seneste 90 dage",
      "less": "Mindre",
      "lowest_day": "Laveste dag",
      "more": "Mere",
      "negative": "Negative",
      "negative_count": "Negative: {count}",
      "no_signals_in_range": "Ingen signaler i dette interval",
      "peak_day": "Topdag",
      "positive": "Positive",
      "positive_count": "Positive: {count}",
      "signal_count": "1 signal | {count} signaler",
      "signal_count_on_date": "{count} den {date}",
      "signal_range": "{min}-{max} signaler",
      "signals_on_date": "Signaler den {date}",
      "title": "Signalindtag",
      "total_signals": "samlede signaler"
    },
    "employee_preview": {
      "access_level": "Adgangsniveau",
      "info": "Info",
      "organizational_role": "Organisatorisk rolle",
      "resilience_score": "Resiliensscore",
      "responsibility_tier": "Ansvarsniveau",
      "role": "Rolle",
      "title": "Medarbejder"
    },
    "filters": {
      "back": "Tilbage",
      "data": "Filtrer data",
      "filter_by": "Filtrer efter",
      "search": "Søg",
      "select_date": "Vælg dato"
    },
    "group_breakdown": {
      "columns": {
        "assignments": "Tildelinger",
        "avg_score": "Gns. score",
        "employees": "Medarbejdere",
        "group": "Gruppe",
        "interventions": "Interventioner",
        "signals": "Signaler"
      },
      "description": "Aggregerede signaler, tildelinger og interventioner efter gruppe",
      "signals_slideover": {
        "activity_links_title": "Aktivitet",
        "links_title": "Signaler",
        "member_count": "{count} medlemmer",
        "title": "Signalopdeling",
        "view_assignments": "Se tildelinger",
        "view_interventions": "Se interventioner",
        "view_signals": "Se {sentiment} signaler"
      },
      "title": "Gruppeopdeling"
    },
    "intervention": {
      "details_title": "Intervention",
      "preview_body": "I produktion indeholder denne e-mail adfærdsbaseret kontekst og vejledning til næste skridt.",
      "preview_cta": "Gennemgå venligst din sikkerhedsaktivitet og gennemfør eventuel opfølgende træning.",
      "preview_from_name": "Moxso sikkerhedsteam",
      "preview_greeting": "Hej {name},",
      "preview_intro": "Dette er en prøveforhåndsvisning af en interventionsnotifikation.",
      "preview_subject": "Sikkerhedsnotifikation",
      "sent_at": "Sendt",
      "signals_description": "Signaler, der udløste denne intervention",
      "title": "Intervention"
    },
    "navigation": {
      "assignments": "Tildelinger",
      "interventions": "Interventioner",
      "osint": "OSINT",
      "overview": "Oversigt",
      "risk_framework": "Risikorammeværk",
      "signals": "Signaler"
    },
    "notification_title": "Notifikation",
    "notification_type": "Notifikationstype",
    "onboarding": {
      "common": {
        "back": "Tilbage",
        "cancel": "Annuller",
        "next": "Næste"
      },
      "glance": {
        "assignment_limits": "Op til {max} lektioner pr. medarbejder, med mindst {cooldown} dage mellem tildelinger",
        "eligibility": "Medarbejdere er berettigede til at modtage træning {min_days} dage efter start.",
        "lesson_selection": "Lektioner tildeles automatisk {selection}",
        "notifications_disabled": "Notifikationer deaktiveret",
        "notifications_enabled": "Notifikationer aktiveret med {frequency}-frekvens. {behavior}"
      },
      "interventions": {
        "heading": "Adfærdsudløste interventioner",
        "subheading": "Definér, hvilke adfærdssignaler der udløser en øjeblikkelig reaktion uden for den normale kadence: en korrigerende træningstildeling, en notifikation til medarbejderens leder eller en advarsel til jeres sikkerhedsadministratorer."
      },
      "intro": {
        "benefits": {
          "better_outcomes": {
            "description": "Fokuser ressourcer der hvor de betyder mest",
            "title": "Bedre resultater"
          },
          "continuous_adaptation": {
            "description": "Systemet lærer og justerer baseret på løbende adfærd",
            "title": "Kontinuerlig tilpasning"
          },
          "personalized_experience": {
            "description": "Hver medarbejder får træning tilpasset deres behov",
            "title": "Personlig oplevelse"
          }
        },
        "description": "Human Risk Intelligence omsætter adfærdssignaler til individuelle risikoprofiler og tildeler derefter den træning og de simulationer, hver medarbejder faktisk har brug for. Indholdet kalibreres efter, hvor den enkelte ligger i Moxso Risk Framework, og genkalibreres efterhånden som nye signaler kommer ind. Risikoen falder uden at øge træningsmængden.",
        "heading": "Hvad er Human Risk Intelligence?",
        "setup_button": "Opsæt Human Risk Intelligence",
        "subheading": "Træn hver medarbejder i de risici, der faktisk gælder for dem, og stop med at træne dem i dem, der ikke gør."
      },
      "review": {
        "at_a_glance": "Kort overblik",
        "enable_button": "Aktivér Human Risk Intelligence",
        "heading": "Klar til at aktivere",
        "next": {
          "heading": "Hvad sker der nu",
          "items": {
            "analysis_starts_immediately": "Moxso begynder straks at indsamle adfærdssignaler på tværs af din organisation.",
            "no_lessons_assigned_immediately_prefix": "Træning leveres efter 24 timer.",
            "no_lessons_assigned_immediately_suffix": "På det tidspunkt har systemet lært nok til at opbygge en pålidelig risikoprofil for hver medarbejder.",
            "settings_can_be_changed_anytime": "Disse indstillinger kan ændres, eller Human Risk Intelligence kan deaktiveres, når som helst."
          }
        },
        "settings_link": "Har du brug for mere kontrol? Tilpas avancerede indstillinger",
        "subheading": "Her er hvad der sker, når du aktiverer Human Risk Intelligence."
      },
      "selection": {
        "heading": "Træningsstrategi",
        "subheading": "Vælg hvordan Moxso prioriterer og tildeler løbende træning på tværs af din organisation."
      },
      "signals": {
        "heading": "Signaler",
        "subheading": "Konfigurer hvordan signaler påvirker beslutninger i menneskelig risiko-intelligens"
      },
      "steps": {
        "interventions": "Interventioner",
        "introduction": "Introduktion",
        "review": "Gennemgå og aktivér",
        "training_strategy": "Træningsstrategi"
      }
    },
    "osint_explanation": {
      "description": "Moxso OSINT-motoren overvåger løbende det globale trusselslandskab og omsætter offentlig cybersikkerhedsintelligens til handlingsorienteret indsigt i menneskelig risiko.",
      "title": "Moxso OSINT-motoren (Open-Source Intelligence)"
    },
    "osint_news": {
      "empty": {
        "description": "Ingen OSINT-data fundet for denne risiko",
        "heading": "OSINT-data utilgængelige"
      },
      "title": "Trusselsefterretningsfeed"
    },
    "pages": {
      "assignments": {
        "heading": "Adaptive tildelinger",
        "subheading": "Se og administrer tildelinger i menneskelig risiko-intelligens."
      },
      "interventions": {
        "heading": "Interventioner",
        "subheading": "Interventioner udløst af medarbejderadfærd på tværs af sikkerhedsaktiviteter."
      },
      "osint": {
        "article": {
          "associated_risk_indicators": "Tilknyttede risikoindikatorer",
          "hide": "Skjul",
          "indicator_count": "{count} indikator | {count} indikatorer",
          "neutral_count": "{count} neutral | {count} neutrale",
          "risky_count": "{count} risikabel | {count} risikable",
          "show": "Vis",
          "vigilant_count": "{count} årvågen | {count} årvågne"
        },
        "breaches": "Brud",
        "current": "Nuværende",
        "heading": "Trusselsintelligens-feed",
        "indicators": {
          "description": "Top de seneste 24 timer",
          "empty": {
            "description": "Indikatoraktivitet vises her, når feedet har taggede risici.",
            "heading": "Ingen indikatorer endnu"
          },
          "title": "Risikoindikatorer"
        },
        "negative_neutral": "Kræver opmærksomhed: Signalaktiviteten forværres",
        "negative_risky": "Advarsel: Trusselsaktiviteten stiger",
        "negative_vigilant": "Kræver opmærksomhed: Sikkerhedsforanstaltningerne falder",
        "news": {
          "description": "Seneste 24 timer",
          "title": "Nyheder"
        },
        "no_change": "Ingen ændring i signalaktivitet",
        "positive_neutral": "Positiv trend: Signalaktiviteten forbedres",
        "positive_risky": "Positiv trend: Trusselsaktiviteten falder",
        "positive_vigilant": "Positiv trend: Sikkerhedsniveauet forbedres",
        "previous": "Forrige",
        "risk_themes": "Risikotemaer",
        "signal_change": "Signalændring",
        "sources": {
          "description": "Aktive kilder de seneste 24 timer",
          "empty": {
            "description": "Kildeaktivitet vises her, når feedet har artikler.",
            "heading": "Ingen kilder endnu"
          },
          "title": "Kilder"
        },
        "subheading": "Følg eksterne signaler knyttet til dine overvågede risikotemaer."
      },
      "overview": {
        "subheading": "Oversigt over aktivitet og indsigter i menneskelig risiko-intelligens."
      },
      "risk_framework": {
        "heading": "Risikorammeværk",
        "subheading": "Moxso-rammeværket til vurdering og håndtering af menneskelig sikkerhedsrisiko."
      },
      "signals": {
        "heading": "Adfærdssignaler",
        "subheading": "Se alle signaler indsamlet fra medarbejderadfærd."
      }
    },
    "risk_category": {
      "change": "Ændring",
      "consequences": "Konsekvenser",
      "details_title": "Detaljer for risikokategori",
      "importance": "Vigtighed",
      "indicators": "Indikatorer",
      "overview_title": "Oversigt over risikokategori",
      "relevance": "Relevans",
      "tabs": {
        "details": "Detaljer",
        "indicators": "Indikatorer"
      }
    },
    "risk_framework": {
      "change_tooltip": "Ændring i de seneste 90 dage",
      "description_1": "Moxso-risikorammeværket er en datadrevet model til at identificere, kvantificere og operationalisere menneskelig cyberrisiko i moderne virksomheder.",
      "description_2": "Det er tilpasset branchestandarder som MITRE ATT&CK og NIST Cybersecurity Framework og udvider traditionelle kontrolbaserede modeller ved specifikt at fokusere på menneskelig adfærd som angrebsvektor. Rammeværket omsætter adfærdsdata fra den virkelige verden, signaler om trusseleksponering og strukturelle risikofaktorer til målbare og reviderbare risikoindikatorer.",
      "description_3": "Organiseret på tværs af og struktureret i 16 menneskecentrerede risikokategorier (R.01-R.16) leverer rammeværket ensartet scoring, handlingsorienteret indsigt og compliance-tilpasset rapportering.",
      "references": "Rammeværksreferencer",
      "short_description": "Moxso-risikorammeværket er en datadrevet model til at identificere, kvantificere og operationalisere menneskelig cyberrisiko i moderne virksomheder.",
      "title": "Risikorammeværk"
    },
    "risk_matrix": {
      "axes": {
        "impact": "Påvirkning",
        "likelihood": "Sandsynlighed"
      },
      "legend": {
        "high": "Høj",
        "low": "Lav",
        "med": "Mellem"
      },
      "title": "Signalrisikomatrix",
      "tooltip": {
        "change": "Ændring",
        "current": "Nuværende",
        "high": "Høje risikosignaler",
        "low": "Lave risikosignaler",
        "medium": "Mellemhøje risikosignaler",
        "previous": "Forrige"
      }
    },
    "sections": {
      "recent_assignments": "Seneste tildelinger",
      "recent_interventions": "Seneste interventioner",
      "recent_signals": "Seneste signaler"
    },
    "settings": {
      "common": {
        "days": "{days} dage",
        "disabled": "Deaktiveret",
        "enabled": "Aktiveret",
        "every_days": "Hver {days}. dag",
        "no": "Nej",
        "none": "Ingen",
        "yes": "Ja"
      },
      "eligibility": {
        "criteria_title": "Berettigelseskriterier",
        "description": "Definér hvem der er berettiget til menneskelig risiko-intelligens",
        "excluded_groups": "Udelukkede grupper",
        "excluded_groups_help": "Ekskluder specifikke grupper fra automatiserede træningsforløb",
        "excluded_roles": "Udelukkede roller",
        "excluded_roles_help": "Ekskluder specifikke organisatoriske roller fra automatiserede træningsforløb",
        "minimum_employment_duration_help": "Medarbejdere skal have været ansat i mindst så mange dage for at være berettigede",
        "minimum_employment_duration_label": "Minimum ansættelsesvarighed (dage)",
        "targeting_title": "Målretning",
        "title": "Berettigelse"
      },
      "interventions": {
        "actions": {
          "add_action": "Tilføj handling",
          "assign_new_lesson": "Tildel ny lektion",
          "assignment_description": "Tildel korrigerende træning til den berørte medarbejder.",
          "empty": "Ingen handlinger endnu. Tilføj en for at definere, hvad der skal ske, når denne gruppe udløses.",
          "heading": "Handlinger ved udløsning",
          "notify_admin": "Underret administratorer",
          "notify_admin_description": "Send e-mail til en kvalificeret Moxso-workspaceadministrator.",
          "notify_employee": "Underret medarbejder",
          "notify_employee_description": "Send e-mail til den berørte medarbejder om den registrerede adfærd.",
          "notify_manager": "Underret leder",
          "notify_manager_description": "Send e-mail til medarbejderens aktive leder.",
          "remove_action": "Fjern {action}"
        },
        "enable_subtitle": "Lad menneskelig risiko-intelligens bryde normale tildelingsregler, når adfærd med høj risiko opdages, og eskalere til ledere og sikkerhedsadministratorer.",
        "enable_title": "Aktivér interventioner",
        "excluded_groups": "Udelukkede grupper",
        "excluded_groups_help": "Medarbejdere i disse grupper målrettes aldrig af interventionstilsidesættelser.",
        "excluded_roles": "Udelukkede roller",
        "excluded_roles_description": "Medarbejdere i disse roller målrettes aldrig af interventionstilsidesættelser.",
        "groups_description": "Vælg hvilke signalgrupper der skal overvåges, og konfigurer reaktionen for hver gruppe.",
        "groups_title": "Interventionssignalgrupper",
        "severity_label": "Overskridelsesgrad",
        "threshold_label": "Aktiveringstærskel",
        "threshold_occurrences": "{count} hændelse | {count} hændelser",
        "timeframe_days": "Hver {days}. dag",
        "timeframe_label": "Tidsperiode",
        "timeframe_within_90_days": "Inden for 90 dage",
        "triggers": {
          "breach_exposure": {
            "description": "Tillad øjeblikkelig tildeling når en medarbejder optræder i et kendt brud.",
            "title": "Brudeksponering"
          },
          "phishing_failures": {
            "description": "Tillad øjeblikkelig tildeling efter at medarbejdere fejler en simulation.",
            "title": "Fejl i phishing-simulationer"
          },
          "training_non_compliance": {
            "description": "Tillad øjeblikkelig tildeling når påkrævet træning er forsinket.",
            "title": "Manglende overholdelse af træning"
          }
        },
        "triggers_description": "Vælg hvilke hændelser der kan udløse øjeblikkelig træning og eskalering til ledere eller sikkerhedsadministratorer, selv hvis en medarbejder for nylig modtog anden træning.",
        "triggers_title": "Interventionsudløsere"
      },
      "notifications": {
        "continuous_sending_subtitle": "Send påmindelsesnotifikationer indtil fuldførelse",
        "continuous_sending_title": "Kontinuerlig udsendelse",
        "enable_subtitle": "Send e-mailnotifikationer for nye tildelinger",
        "enable_title": "Aktivér notifikationer",
        "frequency": {
          "intense": "Intens",
          "loose": "Løs",
          "normal": "Normal (pr. tildeling)",
          "per_assignment": "Pr. tildeling"
        },
        "frequency_label": "Notifikationsfrekvens",
        "title": "Notifikationer"
      },
      "review": {
        "enable_subtitle": "Start personlige træningstildelinger baseret på medarbejderadfærd",
        "enable_title": "Aktivér menneskelig risiko-intelligens",
        "frequency": "Frekvens",
        "max_assignments_per_run": "Maks. tildelinger pr. kørsel: {value}",
        "notifications": "Notifikationer",
        "reminders_until_completion": "Påmindelser indtil fuldførelse",
        "save_settings": "Gem indstillinger",
        "selection": "Udvælgelse",
        "title": "Gennemgå og aktivér"
      },
      "selection_strategy": {
        "avoid_repetition_help": "Gentildel ikke den samme lektion i denne periode.",
        "avoid_repetition_label": "Undgå at gentage den samme træning (dage)",
        "cooldown_help": "Vent før ny menneskelig risiko-intelligens tildeles efter enhver træning.",
        "cooldown_label": "Nedkølingsperiode (dage)",
        "enable_subtitle": "Lad Human Risk Intelligence tildele løbende træning baseret på medarbejdernes risikoprofiler.",
        "enable_title": "Aktivér Human Risk Intelligence",
        "excluded_videos": "Udelukkede videoer",
        "excluded_videos_description": "Disse videoer tildeles aldrig af Human Risk Intelligence.",
        "excluded_videos_placeholder": "Vælg videoer",
        "frameworks_help": "Vælg et eller flere rammeværk for at prioritere træning, der matcher dine compliance-mål.",
        "frameworks_label": "Rammeværker",
        "frameworks_placeholder": "Vælg rammeværker",
        "hide_advanced_settings": "Skjul avancerede indstillinger",
        "interval_help": "Minimum antal dage mellem gennemførte træninger og nye tildelinger.",
        "interval_label": "Interval (dage)",
        "label": "Udvælgelsesstrategi",
        "max_assignments_per_run_help": "Maksimalt antal nye træninger pr. medarbejder i én evaluering.",
        "max_assignments_per_run_label": "Maks. tildelinger pr. kørsel",
        "show_advanced_settings": "Vis avancerede indstillinger"
      },
      "signals": {
        "failed_simulation": "Mislykket simulation",
        "failed_simulation_help": "Vægt anvendt når en medarbejder klikker på en phishing-simulation",
        "low_score": "Lav score",
        "low_score_help": "Vægt anvendt når quizscorer i træning er under tærsklen"
      },
      "summary_eligibility": {
        "description": "Bestemmer hvem der er berettiget til menneskelig risiko-intelligens",
        "excluded_roles": "Udelukkede roller",
        "minimum_employment_duration": "Minimum ansættelsesvarighed",
        "title": "Berettigelse"
      },
      "summary_selection": {
        "description": "Bestemmer hvordan lektioner vælges, og hvordan medarbejdere notificeres",
        "email_notifications": "E-mailnotifikationer",
        "lesson_selection": "Lektionsudvælgelse",
        "maximum_lessons_per_employee": "Maksimalt antal lektioner pr. medarbejder",
        "minimum_time_between_lessons": "Minimum tid mellem lektioner",
        "notification_settings": "Notifikationsindstillinger",
        "notification_style": "Notifikationsstil",
        "prioritize_mandatory_training": "Prioritér obligatorisk træning",
        "selection_approach": "Udvælgelsesmetode",
        "send_reminders_until_complete": "Send påmindelser indtil fuldført",
        "standard_training_interval": "Standard træningsinterval",
        "title": "Udvælgelser og notifikationer"
      },
      "summary_signals": {
        "description": "Bestemmer hvordan signaler påvirker beslutninger i menneskelig risiko-intelligens",
        "impact": {
          "high": "Høj påvirkning",
          "low": "Lav påvirkning",
          "medium": "Mellem påvirkning"
        },
        "signal_labels": {
          "failed_simulation": "Mislykket phishing-simulation",
          "low_score": "Lav træningsscore"
        },
        "title": "Signaler"
      }
    },
    "signal": {
      "associated_risk_categories": "Tilknyttede risikokategorier",
      "behaviour": "Adfærd",
      "category": "Kategori",
      "indicator": "Indikator",
      "intel": "Efterretning",
      "no": "Nej",
      "polarity": "Polaritet",
      "sentiment": "Stemning",
      "title": "Risikosignal",
      "value": "Værdi",
      "yes": "Ja"
    },
    "signal_preview": {
      "breach": {
        "title": "Dark web-overvågning"
      },
      "multiple_choice_quiz_answer": {
        "answer": "Svar",
        "question": "Spørgsmål",
        "title": "Quizsvar"
      },
      "phishing_quiz_answer": {
        "correct": "Korrekt",
        "incorrect": "Forkert",
        "question": "Spørgsmål",
        "result": "Resultat",
        "subject": "Emne",
        "time": "Tid",
        "title": "Svar på phishingquiz"
      }
    },
    "stats": {
      "assignments": "Tildelinger",
      "completed_assignments": "Fuldførte tildelinger",
      "interventions": "Interventioner",
      "negative_signals": "Negative signaler",
      "positive_signals": "Positive signaler",
      "risk_level": {
        "country_risk": "Landerisiko",
        "industry_risk": "Brancherisiko",
        "levels": {
          "high": "Høj",
          "loading": "Indlæser",
          "low": "Lav",
          "medium": "Moderat"
        },
        "title": "Risikoniveau"
      },
      "signals": "Signaler"
    },
    "tables": {
      "negative": "Negativ",
      "neutral": "Neutralt",
      "sentiment": "Stemning",
      "severity": "Alvorlighed",
      "signal_count": "1 signal | {count} signaler",
      "signal_type": "Risikosignal"
    },
    "title": "Human Risk Intelligence",
    "tooltips": {
      "compared_to_prior_period": "Sammenlignet med den forrige periode af samme længde.",
      "previous_value": "Forrige værdi"
    },
    "trending_risk_indicators": "Trendende risikoindikatorer"
  },
  "image_library": {
    "empty_button": "Upload billede",
    "empty_description": "Upload dit første billede for at begynde at opbygge et genanvendeligt bibliotek.",
    "empty_title": "Ingen billeder endnu",
    "image_format": "JPG/JPEG/PNG · Op til 1MB",
    "image_uploaded": "Billede uploadet",
    "insert_button": "Indsæt billede",
    "library_tab": "Billedbibliotek",
    "refresh": "Opdater",
    "show_more": "Vis mere",
    "title": "Indsæt billede",
    "upload_tab": "Upload",
    "upload_title": "Upload et nyt billede"
  },
  "locale": {
    "current": "Dansk",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "french": "Français",
    "norwegian": "Norwegian",
    "polish": "Polski",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "back_to_login": "Tilbage til login",
    "button": "Log ind",
    "change_email": "Skift e-mail?",
    "continue": "Fortsæt",
    "forgot_password": {
      "link": "Nulstil det her",
      "text": "Glemt adgangskode?"
    },
    "heading": "Velkommen tilbage",
    "loading": "Indlæser",
    "preparing_session": "Forbereder session",
    "sso": {
      "provider_found": "SSO er tilgængeligt for {provider}. Fortsæt for at logge ind via din identitetsudbyder.",
      "redirecting": "Viderestiller til SSO",
      "redirecting_text": "Vi forbereder din loginanmodning.",
      "validating": "Validerer SSO",
      "validating_text": "Vi færdiggør dit login."
    },
    "text": "Log ind på din konto"
  },
  "manager_report": {
    "assignment": "Opgave",
    "assignments": "Opgaver",
    "company_average": "Virksomhedsgennemsnit",
    "compared_against": "Sammenlignet med {period}",
    "completed": "Fuldført",
    "date": "Dato",
    "days_overdue": "Dage forsinket",
    "deadline": "Deadline",
    "deadlines_description": "{count} opgaver overskred deres deadline i perioden {period}.",
    "department": "Afdeling",
    "employee": "Medarbejder",
    "employees_affected": "Berørte medarbejdere",
    "employees_at_risk": "Medarbejdere i risiko",
    "gap_to_company": "Forskel til virksomheden",
    "generated": "Genereret {date}",
    "human_risk_intelligence": "Human Risk Intelligence",
    "individual_reports": "Individuelle trænings- og risikorapporter · {count} medarbejdere | Individuel trænings- og risikorapport · {count} medarbejder | Individuelle trænings- og risikorapporter · {count} medarbejdere",
    "interventions": "Seneste interventioner udløst af Moxso",
    "loading": "Indlæser ledelsesrapport…",
    "missed_deadlines": "Overskredne deadlines",
    "missed_team_deadlines": "Teamets overskredne deadlines",
    "most_dangerous_signals": "Periodens 3 farligste signaler",
    "no_assignments": "Ingen opgaver",
    "no_dangerous_signals": "Ingen farlige signaler",
    "no_employees_at_risk": "Ingen medarbejdere i risiko",
    "no_interventions": "Ingen interventioner udløst",
    "no_missed_deadlines": "Ingen overskredne deadlines",
    "no_recent_signals": "Ingen nye signaler",
    "no_sentiment_data": "Ingen sentimentdata",
    "no_severity_data": "Ingen data om alvorlighed",
    "oldest_deadline": "Ældste deadline",
    "overdue_assignments": "Forsinkede opgaver",
    "period_over_period": "Sammenlignet med perioden før",
    "points": "{points} point",
    "recent_signals": "Seneste signaler",
    "risk_indicator": "Risikoindikator",
    "score": "Score",
    "sentiment": "Sentiment",
    "severity": "Alvorlighed",
    "signal": "Signal",
    "signals": "Signaler",
    "signals_by_sentiment": "Signaler efter sentiment",
    "signals_by_severity": "Signaler efter alvorlighed",
    "sorted_by_deadline": "Sorteret efter deadline",
    "status": "Status",
    "summary": "Opsummering",
    "team_average": "Teamgennemsnit",
    "threshold": "Grænse {value}% · laveste først",
    "title": "Ledelsesrapport",
    "total": "{count} i alt",
    "training_report": "Træningsrapport",
    "trend_title": "Modstandsdygtighed, klik- og rapporteringsrate",
    "type": "Type",
    "unavailable": "Rapporten er ikke tilgængelig",
    "unavailable_description": "Rapporten kunne ikke indlæses. Kontrollér, at rapportlinket er gyldigt og ikke udløbet."
  },
  "navigation": {
    "assigned_learning": "Tildelt læring",
    "at_risk": "Udsatte medarbejdere",
    "audit": {
      "index": "Audit",
      "settings": "Indstillinger"
    },
    "automation": {
      "flow_builder": "Forløbsopbygning",
      "index": "Automatisering",
      "sequence": "Sekvens",
      "settings": "Indstillinger"
    },
    "breaches": "Databrud",
    "configuration": "Konfiguration",
    "custom_upload": {
      "edit": "Rediger",
      "quiz": "Quiz"
    },
    "dashboard": "Overblik",
    "employees": "Medarbejdere",
    "goals": "Mål",
    "groups": {
      "index": "Grupper",
      "settings": "Indstillinger",
      "single": "Gruppe"
    },
    "human_risk_intelligence": "Menneskelig risiko-intelligens",
    "integration": {
      "activity": "Aktivitet",
      "settings": "Indstillinger"
    },
    "integrations": "Integrationer",
    "knowledge_base": "Vidensbase",
    "lessons_courses": "Kurser",
    "lessons_deadlines": "Deadlines",
    "lessons_videos": "Videoer",
    "no_workspaces": "Ingen arbejdsområder fundet",
    "overview": "Overblik",
    "policies": "Politikker",
    "policy": {
      "edit": "Rediger",
      "quiz": "Quiz"
    },
    "resilience": "Modstandsdygtighed",
    "search_workspaces": "Søg arbejdsområder",
    "settings": {
      "administration": "Administration",
      "admins": "Administratorer",
      "apis_and_data": "API’er og data",
      "audit_logs": "Revisionslog",
      "authentication": "Godkendelse",
      "back_to_app": "Tilbage til appen",
      "breaches": "Databrud",
      "close_navigation": "Luk navigation",
      "compliance": "Compliance",
      "domains": "Domæner",
      "e_learning": "Træning",
      "export": "Eksporter",
      "exports": "Eksport",
      "goals": "Mål",
      "human_risk_intelligence": "Menneskelig risiko-intelligens",
      "import": "Importer",
      "index": "Indstillinger",
      "interventions": "Interventioner",
      "personal": "Personligt",
      "reporting": "Rapportering",
      "risk": "Risikoniveau",
      "simulations": "Simulationer",
      "threats": "Trusler",
      "workspace": "Arbejdsområde"
    },
    "sign_out": "Log ud",
    "simulations": {
      "custom_templates": "Custom skabeloner",
      "index": "Simulationer",
      "scheduled": "Planlagt",
      "single": "Aktivitet",
      "single_settings": "Indstillinger"
    },
    "team": "Medarbejdere",
    "threats": "Trusler",
    "training": "E-læring",
    "user_settings": "Sikkerhed og adgang",
    "your_workspaces": "Dine arbejdsområder"
  },
  "oauth": {
    "back_to_home": "Tilbage til forsiden",
    "error": "Vi kunne ikke opsætte integration",
    "login": "Log ind",
    "success": "Udbyderen er nu gemt"
  },
  "onboarding": {
    "building_training_paths": "Bygger træningsforløb",
    "calculating_risk_score": "Beregner risikoscore",
    "choose_provider": "Vælg din identitetsudbyder",
    "continue_button": "Fortsæt",
    "exit": "Afslut",
    "gmail_integration": "Gmail-integration",
    "google_manual_setup": {
      "access_google_admin_console_heading": "Adgang til Google Admin-konsol",
      "access_google_admin_console_text": "Log ind på Google Workspace Admin-konsollen: {google_admin_console_link}",
      "allow_moxso_ip_addresses_bullet_1": "Udvid sektionen {email_allowlist}.",
      "allow_moxso_ip_addresses_bullet_2": "Indtast følgende Moxso IP-adresser: {ip_1} {ip_2}",
      "allow_moxso_ip_addresses_bullet_3": "Klik på {save_button}",
      "allow_moxso_ip_addresses_heading": "Tillad Moxso IP-adresser",
      "configure_inbound_gateway_bullet_1": "Udvid sektionen {inbound_gateway}",
      "configure_inbound_gateway_bullet_2": "Aktiver gatewayen ved at slå knappen til.",
      "configure_inbound_gateway_bullet_3": "Indtast følgende Moxso IP-adresser under {gateway_ips}: {ip_1} {ip_2}",
      "configure_inbound_gateway_bullet_4": "Aktiver {require_tls}",
      "configure_inbound_gateway_bullet_5": "I sektionen {message_tagging_section} skal du aktivere {message_spam_eval_header}",
      "configure_inbound_gateway_bullet_6": "Indtast følgende værdi i feltet {regexp_field}: {uuid}",
      "configure_inbound_gateway_bullet_7": "Aktiver {disable_gmail_spam_eval}",
      "configure_inbound_gateway_bullet_8": "Klik på {save_button} for at anvende indstillingerne.",
      "configure_inbound_gateway_heading": "Konfigurer indgående gateway",
      "configure_spam_rule_bullet_1": "Naviger til {spam_settings}: Find sektionen Spam i den samme menu {menu_path}.",
      "configure_spam_rule_bullet_2": "Tilføj en ny regel: Klik på {add_rule} (eller rediger en eksisterende Moxso-regel), og giv den et navn som {rule_name}.",
      "configure_spam_rule_bullet_3": "Konfigurer omgåelse: Vælg {bypass_option}",
      "configure_spam_rule_bullet_4": "Skjul advarsler (kritisk): Sørg for at markere {hide_warnings_option}",
      "configure_spam_rule_bullet_5": "Sørg for, at simuleringsdomænerne tilføjes til adresselisten for denne regel ved at downloade CSV-filen:",
      "configure_spam_rule_bullet_6": "Gem reglen.",
      "configure_spam_rule_heading": "Konfigurer spamregel (omgå advarsler)",
      "disable_gmail_spam_eval": "Deaktiver Gmails spamevaluering af mail fra denne gateway; brug kun headerværdien.",
      "email_allowlist": "E-mail-tilladelsesliste",
      "gateway_ips": "Gateway-IP'er",
      "google_admin_console": "Google Admin-konsol",
      "inbound_gateway": "Indgående gateway",
      "inbound_gateway_warning_not_checked": "ikke markeret",
      "inbound_gateway_warning_text": "Sørg for, at {reject_option} er {not_checked}. Hvis denne indstilling forbliver aktiveret, kan du kun modtage e-mails fra Moxso og ikke fra eksterne afsendere.",
      "message_spam_eval_header": "Meddelelsen betragtes som spam, hvis følgende header-regexp matcher",
      "message_tagging": "Meddelelsesmærkning",
      "navigate_spam_phishing_malware_heading": "Naviger til indstillinger for spam, phishing og malware",
      "navigate_spam_phishing_malware_text": "Gå til Gmail-indstillingerne for spam, phishing og malware: {spam_phishing_link}",
      "regexp": "Regexp",
      "require_tls": "Kræv TLS for forbindelser fra de e-mailgateways, der er angivet ovenfor.",
      "save": "Gem",
      "spam_phishing_malware_settings": "Indstillinger for spam, phishing og malware",
      "whitelisting_moxso_ip_addresses_in_gw": "Allowlisting af Moxso IP-adresser i Google Workspace"
    },
    "import_employees": "Importer medarbejdere",
    "integration_error": "Der opstod en fejl ved opsætningen af integrationen til {provider}.",
    "integration_error_title": "Der opstod en fejl",
    "invite": {
      "button": "Inviter bruger",
      "text": "Vi sender dem en e-mail for at komme i gang.",
      "title": "Invitér teammedlemmer til dit dashboard"
    },
    "microsoft_bypass_junk_by_header": {
      "bypass_junk_by_header": "Omgå junk via header",
      "finish": "afslut",
      "step_1_heading": "Exchange administrationscenter",
      "step_1_text": "Gå til mail-flowregler i Exchange administrationscenter ved at besøge følgende URL: {url}",
      "step_2_heading": "Opret en ny regel",
      "step_2_text": "Opret en ny regel og giv den et navn. For eksempel: {copyField}",
      "step_2b_heading": "Konfigurer regel",
      "step_2b_list_1": "Vælg \"The message headers...\"",
      "step_2b_list_2": "Vælg derefter \"matches these text patterns\".",
      "step_2b_p1": "Klik på det første link \"Enter text\" og indtast header-nøglen: {copyField}",
      "step_2b_p2": "Klik på det næste link \"Enter text\" og indtast følgende header-værdi: {copyField}",
      "step_2b_text": "I menuen \"Apply this rule if\":",
      "step_3_heading": "Konfigurer meddelelsesheader",
      "step_3_list_1": "Vælg \"Modify the message properties\"",
      "step_3_list_2": "Vælg derefter \"Modify the message properties\".",
      "step_3_list_3": "Klik på det første link \"Enter text\" og sæt headeren til: {copyField}",
      "step_3_list_4": "Klik på det andet link \"Enter text\" og sæt værdien til: {copyField}",
      "step_3_text": "I menuen \"Do the following\":",
      "step_4_heading": "Indstillinger for regel",
      "step_4_list_1": "Klik på \"next\" og fortsæt til regelindstillinger.",
      "step_4_list_2": "Under \"Rule mode\" vælges \"Enforce\".",
      "step_4_list_3": "Klik på \"next\" og gennemse regelkonfigurationen.",
      "step_5_heading": "Gem reglen",
      "step_5_text": "Klik på {finish} for at gemme og anvende reglen."
    },
    "microsoft_bypass_junk_by_ip": {
      "bypass_junk_by_ip": "Omgå Junk via IP",
      "configure_message_header_heading": "Konfigurer meddelelsesheader",
      "configure_message_header_text_bullet_1": "Vælg {modify_message_props}",
      "configure_message_header_text_bullet_2": "Vælg derefter {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klik på det første link \"Enter text\" og sæt headeren til: {header}",
      "configure_message_header_text_bullet_4": "Klik på det andet link \"Enter text\" og sæt værdien til: {value}",
      "configure_message_header_text_intro": "I menuen \"Do the following\":",
      "configure_rule_heading": "Konfigurer regel",
      "configure_rule_text_bullet_1": "Vælg {the_sender}",
      "configure_rule_text_bullet_2": "Vælg derefter {ip_range}",
      "configure_rule_text_bullet_3": "Indtast følgende IP-adresser én ad gangen i pop op-vinduet og klik \"Add\". Når du er færdig, skal du klikke \"Save\".",
      "configure_rule_text_intro": "I menuen \"Apply this rule if\":",
      "create_new_rule_heading": "Opret en ny regel",
      "create_new_rule_text": "Opret en ny regel og giv den et navn. For eksempel: {example}",
      "exchange_admin_center_heading": "Exchange administrationscenter",
      "exchange_admin_center_text": "Gå til mailflow-regler i Exchange administrationscenter ved at besøge følgende URL: {url}",
      "rule_settings_bullet_1": "Klik \"next\" og fortsæt til regelindstillinger.",
      "rule_settings_bullet_2": "Vælg \"Enforce\" under \"Rule mode\".",
      "rule_settings_bullet_3": "Klik \"next\" og gennemse regelkonfigurationen.",
      "rule_settings_heading": "Indstillinger for regel",
      "save_the_rule_heading": "Gem reglen",
      "save_the_rule_text": "Klik på {finish} for at gemme og anvende reglen."
    },
    "microsoft_bypass_safe_links_by_header": {
      "bypass_safe_links_by_header": "Omgå Safe Links via header",
      "configure_message_header_heading": "Konfigurer meddelelsesheader",
      "configure_message_header_text_bullet_1": "Vælg {modify_message_properties}",
      "configure_message_header_text_bullet_2": "Vælg derefter {set_a_message_header}",
      "configure_message_header_text_bullet_3": "Klik på det første link \"Enter text\" og sæt headeren til: {header}",
      "configure_message_header_text_bullet_4": "Klik på det andet link \"Enter text\" og sæt værdien til: {value}",
      "configure_message_header_text_intro": "I menuen \"Do the following\":",
      "configure_rule_heading": "Konfigurer regel",
      "configure_rule_text_bullet_1": "Vælg {the_message_headers}",
      "configure_rule_text_bullet_2": "Vælg derefter {matches_text_patterns}",
      "configure_rule_text_intro": "I menuen \"Apply this rule if\":",
      "configure_rule_text_paragraph_1": "Klik på det første link \"Enter text\" og indtast header-nøglen: {header_key}",
      "configure_rule_text_paragraph_2": "Klik på det næste link \"Enter text\" og indtast følgende header-værdi: {header_value}",
      "create_new_rule_heading": "Opret en ny regel",
      "create_new_rule_text": "Opret en ny regel og giv den et navn. For eksempel: {example}",
      "exchange_admin_center_heading": "Exchange administrationscenter",
      "exchange_admin_center_text": "Gå til mailflow-regler i Exchange administrationscenter ved at besøge følgende URL: {url}",
      "rule_settings_bullet_1": "Klik på \"next\" og fortsæt til regelindstillinger.",
      "rule_settings_bullet_2": "Vælg \"Enforce\" under \"Rule mode\".",
      "rule_settings_bullet_3": "Klik på \"next\" og gennemse regelkonfigurationen.",
      "rule_settings_heading": "Indstillinger for regel",
      "save_the_rule_heading": "Gem reglen",
      "save_the_rule_text": "Klik på {finish} for at gemme og anvende reglen."
    },
    "microsoft_bypass_safe_links_by_ip": {
      "bypass_safe_links_by_ip": "Omgå Safe Links via IP",
      "configure_message_header_heading": "Konfigurer meddelelsesheader",
      "configure_message_header_text_bullet_1": "Vælg {modify_message_props}",
      "configure_message_header_text_bullet_2": "Vælg derefter {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klik på det første link \"Enter text\" og sæt headeren til: {header}",
      "configure_message_header_text_bullet_4": "Klik på det andet link \"Enter text\" og sæt værdien til: {value}",
      "configure_message_header_text_intro": "I menuen \"Do the following\":",
      "configure_rule_heading": "Konfigurer regel",
      "configure_rule_text_bullet_1": "Vælg {the_sender}",
      "configure_rule_text_bullet_2": "Vælg derefter {ip_range}",
      "configure_rule_text_bullet_3": "Indtast følgende IP-adresser én efter én i pop op-vinduet og klik \"Add\". Når du er færdig, skal du klikke \"Save\".",
      "configure_rule_text_intro": "I menuen \"Apply this rule if\":",
      "create_new_rule_heading": "Opret en ny regel",
      "create_new_rule_text": "Opret en ny regel og giv den et navn. For eksempel: {example}",
      "exchange_admin_center_heading": "Exchange administrationscenter",
      "exchange_admin_center_text": "Gå til mailflow-regler i Exchange administrationscenter ved at besøge følgende URL: {url}",
      "rule_settings_bullet_1": "Klik \"next\" og fortsæt til regelindstillinger.",
      "rule_settings_bullet_2": "Vælg \"Enforce\" under \"Rule mode\".",
      "rule_settings_bullet_3": "Klik \"next\" og gennemse regelkonfigurationen.",
      "rule_settings_heading": "Indstillinger for regel",
      "save_the_rule_heading": "Gem reglen",
      "save_the_rule_text": "Klik på {finish} for at gemme og anvende reglen."
    },
    "microsoft_integration": "Microsoft-allowlisting",
    "microsoft_tenant_allow_block": {
      "add_moxso_ips_to_tabl": "Tilføj Moxso IP'er til Tenant Allow/Block-lister",
      "add_new_entry_bullet_1": "Klik på knappen {add_button}.",
      "add_new_entry_bullet_2": "I sektionen for domænepar skal du indtaste følgende: {domain_pair_1} {domain_pair_2}",
      "add_new_entry_bullet_3": "Indstil Spoof-typen til {spoof_internal}.",
      "add_new_entry_bullet_4": "Indstil handling til {allow_action}.",
      "add_new_entry_heading": "Tilføj en ny post",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Naviger til Tenant Allow/Block-lister i Microsoft Defender ved at besøge følgende URL: {url}",
      "save_the_domain_pair_heading": "Gem domæneparret",
      "save_the_domain_pair_text": "Klik på {add} for at gemme det nye domænepar."
    },
    "microsoft_third_party": {
      "add_moxso_ips_domains_title": "Tilføj Moxsos IP'er og domæner til tredjeparts phishing-simulering i Microsoft Defender",
      "download_simulation_heading": "Download simuleringsdomæner/IP'er",
      "download_simulation_text": "Download simuleringsdomæner/IP'er ved at klikke på knappen nedenfor: {csv_export_button}",
      "edit_entries_bullet_1": "Klik på knappen {edit_button}.",
      "edit_entries_bullet_2": "I sektionen {domain_section} skal du indtaste hvert domæne, der er angivet som {domain_text} i den downloadede CSV-fil.",
      "edit_entries_bullet_3": "I sektionen {sending_ip_section} skal du indtaste følgende: {ip_1} {ip_2}",
      "edit_entries_heading": "Rediger poster",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Naviger til indstillingerne for tredjeparts phishing-simulering i Microsoft Defender ved at besøge følgende URL: {url}",
      "save_the_domain_pair_heading": "Gem domæneparret",
      "save_the_domain_pair_text": "Klik på {save_button} for at gemme indstillingerne for tredjeparts phishing-simulering."
    },
    "redirecting": "Omdirigerer",
    "results": {
      "button": "Gå til dashboardet",
      "text": "Velkommen ombord! Baseret på dine svar har vi tildelt træningsniveauer, der passer bedst til dig. Du kan til enhver tid justere dem i indstillingerne.",
      "title": "Opsummering"
    },
    "risk": {
      "approx_training_time_per_month": "Omtrentlig træningstid pr. måned",
      "more_training_more_time": "Højere modstandsmål øger træningstiden eksponentielt.",
      "targeted_resilience_score": "Målsat modstandsscore",
      "text": "Brug slideren til at angive din virksomheds overordnede risikoudsættelse og -tolerance. Overvej din branche, arten af jeres drift, og hvor følsomme de oplysninger, I håndterer, er, når du vælger et risikoniveau.",
      "title": "Angiv organisationens risikoniveau"
    },
    "select_your_email_provider": "Vælg din e-mailudbyder for trinvis allowlisting-vejledning.",
    "setting_up_workspace": "Opsætter workspace",
    "skip_button": "Spring over allowlisting",
    "skip_this_step": "Spring dette trin over",
    "sync_started": "Synkronisering startet",
    "toggle_gmail_api_integration": "Brug Gmail API-integration",
    "try_integration_again": "Prøv igen",
    "use_powershell": "Brug Powershell",
    "verifying_integration": "Bekræfter integration",
    "we_are_now_importing_employees": "Vi synkroniserer nu medarbejdere fra {provider}.",
    "welcome": {
      "graphic": {
        "text": "Du kan også springe dette trin over for nu.",
        "title": "Vælg en integration for at komme i gang"
      },
      "text": "For at få mest muligt ud af Moxso anbefaler vi, at du gennemfører denne onboarding.",
      "title": "Velkommen til Moxso"
    }
  },
  "pagination": "Side {page} af {lastPage}",
  "policies": {
    "approve_button": "Godkend politik",
    "approve_warning": "Færdiggørelse af denne politik vil deaktivere fremtidig redigering. Ønsker du at fortsætte?",
    "approve_warning_title": "Godkend politik",
    "audit": {
      "cancel": {
        "audit_canceled": "Audit annulleret",
        "button": "Annuller audit",
        "title": "Annuller audit",
        "warning": "Alle ventende notifikationer vil blive stoppet med det samme, og tildelte brugere vil miste adgang til denne politik. Ønsker du at fortsætte?"
      },
      "details": {
        "all_completed_tooltip": "Alle {count} medarbejdere har bekræftet auditten",
        "completed_tooltip": "Ingen medarbejdere har bekræftet auditten | {count} ud af {total} medarbejdere har bekræftet auditten | {count} ud af {total} medarbejdere har bekræftet auditten",
        "created_at": "Oprettet den",
        "end_date": "Slutdato",
        "enrolling_participants_heading": "Tilmelder deltagere",
        "enrolling_participants_text": "Deltagere bliver tilmeldt. Vent venligst.",
        "group": "Gruppe",
        "groups_heading": "Målgruppe",
        "groups_text": "Målgruppedetaljer",
        "heading": "Audit",
        "included_members_count_new_members_tooltip": "Nye medlemmer, der er tilføjet til gruppen efter starten af denne audit, inkluderes ikke.",
        "included_members_count_tooltip": "Medarbejdere, der allerede har bekræftet denne politik, og nye medlemmer, der er tilføjet til gruppen efter starten af denne audit, er ekskluderet.",
        "members": "Medlemmer",
        "no_participants_text": "Ingen deltagere i denne audit",
        "no_participants_title": "Ingen deltagere",
        "not_active_yet_text": "Start audit for at tilmelde deltagere.",
        "not_active_yet_title": "Audit ikke aktiv",
        "start_date": "Startdato",
        "status": "Status",
        "text": "Auditsdetaljer"
      },
      "filters": {
        "acknowledged": "Bekræftet",
        "acknowledged_at": "Bekræftet den",
        "acknowledged_default": "Alle",
        "acknowledged_label": "Bekræftelse",
        "not_acknowledged": "Afventer"
      },
      "launch": {
        "audit_started": "Audit påbegyndt",
        "button": "Start audit",
        "input_label": "Antal modtagere",
        "title": "Start audit",
        "warning": "Du er ved at starte en audit, der vil distribuere politikken til medlemmer af følgende grupper. Ønsker du at fortsætte?"
      },
      "single": {
        "settings": "Indstillinger",
        "title": "Audit"
      }
    },
    "audit_draft": "Inaktiv",
    "audit_running": "Under audit",
    "audits": {
      "create": {
        "buttons": {
          "back": "Gå tilbage",
          "continue": "Forsæt",
          "submit": "Opret audit"
        },
        "date_range": "Auditperiode",
        "date_range_placeholder": "Vælg audit start- og slutdato",
        "error": "Der opstod en fejl under oprettelsen af auditen",
        "select_groups": "Vælg grupper",
        "title": "Opret audit"
      },
      "create_new_button": "Tilføj audit",
      "created": "Audit oprettet med succes",
      "edit_button": "Rediger",
      "empty": "Ingen audits tilgængelige for denne politik",
      "help": {
        "include_previously_signed": "Medarbejdere, der allerede har bekræftet denne politik, inkluderes i auditen.",
        "notification_flow_enabled": "Aktivér automatiske notifikationer til medarbejdere, der endnu ikke har bekræftet politikken",
        "notification_prelude_enabled": "Send en notifikation til medarbejdere, når en ny politik er tildelt."
      },
      "labels": {
        "include_previously_signed": "Inkludér medarbejdere, der allerede har bekræftet",
        "notification_flow_enabled": "Aktivér notifikationsflow",
        "notification_frequency": "Notifikationsfrekvens",
        "notification_prelude_enabled": "Aktivér indledende notifikation"
      },
      "policy_not_approved_yet": "Godkend politik for at påbegynde en audit.",
      "save_settings": "Gem indstillinger",
      "title": "Audithistorik",
      "updated": "Audit blev opdateret"
    },
    "create": {
      "create_button": "Opret politik",
      "duplicate": "Duplikér",
      "duplicated": "Politik duplikeret!",
      "from_template": {
        "text": "Vælg fra et bibliotek af almindelige politikker.",
        "title": "Opret politik fra skabelon"
      },
      "labels": {
        "locale": "Sprog",
        "title": "Titel"
      },
      "manual": {
        "text": "Opret politik uden forudfyldt indhold.",
        "title": "Opret politik fra bunden"
      },
      "placeholders": {
        "locale": "Vælg politikkens primære sprog",
        "title": "Politiktitel"
      },
      "success": "Politik oprettet!",
      "title": "Opret politik"
    },
    "delete": {
      "are_you_sure": "Er du sikker på, at du vil slette denne politik? Denne handling kan ikke fortrydes.",
      "button": "Slet",
      "policy_deleted": "Politik slettet."
    },
    "edit": {
      "subtitle": "Rediger politikindhold og detaljer",
      "title": "Rediger politik",
      "title_updated": "Titel ændret med succes"
    },
    "editor": {
      "add_column_after": "Tilføj kolonne efter",
      "add_column_before": "Tilføj kolonne før",
      "add_row_after": "Tilføj række under",
      "add_row_before": "Tilføj række over",
      "delete_column": "Slet kolonne",
      "delete_image": "Slet billede",
      "delete_row": "Slet række",
      "delete_table": "Slet tabel",
      "insert_image": "Indsæt billede",
      "insert_table": "Indsæt tabel",
      "merge_cells": "Flet celler",
      "split_cell": "Opdel celle",
      "table": "Tabel",
      "toggle_header_row": "Slå overskriftsrække til/fra"
    },
    "list": {
      "create_new": "Opret politik",
      "subtitle": "Oversigt over alle politikker",
      "title": "Politikker"
    },
    "policy_approved": "Politik godkendt.",
    "quiz": {
      "create_button": "Opret quiz",
      "done_translate_button": "Færdig",
      "edit_button": "Rediger quiz",
      "empty": "Ingen quizzer",
      "other_translations_have_quizzes": "Ander oversættelser har quizzer",
      "other_translations_have_quizzes_want_to_translate": "Andre oversættelser har allerede quizzer. Vil du oversætte denne quiz til de pågældende sprog automatisk?",
      "processing_n_languages": "Behandler ét sprog | Behandler {count} sprog",
      "quiz": "Quiz",
      "quiz_now_available_in": "Din quiz er nu tilgængelig på ét yderligere sprog | Din quiz er nu tilgængelig på {count} yderligere sprog",
      "quiz_translate_success": "Succes!",
      "quizzes_translated": "Quizzer oversat.",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Vælg de sprog, du vil oversætte din quiz til",
      "some_translations_have_no_quizzes": "Nogle oversættelser har i øjeblikket ingen quizzer. Oversæt nu?",
      "subtitle": "Tilgængelige quizzer",
      "this_translation_has_quizzes_in_other_languages_translate_automatically": "Denne oversættelse har quizzer på andre sprog. Oversæt automatisk?",
      "title": "Quizzer",
      "translate_button": "Oversæt",
      "translate_from": "Oversæt fra",
      "translate_multiple_choice_quiz": "Oversæt multiple choice quiz",
      "translate_quiz": "Oversæt",
      "translating_your_quiz": "Oversætter din quiz",
      "update_this_quiz_and_translate_others": "Opdater denne quiz og oversæt andre quizzer",
      "update_this_quiz_only": "Opdater kun denne quiz",
      "view_button": "Se quiz"
    },
    "single": {
      "audits": "Audits",
      "audits_subtitle": "Audithistorik",
      "details": {
        "heading": "Detaljer",
        "text": "Politikdetaljer"
      },
      "labels": {
        "acknowledgement_rate": "Bekræftelsesrate",
        "approval": "Godkendelsesstatus",
        "approved_at": "Godkendt den {approved_at}",
        "approved_by": "Godkendt af {user}",
        "created_at": "Oprettet den",
        "edit": "Rediger",
        "id": "ID",
        "latest_audit_status": "Seneste auditstatus",
        "not_approved": "Ikke godkendt",
        "updated_at": "Opdateret den"
      },
      "subtitle": "Tilgængelige oversættelser",
      "title": "Politik"
    },
    "tables": {
      "approved_at": "Godkendt den",
      "created_at": "Oprettet den",
      "has_active_audit": "Auditstatus",
      "status_approved": "Godkendt",
      "status_draft": "Kladde",
      "title": "Titel"
    },
    "translations": {
      "ai": {
        "done_translate_button": "Færdig",
        "policy_now_available_in": "Din politik er nu tilgængelig på ét ekstra sprog | Din politik er nu tilgængelig på {count} ekstra sprog",
        "policy_translate_success": "Succes!",
        "processing_n_languages": "Behandler ét sprog | Behandler {count} sprog",
        "text": "Brug DeepL til automatisk at oversætte politikken til et valgt sprog.",
        "title": "Oversæt politik med AI",
        "translate_button": "Oversæt",
        "translate_from": "Oversæt fra",
        "translating_your_policy": "Oversætter din politik"
      },
      "create": "Oversæt",
      "create_deepl_new_button": "Oversæt med AI",
      "create_new_button": "Tilføj oversættelse",
      "create_success": "Oversættelse oprettet med succes",
      "create_title": "Tilføj oversættelse",
      "created_at": "Oprettet",
      "default_badge": "Standard",
      "delete_are_you_sure": "Er du sikker på, at du vil slette denne oversættelse? Denne handling kan ikke fortrydes.",
      "delete_button": "Slet",
      "edit_button": "Rediger",
      "edit_views": {
        "edit": "Rediger",
        "preview": "Forhåndsvisning"
      },
      "empty": "Ingen oversættelser for denne politik",
      "empty_sections_overview": {
        "subtitle": "Tilføj en Heading 1 for at oprette en ny sektion.",
        "title": "Ingen sektioner tilføjet"
      },
      "language": "Sprog",
      "last_updated": "Sidst opdateret",
      "locked": "Redigering låst, da politikken er godkendt.",
      "make_default": "Sæt som standard",
      "manual": {
        "first_translation_text": "Start med at oprette en oversættelse fra bundeng",
        "first_translation_title": "Opret oversættelse for denne politik",
        "text": "Omskriv oversættelsen fra bunden på et nyt sprog.",
        "title": "Oversæt politik manuelt"
      },
      "save": "Gem ændringer",
      "save_success": "Oversættelse gemt med succes",
      "save_success_title": "Titel ændret med succes",
      "select_locale": "Målsprog",
      "select_locale_placeholder": "Vælg sproget for din oversættelse",
      "subtitle": "Administrer oversættelser for denne politik",
      "title": "Oversættelser",
      "title_label": "Oversættelsestitel",
      "title_placeholder": "Indtast oversættelsestitel",
      "translation_deleted": "Oversættelse slettet.",
      "view_button": "Vis"
    }
  },
  "quiz_builder": {
    "ai_prompt": {
      "button": "AI prompt",
      "generate": "Generer",
      "no_previous_steps": "Tilføj et video- eller teksttrin tidligere i kurset for at bruge det som kontekst.",
      "placeholder": "Beskriv den quiz, du vil have AI til at oprette...",
      "select_helper": "Vælg tidligere trin for at give AI mere kontekst.",
      "select_label": "Inkluder tidligere indhold",
      "step_number": "Trin {order}",
      "step_type": {
        "quiz": "Quiz",
        "text": "Tekst",
        "video": "Video"
      },
      "title": "Generer quiz med AI",
      "untitled": "Uden titel"
    },
    "buttons": {
      "add_ai_question": "Tilføj AI spørgsmål",
      "add_option": "Tilføj valgmulighed",
      "add_question": "Tilføj spørgsmål",
      "close": "Luk",
      "edit": "Rediger",
      "save_quiz": "Gem quiz"
    },
    "delete_question_confirmation": {
      "are_you_sure": "Er du sikker på, at du vil slette dette spørgsmål?",
      "button": "Slet spørgsmål"
    },
    "empty": {
      "ai_create_button": "Brug Moxso Intelligence",
      "ai_description": "Kom i gang ved enten at tilføje det første spørgsmål eller bruge Moxso AI til at generere en quiz.",
      "create_button": "Opret quiz",
      "description": "Kom i gang ved at tilføje det første spørgsmål.",
      "manually_create_button": "Opret quiz manuelt",
      "title": "Ingen spørgsmål endnu"
    },
    "labels": {
      "answer_options": "Svarmuligheder",
      "question": "Spørgsmål"
    },
    "placeholders": {
      "answer_option": "Indtast svarmulighed",
      "question": "Indtast spørgsmål"
    },
    "quiz_saved": "Quiz gemt",
    "quizzes_translated": "Quizzer oversat.",
    "titles": {
      "question": "Spørgsmål {number}"
    }
  },
  "report": {
    "click_rate": "Klikrate",
    "from_value": "fra {value}",
    "last_12_months": "Seneste 12 måneder",
    "last_six_months": "Seneste seks måneder",
    "no_data": "Ingen data",
    "polarity": "Polaritet",
    "report_rate": "Rapporteringsrate",
    "resilience": "Modstandsdygtighed",
    "simulations": "Simuleringer",
    "training": "Træning",
    "vs_previous_period": "mod forrige periode"
  },
  "reset_password": {
    "heading": "Nulstil adgangskode",
    "success_message": "Adgangskoden er nu gemt",
    "text": "Vælg ny adgangskode"
  },
  "seo_titles": {
    "automation": {
      "action": "Automationsdeltagere",
      "edit": "Rediger automation",
      "index": "Automatisering",
      "single": "Sekvens"
    },
    "breach": {
      "index": "Databrud",
      "single": "Databrud"
    },
    "campaign": {
      "index": "Simulationer",
      "single": "Simuleringsoversigt",
      "templates": "Custom skabeloner"
    },
    "dashboard": {
      "breaches": "Dashboard – Databrud",
      "human_risk_intelligence": "Dashboard - Menneskelig risiko-intelligens",
      "overview": "Dashboard",
      "resilience": "Dashboard – Modstandsdygtighed",
      "simulations": "Dashboard – Simulationer",
      "threats": "Dashboard – Trusler",
      "training": "Dashboard – Træning"
    },
    "employee": {
      "index": "Medarbejdere",
      "single": "Medarbejder"
    },
    "forgot_password": "Nulstil adgangskode",
    "group": {
      "index": "Grupper",
      "single": "Gruppe"
    },
    "impersonate": "Impersonate",
    "integration": "Integration",
    "invite": {
      "id": "Accepter invitation",
      "index": "Accepter invitation"
    },
    "login": "Log ind",
    "policies": {
      "audit": "Audit",
      "index": "Politikker",
      "single": "Rediger politikoversættelse",
      "translations": "Politikoversættelser"
    },
    "reset_password": "Nulstil adgangskode",
    "settings": {
      "breaches": "Indstillinger – Databrud",
      "domains": "Indstillinger – Domæner",
      "e_learning": "Indstillinger – Træning",
      "export": "Indstillinger – Eksportér data til CSV",
      "import": "Indstillinger – Importér fra CSV",
      "index": "Indstillinger – Indstillinger",
      "integrations": {
        "index": "Indstillinger – Integrationer",
        "single": "Indstillinger – Rediger integration"
      },
      "risk": "Indstillinger – Risikoniveau",
      "simulations": "Indstillinger – Simulationer",
      "threats": "Indstillinger – Trusler"
    },
    "threat": {
      "index": "Trusler",
      "single": "Trussel"
    },
    "training": {
      "deadlines": "Deadlines",
      "index": "E-læring",
      "participation": "Træningsdeltagelse"
    },
    "two_factor": "Tofaktorgodkendelse",
    "user_settings": "Brugerindstillinger",
    "validate_domain": "Bekræft domæne"
  },
  "settings": {
    "breaches": {
      "enable_breaches": {
        "help": "Aktiver databrud for denne konto.",
        "title": "Aktiver databrud"
      },
      "enable_notifications": {
        "help": "Underret medarbejdere direkte, når de er involveret i nye databrud.",
        "title": "Aktiver notifikationer"
      },
      "subtitle": "Indstillinger for databrud.",
      "title": "Databrud"
    },
    "buttons": {
      "add_domain": "Tilføj domæne",
      "add_report": "Tilføj rapport",
      "add_user": "Tilføj bruger",
      "resend_invitation": "Gensend email",
      "revoke_access": "Fjern adgang",
      "save_settings": "Gem indstillinger",
      "verify_domain": "Bekræft"
    },
    "data": {
      "subtitle": "Når funktionen er aktiveret, vil data blive anonymiseret 90 dage efter seneste relevante handling.",
      "title": "Dataanonymisering"
    },
    "domains": {
      "domain_added": "Domæne oprettet",
      "domain_required": "Indtast et domæne",
      "subtitle": "Administrer domænenavne ejet af din virksomhed.",
      "title": "Verificerede domæner",
      "verification_email_sent": "Bekræftelsesmail sendt",
      "verification_required": "Afventer bekræftelse",
      "verified": "Bekræftet",
      "verified_on": "Verificeret dn:",
      "verify_new_domain": "Bekræft nyt domæne"
    },
    "e_learning": {
      "alert": {
        "not_allowed": "Ikke tilladt",
        "optional_courses": "Valgfrie kurser",
        "optional_courses_description": "Kurser uden for obligatorisk træning",
        "optional_quiz_questions": "Quizspørgsmål",
        "optional_quiz_questions_description": "Valgfrie phishing-quizspørgsmål",
        "optional_videos": "Valgfrie videoer",
        "optional_videos_description": "Videoer uden for obligatorisk træning",
        "quiz_limit_value": "15 pr. uge",
        "title": "Begrænsninger anvendt når aktiveret",
        "video_limit_value": "2 pr. uge"
      },
      "modes": {
        "automatic": {
          "description": "Moxso styrer hele jeres træningsprogram automatisk.",
          "recommended": "Anbefalet",
          "title": "Automatisk træning"
        },
        "confirmation": {
          "automatic": {
            "description": "Moxso begynder automatisk at tildele træning.",
            "title": "Skift til automatisk træning?"
          },
          "manual": {
            "description": "Moxso stopper med at tildele træning. Eksisterende tildelinger bevares.",
            "title": "Skift til planlagt træning?"
          },
          "switch": "Skift"
        },
        "help": "Vælg, hvordan træning tildeles i din organisation.",
        "label": "Træningstilstand",
        "manual": {
          "description": "Administratorer planlægger og tildeler selv træning.",
          "title": "Planlagt træning"
        },
        "will_be_hidden": "Skjules efter skiftet"
      },
      "subtitle": "Konfigurer dine træningsindstillinger.",
      "title": "Træning"
    },
    "exports": {
      "custom": "Brugerdefineret",
      "default": "Standard",
      "download_export": "Download eksport",
      "export_type": {
        "automation": "Automation rapport",
        "employee": "Medarbejderapport",
        "text": "Vælg den type eksport, du vil generere.",
        "title": "Eksporttype",
        "training": "Træningsrapport"
      },
      "form": {
        "deselect_all": "Fravælg alle",
        "select_all": "Vælg alle"
      },
      "reports": {
        "delete_button": "Slet",
        "deleted_success": "Rapport slettet",
        "download_button": "Download",
        "edit_button": "Rediger",
        "search": "Søg",
        "subtitle": "Konfigurer skemalagte rapporter.",
        "title": "Skemalagte rapporter"
      },
      "selected_columns": "Kolonner({count}): {columns}",
      "subtitle": "Vælg kolonner, der skal eksporteres.",
      "title": "Download eksport"
    },
    "forms": {
      "company": {
        "label": "Virksomhed",
        "placeholder": "Virksomhed"
      },
      "custom_deeplink_url": {
        "description": "Brug ::content_id:: som en påkrævet pladsholder for indholds-id.",
        "label": "Brugerdefineret indholds-URL",
        "placeholder": "https://example.com/launch/something-::content_id::"
      },
      "custom_lms_url": {
        "label": "Brugerdefineret LMS-URL",
        "placeholder": "https://example.com/launch/"
      },
      "data_enrichment": {
        "subtitle": "Tildel roller til medarbejdere baseret på deres data.",
        "title": "Berigelse af medarbejderdata",
        "tooltip": "Berigelse af medarbejderdata bruger AI til at tildele roller til medarbejdere baseret på deres afdeling og grupper."
      },
      "enhanced_scoring": {
        "subtitle": "Vægt resilience scores baseret på medarbejderroller",
        "title": "Forbedret scoring",
        "tooltip": "Forbedret scoring anvender forskellige vægtninger afhængigt af, hvor sikkerhedskritisk en rolle er, så personer med større adgang eller ansvar skal gøre mere for at opnå den samme resilience score."
      },
      "gdpr": {
        "employees": {
          "help": "Anonymiser automatisk inaktive medarbejdere.",
          "title": "Anonymiser inaktive medarbejdere"
        },
        "threats": {
          "help": "Anonymiser automatisk trusselsdata.",
          "title": "Anonymiser håndterede trusler"
        }
      },
      "hotline": {
        "description": "Dette vil være den primære kontakt person i dit team i tilfælde af trusler eller medarbejderhenvendelser.",
        "label": "Hotline",
        "placeholder": "it{'@'}firma.dk"
      },
      "industry": {
        "label": "Industri"
      },
      "labels": {
        "active_status": "Status",
        "automation": "Automation",
        "custom_fields": "Kolonner",
        "date_range": "Vælg datoer",
        "domain": "Domæne",
        "email": "Email",
        "first_name": "Fornavn",
        "group": "Gruppe",
        "last_name": "Efternavn",
        "report_frequency": "Frekvens",
        "report_period": "Periode",
        "report_recipient": "Modtager",
        "report_status": "Status",
        "report_type": "Rapport type",
        "role": "Rolle",
        "training_type": "Type"
      },
      "leaderboard": {
        "enabled": {
          "subtitle": "Vis et leaderboard i hubben, og vælg hvordan medarbejdere rangeres.",
          "title": "Leaderboard"
        },
        "options": {
          "point_leaderboard": "Point leaderboard",
          "score_leaderboard": "Leaderboard for resilience score"
        },
        "setting": {
          "label": "Leaderboard-type"
        }
      },
      "placeholders": {
        "date_range": "Vælg datoer",
        "domain": "firma.dk",
        "email": "navn{'@'}firma.dk",
        "first_name": "Fornavn",
        "last_name": "Efternavn",
        "report_recipient": "Søg efter modtager",
        "search_employee": "Søg efter ansatte"
      },
      "reports": {
        "add_scheduled_report": "Tilføj skemalagt rapport",
        "choose_report_type": "Vælg en anden rapport type",
        "description": "Opsæt skemalagt rapport til automatisk afsendelse.",
        "edit_scheduled_report": "Rediger skemalagt rapport",
        "hierarchy_level": {
          "description": "Når dette er aktiveret, inkluderer rapporten medarbejdere længere nede i hierarkiet, ikke kun direkte referencer.",
          "label": "Inkluder underliggende teammedlemmer"
        },
        "manager_report": {
          "text": "En rapport til managere omkring deres ansatte.",
          "title": "Manager rapport"
        },
        "workspace_report": {
          "text": "En rapport om hele organisationen.",
          "title": "Organisationsrapport"
        }
      },
      "scim": {
        "add_title": "Opret SCIM-token",
        "connection_add_title": "Opret SCIM-forbindelse",
        "connection_created": "SCIM-forbindelse oprettet.",
        "connection_deleted": "SCIM-forbindelse slettet.",
        "connection_name_label": "Forbindelsesnavn",
        "connection_name_placeholder": "Microsoft Entra ID",
        "connection_saved": "SCIM-forbindelse gemt.",
        "connection_token_name_placeholder": "{name}-provisionering",
        "create_connection_button": "Opret forbindelse",
        "create_token_button": "Opret token",
        "create_token_header": "Opret token",
        "created_title": "SCIM-token oprettet",
        "default_mapping_marker": "Standard",
        "delete_connection_body": "Dette fjerner forbindelsen og tilbagekalder alle SCIM-tokens, der er knyttet til den. Provisionering fra denne udbyder stopper med det samme.",
        "delete_connection_button": "Slet forbindelse",
        "delete_connection_title": "Slet SCIM-forbindelse?",
        "done": "Færdig",
        "edit_connection_button": "Rediger forbindelse",
        "enabled_label": "Aktiveret",
        "name_help": "Giv dit token et beskrivende navn, så du kan genkende det senere.",
        "name_label": "Tokennavn",
        "name_placeholder": "Microsoft Entra-provisionering",
        "note_cannot_view": "Dette token vises kun én gang. Gem det i din identitetsudbyder, før du lukker denne dialog.",
        "provider_label": "Udbyder",
        "reset_mapping_button": "Nulstil til standarder",
        "revoke_body": "Provisioneringsanmodninger med dette token stopper med det samme. Eksisterende medarbejdere og grupper slettes ikke.",
        "revoke_button": "Tilbagekald token",
        "revoke_title": "Tilbagekald SCIM-token",
        "save_connection_button": "Gem forbindelse",
        "save_mapping_button": "Gem mapping",
        "secret_token_label": "Hemmeligt token",
        "show_mapping_details": "Mappingdetaljer",
        "success_token_added": "SCIM-token tilføjet.",
        "success_token_revoked": "SCIM-token tilbagekaldt.",
        "sync_type_employee": "Medarbejder",
        "sync_type_employee_description": "Provisionér medarbejdere og medarbejdergrupper fra denne identitetsudbyder.",
        "sync_type_label": "Provisioneringstype",
        "sync_type_user": "Adminbruger",
        "sync_type_user_description": "Provisionér adminbrugere, der kan få adgang til administrationsdashboardet."
      },
      "select_automation": "Vælg automation",
      "select_group": "Vælg gruppe",
      "settings_saved": "Indstillinger gemt",
      "success": {
        "invitation_resent": "Email bekræftelse er blevet gensendt",
        "report_added": "Rapport tilføjet",
        "report_edited": "Rapport gemt",
        "user_added": "Bruger tilføjet"
      },
      "timezone": {
        "label": "Tidszone",
        "placeholder": "Vælg tidszone"
      },
      "tokens": {
        "add_title": "Opret token",
        "are_you_sure_you_want_to_delete": "Er du sikker på, at du vil slette dette token? Denne handling kan ikke fortrydes.",
        "close": "Luk",
        "create_token_button": "Opret token",
        "documentation": "Dokumentation",
        "name_help": "Giv dit token et beskrivende navn, så du kan identificere det senere.",
        "name_label": "Navn",
        "name_placeholder": "Token‑navn",
        "note_cannot_view": "Dette token vises kun én gang. Gem det et sikkert sted.",
        "success_token_added": "Token tilføjet.",
        "success_token_deleted": "Token slettet.",
        "token_created": "Token oprettet"
      },
      "training_restrictions": {
        "enabled": {
          "subtitle": "Begræns hvor meget ikke-tildelt træning medarbejdere selv kan gennemføre.",
          "title": "Træningsbegrænsninger",
          "tooltip": "Aktivér standardbegrænsningerne for valgfri træning i hubben."
        },
        "unassigned_quiz_limit": {
          "help": "Maksimalt antal ikke-tildelte quizzer en medarbejder kan gennemføre.",
          "label": "Quizgrænse"
        },
        "unassigned_video_limit": {
          "help": "Maksimalt antal ikke-tildelte videoer en medarbejder kan gennemføre.",
          "label": "Videogrænse"
        }
      },
      "training_type": {
        "course": "Kurser",
        "video": "Videoer"
      },
      "users": {
        "add_employee": "Tilføj bruger"
      }
    },
    "imports": {
      "back": "Tilbage",
      "button": "{click} eller træk og slip filen her",
      "click_to_upload": "Klik her for at uploade",
      "completed": "Fuldført",
      "done": "Færdig",
      "failed": "Fejlet",
      "file_requirements": "Filen skal indeholde følgende kolonner: <b>first_name</b>, <b>last_name</b>, <b>email</b> og <b>locale</b> (f.eks. da_DK, en_US, de_DE).<br/>Filen kan valgfrit indeholde <b>timezone</b> (f.eks. Europe/Copenhagen), <b>phone_number</b> og <b>phone_country_code</b>.<br/><b>CSV-filer skal bruge komma som separator.</b><br/>Accepterede formater: .csv eller .txt (Filen skal gemmes i UTF-8 format for at sikre korrekt tegnsætning).",
      "formats": "CSV eller TXT op til 10MB",
      "import_type": {
        "employees": "{count} medarbejder | {count} medarbejdere",
        "groups": "{count} gruppe | {count} grupper"
      },
      "pending": "Synkroniserer",
      "upload_another": "Upload endnu en fil"
    },
    "integrations": {
      "account": {
        "subtitle": "Synkronisér brugerprofiler med Moxso.",
        "title": "Brugere og kommunikation"
      },
      "add_our_domains_and_setup_guides": "Tilføj vores domæner, og følg vejledningerne til Gmail/Outlook",
      "addin_setup_guide": "Opsætningsvejledning",
      "coming_soon": "Kommer snart",
      "compliance": {
        "subtitle": "Synkronisér med compliance værktøjer.",
        "title": "Compliance værktøjer"
      },
      "connected": {
        "subtitle": "Integrationer der er tilsluttet.",
        "title": "Aktive integrationer"
      },
      "delete": {
        "button": "Slet integration",
        "confirmation": "Er du sikker på, at du vil slette denne integration? Handlingen kan ikke fortrydes.",
        "description": "Når du sletter denne integration, stopper fremtidig synkronisering. Handlingen kan ikke fortrydes.",
        "subtitle": "Fjern denne integration fra dit workspace.",
        "success": "Integration slettet",
        "title": "Slet integration"
      },
      "edit": {
        "auth_settings": {
          "subtitle": "Opdatér autentificeringsindstillinger",
          "title": "Autentificeringsindstillinger"
        },
        "filtering": {
          "text": "Generisk og rollebaseret e-mail-filtrering fjerner automatisk delte e-mailadresser fra din integration, dette kunne være e-mail-konti som: admin{'@'}domæne.com, kontakt{'@'}domæne.com osv.",
          "title": "Generisk og rollebaseret e-mailfiltrering"
        },
        "groups": {
          "text": "Vælg om du vil synkronisere grupper hver gang integrationen synkroniseres.",
          "title": "Grupper"
        },
        "managers": {
          "text": "Vælg om du vil synkronisere managere hver gang integrationen synkroniseres.",
          "title": "Managere"
        },
        "offboarding": {
          "text": "Vælg om du vil deaktivere medarbejdere, der ikke længere er tilknyttet din integration.",
          "title": "Offboarding"
        },
        "settings": {
          "enable_notifications": {
            "title": "Aktivér træningsnotifikationer"
          },
          "enable_sync": "Aktiver synkronisering",
          "select_sync_frequency": "Vælg hvor ofte vi skal synkronisere med din integration.",
          "subtitle": "Opdater integrationskonfiguration",
          "sync_frequency": "Synkroniseringsfrekvens",
          "title": "Rediger integration"
        },
        "sync_phone_numbers": {
          "text": "Vælg, om telefonnumre skal importeres, når der synkroniseres med denne integration.",
          "title": "Importer telefonnumre"
        },
        "title": "Seneste synkroniseringer"
      },
      "enabled": "Aktiveret",
      "first_sync": "Første synkronisering",
      "form": {
        "access_token": {
          "help": "API nøglen benyttes til at forbinde til din integration.",
          "label": "API nøgle"
        },
        "api_route": {
          "label": "API rute",
          "placeholder": "Indtast API rute"
        },
        "password": {
          "help": "Adgangskoden bruges til autentificering af integrationen.",
          "label": "Adgangskode",
          "placeholder": "Indtast adgangskode"
        },
        "region": {
          "help": "Vælg den data region du benytter hos din ubyder.",
          "label": "Data region",
          "options": {
            "eu": "EU",
            "global": "Global"
          }
        },
        "username": {
          "help": "Brugernavnet bruges til autentificering af integrationen.",
          "label": "Brugernavn",
          "placeholder": "Indtast brugernavn"
        }
      },
      "frequency": {
        "daily": {
          "description": "Dine data vil blive synkroniseret hver dag.",
          "title": "Daglig"
        },
        "monthly": {
          "description": "Dine data vil blive synkroniseret den første dag i hver måned.",
          "title": "Månedlig"
        },
        "realtime": {
          "description": "Dine data vil blive synkroniseret hvert minut.",
          "title": "Realtid"
        },
        "weekly": {
          "description": "Dine data vil blive synkroniseret hver mandag.",
          "title": "Ugentlig"
        }
      },
      "gmail_addin": {
        "apps_marketplace_apps": "Apps → Google Workspace Marketplace apps",
        "click_install_review_deploy": "Klik på {install}, gennemgå de anmodede tilladelser, og vælg {deploy_to_organisation} (eller en testgruppe) for at gøre add-in tilgængelig for brugerne.",
        "deploy_to_organisation": "Deploy to your organisation",
        "find_moxso_add_in": "Find “Moxso Report” add-in",
        "in_admin_console_navigate_to": "I Google Workspace Admin-konsollen skal du navigere til {marketplace_apps}.",
        "install": "Install",
        "install_and_deploy": "Installer og udrul add-in",
        "moxso_report": "Moxso Report",
        "open_workspace_marketplace": "Åbn Google Workspace Marketplace",
        "report_threats_directly_from_gmail": "Rapportér trusler til Moxso direkte fra Gmail.",
        "search_to_locate": "Brug søgefeltet til at finde og åbne {moxso_report}.",
        "title": "Opsæt Gmail Add-in"
      },
      "gmail_whitelisting_guide": "Gmail allowlisting guide",
      "hri": {
        "connected": "Tilsluttet",
        "directory_description": "Forbind Microsoft Entra eller Google Workspace for at matche medarbejder-id'er og låse op for andre HRI-integrationer. Denne HRI-forbindelse er adskilt fra din almindelige integration.",
        "directory_title": "Forbind først dit medarbejderkatalog",
        "enable": "Aktivér",
        "explore_description": "Du kan udforske integrationerne nedenfor. Opsætning kræver en aktiv HRI-forbindelse til Microsoft Entra eller Google Workspace.",
        "explore_title": "Udforsk integrationer",
        "recommended": "Anbefalet",
        "recommended_tooltip": "Du bruger allerede dette katalog",
        "setup_locked": "Opsætning låst",
        "setup_prerequisite": "Opsæt først HRI til Microsoft Entra eller Google Workspace."
      },
      "integration_stored": "Integration gemt",
      "last_sync": "Seneste synkronisering",
      "last_update": "Sidst opdateret: {time}",
      "lms": {
        "subtitle": "Synkronisér med learning management systemer.",
        "title": "Learning management systemer"
      },
      "never": "Aldrig",
      "not_connected": "Ikke tilsluttet",
      "notifications": {
        "subtitle": "Send notifikationer via samarbejdsværktøjer.",
        "title": "Notifikationer"
      },
      "open_guide": "Åbn vejledning",
      "outlook_addin": {
        "accept_permissions": "Acceptér tilladelser",
        "add_ins": "Add-ins",
        "app_type": "App type",
        "assign_access": "Tildel adgang",
        "assign_users": "Assign users",
        "choose_who_get_add_in": "Under {assign_users} skal du vælge, hvem der skal have add-in installeret. Vi anbefaler at vælge {specific_users} og vælge de relevante grupper.",
        "chose_manifest_url": "Vælg {provide_link}, og indsæt manifest-URL'en:",
        "click": "Klik på {next}.",
        "click_next_then_finish": "Klik på {next}, og derefter {finish}.",
        "click_you_should_see_message": "Klik på {validate}. Du bør se beskeden \"{file_validated}\".",
        "complete": "Fuldfør",
        "confirm_slot_is_selected": "Bekræft i {app_type}, at {add_in} er valgt.",
        "done": "Done",
        "examine_permissions": "Gennemgå de anmodede tilladelser. Hvis alt ser korrekt ud, vælg {accept_permissions} og bekræft.",
        "finalize_deployment": "Finalize Deployment",
        "finish_deployment": "Finish deployment",
        "integrated_apps": "Integrated Apps",
        "manifest_file_validated": "Manifest file validated",
        "navigate_to_admin_center": "Naviger til Microsoft 365 administrationscenter > Indstillinger > {link}",
        "next": "Next",
        "office_add-in": "Office Add-in",
        "open_integrated_apps": "Åbn Integrated Apps",
        "proceed_to_assignment": "Fortsæt til Assignment",
        "process_indicator_then_complete": "Du vil se en statusindikator; dette trin tager sjældent mere end et minut. Tryk derefter på {done} for at færdiggøre opsætningen.",
        "provide_link_to_manifest_file": "Angiv link til manifestfil",
        "provide_manifest": "Angiv manifestet",
        "report_threats_directly_from_outlook": "Rapportér trusler til Moxso direkte fra Outlook.",
        "restart_outlook": "Genstart Outlook for at sikre, at add-in initialiseres, og indsend derefter en test rapportering. Bemærk, at add-in kan tage op til 24 timer at vises efter udrulning.",
        "review_permissions": "Gennemgå tilladelser",
        "select_upload_custom_apps": "Vælg {bold}.",
        "specific_users_groups": "Specific users/groups",
        "specify_app_type": "Angiv App type",
        "start_the_upload": "Start uploadprocessen",
        "title": "Opsæt Outlook Add-in",
        "upload_custom_apps": "Upload custom apps",
        "use_powershell": "Brug PowerShell",
        "validate": "Validate",
        "validate_manifest": "Validér manifestet",
        "verify_add_in": "Bekræft Add-in i Outlook"
      },
      "outlook_whitelisting_guide": "Outlook allowlisting guide",
      "overview": {
        "active": "Aktive",
        "active_subtitle": "Integrationer der er tilsluttet.",
        "active_title": "Aktive integrationer",
        "all": "Alle",
        "all_subtitle": "Forbind tjenester for at samle medarbejdernes sikkerhedsaktivitet i Human Risk Intelligence.",
        "all_title": "Alle integrationer",
        "attention": "Kræver opmærksomhed",
        "attention_subtitle": "Integrationer, der kræver opmærksomhed, før de kan synkronisere.",
        "attention_title": "Kræver opmærksomhed",
        "empty": "Ingen integrationer fundet.",
        "hri": "Human risk intelligence",
        "search": "Søg efter integrationer...",
        "sections": {
          "compliance": "Compliance",
          "lms": "LMS",
          "notifications": "Notifikationer",
          "signals": "Signaler",
          "user_sync": "Brugersynkronisering"
        }
      },
      "refresh": "Opdater data",
      "refresh_data": "Opdater data",
      "report_threats_directly_from_inbox": "Rapportér trusler direkte fra indbakken.",
      "settings_saved": "Indstillinger gemt",
      "setup": "Forbind",
      "setup_integration": "Opsætning",
      "setup_text": "Vi bruger single sign-on (SSO) til sikker forbindelse til {provider}. Du vil blive viderestillet til udbyderens login-side for at godkende. Bemærk, at der kræves en administratorkonto for at konfigurere integrationen.",
      "simulation_deliverability": "Levering af simulationer",
      "single": {
        "provider_title": "Rediger {provider}",
        "subtitle": "Opdater integrationskonfiguration",
        "title": "Rediger integration"
      },
      "status": "Integrationsstatus",
      "step_by_step": "Trinvis vejledning til at tillade e-mails",
      "sync_already_enabled_tooltip": "Medarbejdersynkronisering er allerede aktiveret i en anden integration. Deaktiver den for at aktivere denne mulighed.",
      "sync_started": "Synkronisering tilføjet til kø",
      "tags": {
        "all": "Alle tags",
        "compliance": {
          "description": "Del data om sikkerhedsbevidsthed med din complianceplatform.",
          "headline": "Compliance"
        },
        "filter": "Filtrer efter tag",
        "learning_management": {
          "description": "Forbind træning i sikkerhedsbevidsthed med dit læringssystem.",
          "headline": "Læringsstyring"
        },
        "notifications": {
          "description": "Send notifikationer fra Moxso via din kommunikationsplatform.",
          "headline": "Notifikationer"
        },
        "user_sync": {
          "description": "Synkroniser brugere fra din mappe eller dit arbejdsområde til Moxso.",
          "headline": "Brugersynkronisering"
        }
      },
      "teams_guide": {
        "description": "Følg opsætningsguiden i vores {help_center} for instruktioner til at tilføje Moxso til Microsoft Teams.",
        "download_zip": "Download ZIP-fil",
        "help_center": "hjælpecenter"
      },
      "thunderbird_addin": {
        "description": "Rapportér trusler direkte fra Thunderbird",
        "download_button": "Download tilføjelse",
        "download_text": "Gem moxso-thunderbird.xpi på din computer. Hvis browseren forsøger at åbne filen, skal du højreklikke på downloadlinket og vælge Gem link som.",
        "download_title": "Download tilføjelsen",
        "install_text": "Åbn tandhjulsmenuen, vælg Installér tilføjelse fra fil, og vælg moxso-thunderbird.xpi. Gennemgå de ønskede tilladelser, og bekræft installationen. Genstart Thunderbird, hvis du bliver bedt om det.",
        "install_title": "Installér tilføjelsen",
        "name": "Thunderbird-tilføjelse",
        "open_text": "Åbn menuen i Thunderbird, vælg Tilføjelser og temaer og derefter Udvidelser.",
        "open_title": "Åbn tilføjelsesadministrationen",
        "title": "Opsætning af Thunderbird-tilføjelse"
      },
      "title": "Integrationer",
      "token_error": "Vi kunne ikke oprette forbindelse til {provider} for dig. Vores seneste forsøg var den: {date}. Bekræft venligst dine kontooplysninger igen.",
      "whitelisting_guide": "Allowlisting guide"
    },
    "magic_links": {
      "description": "Lad medarbejdere logge ind automatisk via Hub-links i notifikationer. Når funktionen er slået fra, åbner links Hubs loginside og bevarer den oprindelige destination.",
      "label": "Aktivér magiske links",
      "title": "Magiske links til Hub"
    },
    "risk": {
      "organisation_risk_subtitle": "Samlet risikoniveau for {organisation}",
      "organisation_risk_text": "Et højere risikoniveau betyder mere træning for medarbejderne. Sørg for at finde en balance mellem træning og arbejdsopgaver.",
      "organisation_risk_title": "Organisationsrisiko",
      "subtitle": "Angiv træningsniveau efter kategori.",
      "title": "Træningsniveau"
    },
    "saml": {
      "acs_url": "ACS-URL",
      "add_provider": "Tilføj provider",
      "attribute_mapping": {
        "description": "Map SAML assertion-attributter til de adminbrugerfelter, Moxso forventer.",
        "title": "Assertion-attributmapping"
      },
      "cancel_edit": "Annuller redigering",
      "create": {
        "manual": {
          "description": "Konfigurer provideren manuelt",
          "title": "Opret manuelt"
        },
        "metadata": {
          "description": "Importer IdP-indstillinger fra provider",
          "title": "Opret fra metadata-URL"
        }
      },
      "delete": {
        "cancel": "Annuller",
        "confirm": "Slet forbindelse",
        "description": "Brugere vil ikke længere kunne logge ind via denne identity provider. Eksisterende tilknyttede SAML-identiteter for denne provider vil også blive fjernet.",
        "title": "Slet SAML-forbindelse"
      },
      "deleted": "SAML-forbindelse slettet",
      "disabled": "Deaktiveret",
      "edit_provider": "Rediger provider",
      "empty": {
        "description": "Tilføj en SAML-provider, så inviterede adminbrugere kan starte SSO fra login-siden.",
        "title": "Ingen SAML-providere"
      },
      "enabled": "Aktiveret",
      "entity_id": "Entity ID",
      "entity_id_instruction": "Brug entityID-værdien fra metadata-URL'en.",
      "existing_users_only": "SAML-login virker kun for eksisterende inviterede adminbrugere i dette workspace.",
      "form": {
        "app_federation_metadata_url": "App federation metadata-URL",
        "app_federation_metadata_url_placeholder": "https://example.com/federationmetadata.xml",
        "email_attribute": "E-mail-attribut",
        "email_attribute_placeholder": "email",
        "enabled": "Aktiver provider",
        "enabled_help": "Aktiverede providere kan bruges fra login-siden.",
        "first_name_attribute": "Fornavn-attribut",
        "first_name_attribute_placeholder": "firstName",
        "idp_entity_id": "IdP entity ID",
        "idp_entity_id_placeholder": "https://idp.example.com/entity",
        "idp_login_url": "IdP-login-URL",
        "idp_logout_url": "IdP-logout-URL",
        "idp_x509_certificate": "IdP X.509-certifikat",
        "idp_x509_certificate_help": "Det nuværende certifikat kan ikke vises igen. Lad feltet være tomt for at beholde det, eller indsæt et nyt certifikat for at opdatere det.",
        "idp_x509_certificate_placeholder": "Indsæt certifikatet fra din identitetsudbyder",
        "idp_x509_certificate_update": "Opdater certifikat",
        "last_name_attribute": "Efternavn-attribut",
        "last_name_attribute_placeholder": "lastName",
        "login_type": "Kræv SAML for",
        "login_type_employee": "Hub-brugere",
        "login_type_employee_description": "Brug SAML til medarbejderlogin i læringshubben.",
        "login_type_user": "Adminbrugere",
        "login_type_user_description": "Brug SAML til adminlogin i adminområdet.",
        "name": "Navn",
        "name_id_format": "Name ID-format",
        "name_placeholder": "Microsoft Entra ID",
        "provider": "Provider",
        "url_placeholder": "https://idp.example.com/sso"
      },
      "idp_entity_id": "IdP entity ID",
      "login_url": "Login-URL",
      "metadata_url": "Metadata-URL",
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      },
      "read": {
        "description": "Kopiér disse værdier ind i din identitetsudbyderopsætning.",
        "title": "SAML-konfiguration"
      },
      "save_provider": "Gem provider",
      "saved": "SAML-provider gemt",
      "subtitle": "Konfigurer identitetsudbydere til SSO.",
      "table": {
        "delete": "Slet",
        "edit": "Rediger",
        "name": "Navn",
        "provider": "Provider",
        "provider_id": "Provider-ID",
        "status": "Status"
      },
      "title": "SAML single sign-on"
    },
    "simulation": {
      "ceo_fraud": {
        "ceo": {
          "text": "Indtast kontaktoplysningerne på jeres administrerende direktør (eller tilsvarende)",
          "title": "Administrerende direktør (CEO)"
        },
        "cfo": {
          "text": "Indtast kontaktoplysningerne på jeres økonomidirektør (eller tilsvarende)",
          "title": "Økonomidirektør (CFO)"
        },
        "cto": {
          "text": "Indtast kontaktoplysningerne på jeres teknologichef (eller tilsvarende)",
          "title": "Teknologichef (CTO)"
        },
        "info": "Vi bruger nedenstående oplysninger til at tilpasse vores simulerede direktørsvindel til jeres organisation. Hvis ikke oplysningerne udfyldes, benytter vi standardværdier.",
        "subtitle": "Indstillinger for simuleret direktørsvindel.",
        "title": "Direktørsvindel"
      },
      "dmi": {
        "google": {
          "alert_text": "Sørg for at konfigurere DMI i Google Workspace, før du aktiverer det her.",
          "subtitle": "Opsæt DMI i Google Workspace for at indsætte simulationse-mails direkte til Gmail-indbakker.",
          "title": "DMI for Google Workspace",
          "toggle": {
            "help": "Konfigurer DMI i Google Workspace, og aktivér derefter her, når opsætningen er fuldført.",
            "label": "Aktivér DMI"
          }
        }
      },
      "search": {
        "placeholder": "Søg efter tjenester",
        "results": "Søgeresultater for: {query}"
      },
      "services": {
        "credential_harvest": "Loginside",
        "selector": {
          "dialog_title": "Rediger tjenester",
          "edit_button": "Rediger tjenester",
          "title": "Ingen tjenester aktiveret | Én tjeneste aktiveret | {count} tjenester aktiveret",
          "update_services": "Opdater tjenester"
        },
        "subtitle": "Indstillinger for målretning baseret på brug af software.",
        "title": "Software målretning"
      },
      "training": {
        "download": {
          "subtitle": "Download domæner, der bruges i vores phishing-simulationer.",
          "title": "Download simulationsdomæner"
        },
        "local_ratio": {
          "help": "Ved 70 % får en tysktalende medarbejder 70 % tyske skabeloner og 30 % engelske.",
          "subtitle": "Bestem, hvordan skabeloner fordeles mellem hver medarbejders sprog og engelsk. Når funktionen er slået fra, er der ikke noget fast forhold.",
          "title": "Skabeloner på medarbejdernes sprog"
        },
        "subtitle": "Indstillinger for simulationsmål og sporing.",
        "title": "Generelt",
        "toggle": {
          "subtitle": "Send automatisk træningsøvelser til medarbejdere",
          "title": "Automatisk træning"
        }
      }
    },
    "simulations": {
      "ceo_fraud": {
        "ceo_email": {
          "label": "Email"
        },
        "ceo_name": {
          "label": "Navn"
        },
        "cfo_email": {
          "label": "Email"
        },
        "cfo_name": {
          "label": "Navn"
        },
        "cto_email": {
          "label": "Email"
        },
        "cto_name": {
          "label": "Navn"
        }
      },
      "enable_ceo_fraud": "Aktivér CEO-svindel",
      "enable_module_help": "Aktivér dette modul for arbejdsområdet.",
      "enable_software_targeting": "Aktivér softwaremålretning"
    },
    "tables": {
      "reports": {
        "frequency": "Frekvens",
        "period": "Periode",
        "recipient": "Modtager",
        "status": "Status",
        "type": "Type"
      },
      "scim": {
        "actions": "Handlinger",
        "created": "Oprettet",
        "default_mapping": "Standardmapping",
        "effective_mapping": "Effektiv mapping",
        "last_used": "Sidst brugt",
        "name": "Navn",
        "provider": "Udbyder",
        "status": "Status",
        "sync_type": "Type"
      },
      "tokens": {
        "created": "Oprettet",
        "last_used": "Sidst anvendt",
        "name": "Navn"
      },
      "users": {
        "created": "Oprettet",
        "role": "Rolle",
        "status": "Status",
        "two_factor": "2FA",
        "user": "Bruger"
      }
    },
    "threats": {
      "advanced_settings": {
        "hide": "Skjul avancerede indstillinger",
        "show": "Vis avancerede indstillinger"
      },
      "alias_email": {
        "help": "Vi foreslår at, i som virksomhed, opretter en mere brugervenlig aliasversion af den indgående e-mail-adresse. For eksempel security{'@'}example.com",
        "label": "Alias email",
        "placeholder": "security{'@'}example.com"
      },
      "clustering": {
        "title": "Trusselsklyngning"
      },
      "enable_defender_integration": {
        "help": "Videresend rapporterede phishing emails til Microsoft Defender.",
        "label": "Aktivér Microsoft Defender integration",
        "title": "Microsoft Defender"
      },
      "enable_forwarding": {
        "help": "Videresend trusler til en bestemt e-mailadresse.",
        "title": "Aktiver videresendelse af trusler"
      },
      "enable_grouped_threat_status_transitions": {
        "help": "Når funktionen er aktiveret, får nyoprettede trusler samme status som deres relaterede trussel",
        "title": "Aktivér automatisk statusovergang for trusler i klynger"
      },
      "enable_notifications": {
        "help": "Modtag en notifikation når en potentiel trussel rapporteres",
        "title": "Aktiver notifikationer"
      },
      "enable_third_party_submission": {
        "help": "Aktiver tredjeparts indsendelse af phishing-angreb til Microsoft og Google.",
        "title": "Aktiver tredjepartsindsendelse"
      },
      "enable_threat_management": {
        "help": "Aktiver truslehåndtering for denne konto.",
        "title": "Aktiver truslehåndtering"
      },
      "forward_reported_emails_to": {
        "label": "Videresend rapporterede e-mails til:",
        "placeholder": "reported{'@'}company.com"
      },
      "forward_to": {
        "label": "Videresend til:",
        "placeholder": "phishing{'@'}company.com"
      },
      "forwarding": {
        "defender": {
          "description": "Videresend rapporterede phishing-mails til Microsoft Defender.",
          "title": "Videresend til Defender"
        },
        "disabled": {
          "description": "Videresend ikke rapporterede trusler.",
          "title": "Deaktiver videresendelse"
        },
        "email": {
          "description": "Send rapporterede trusler til en bestemt e-mailadresse.",
          "title": "Videresend til e-mail"
        },
        "title": "Trusselvideresendelse"
      },
      "forwarding_warning": "Når videresendelse af trusler er aktiveret, vil rapporterede trusler være skrivebeskyttede i adminpanelet. Der vil ikke blive udført analyse af Moxso.",
      "inbound_email": {
        "help": "Denne rapporterings-e-mail er unik for jeres virksomhed. Alle e-mails sendt til denne adresse vil blive analyseret af Moxso.",
        "label": "Indgående e-mail"
      },
      "save_forwarded_emails": {
        "help": "Når dette er aktiveret, bliver videresendte emails gemt.",
        "label": "Gem videresendte trusler"
      },
      "subtitle": "Indstillinger for threat management.",
      "threat_grouping_confidence": {
        "help": "Styrer, hvor tæt trusler skal matche, før de samles i en klynge.",
        "label": "Konfidensniveau for trusselsklynger",
        "options": {
          "high": "Høj",
          "low": "Lav",
          "medium": "Mellem"
        }
      },
      "title": "Threat management"
    },
    "two_factor": {
      "actions": {
        "disable": "Deaktiver tofaktorgodkendelse",
        "enable": "Aktiver tofaktorgodkendelse",
        "regenerate_recovery_codes": "Generer gendannelseskoder igen",
        "view_recovery_codes": "Vis gendannelseskoder"
      },
      "disabled": {
        "badge": "Fra",
        "text": "Beskyt denne adminkonto med en kode fra en godkender-app eller password manager.",
        "title": "Tofaktorgodkendelse er slået fra"
      },
      "enabled": {
        "badge": "Til",
        "text": "Denne adminkonto kræver en ekstra faktor ved login.",
        "title": "Tofaktorgodkendelse er aktiveret"
      },
      "password_dialog": {
        "cancel": "Annuller",
        "cancel-setup": {
          "button": "Annuller opsætning",
          "description": "Bekræft din nuværende adgangskode for at annullere den igangværende tofaktoropsætning.",
          "title": "Annuller tofaktoropsætning"
        },
        "current_password": "Nuværende adgangskode",
        "disable": {
          "button": "Deaktiver",
          "description": "Bekræft din nuværende adgangskode for at deaktivere tofaktorgodkendelse for denne konto.",
          "title": "Deaktiver tofaktorgodkendelse"
        },
        "enable": {
          "button": "Fortsæt",
          "description": "Bekræft din nuværende adgangskode, før du opsætter tofaktorgodkendelse.",
          "title": "Aktiver tofaktorgodkendelse"
        },
        "regenerate-recovery-codes": {
          "button": "Generer koder igen",
          "description": "Bekræft din nuværende adgangskode for at erstatte dine eksisterende gendannelseskoder.",
          "title": "Generer gendannelseskoder igen"
        },
        "show-recovery-codes": {
          "button": "Vis koder",
          "description": "Bekræft din nuværende adgangskode for at se dine gendannelseskoder.",
          "title": "Vis gendannelseskoder"
        }
      },
      "recovery_codes": {
        "copied": "Kopieret",
        "copy": "Kopiér koder",
        "text": "Gem disse engangskoder i din password manager. De vises ikke her igen, når du lukker dem.",
        "title": "Gendannelseskoder"
      },
      "setup": {
        "cancel": "Annuller opsætning",
        "code_label": "Godkendelseskode",
        "code_placeholder": "123456",
        "confirm": "Bekræft",
        "manual_key": "Manuel opsætningsnøgle",
        "qr_alt": "QR-kode til tofaktoropsætning",
        "text": "Scan QR-koden med din godkender-app eller password manager, og indtast derefter den 6-cifrede kode, den genererer.",
        "title": "Opsæt din godkender"
      },
      "subtitle": "Kræv en ekstra faktor ved login til din adminkonto.",
      "title": "Tofaktorgodkendelse"
    },
    "workspace": {
      "lms": {
        "subtitle": "Konfigurer en brugerdefineret indholds-URL til at omdirigere brugere til en ekstern læringsplatform.",
        "title": "Eksternt LMS"
      },
      "logging": {
        "activity": "Aktivitet",
        "columns": {
          "action_time": "Handlingstidspunkt",
          "action_type": "Handlingstype",
          "actor": "Aktør",
          "zone": "Zone"
        },
        "moxso_support": "Moxso support",
        "partner": "Partner",
        "slideover": {
          "actor": "Aktør",
          "app": "App",
          "audit_log": "Revisionslog",
          "created": "Oprettet",
          "email": "Email",
          "event": "Hændelse",
          "impersonated_by_support": "Impersoneret af support",
          "ip_address": "IP-adresse",
          "name": "Navn",
          "no": "Nej",
          "path": "Sti",
          "request": "Forespørgsel",
          "summary": "Oversigt",
          "tabs": {
            "request": "Forespørgsel",
            "summary": "Oversigt og aktør"
          },
          "title": "Hændelse",
          "type": "Type",
          "user_agent": "User agent",
          "yes": "Ja"
        },
        "subtitle": "Se historikken over ændringer foretaget på denne konto.",
        "title": "Revisionslogge"
      },
      "scim": {
        "attribute_mapping": {
          "subtitle": "Tilsidesæt understøttede SCIM-attributmål for denne forbindelse. Tomme rækker bruger backendens standardmapping.",
          "title": "Attributmapping"
        },
        "connection_settings": {
          "subtitle": "Administrer udbyder, navn og aktiveret status for den valgte SCIM-forbindelse.",
          "title": "Forbindelsesindstillinger"
        },
        "connections": {
          "disabled": "Deaktiveret",
          "enabled": "Aktiveret",
          "subtitle": "Konfigurer identitetsudbyderforbindelser til automatiseret SCIM-provisionering af brugere og grupper.",
          "title": "SCIM-forbindelser"
        },
        "endpoint": {
          "label": "Tenant-URL",
          "subtitle": "Brug denne base-URL i din identitetsudbyder. Tilføj ikke Users, Groups eller ServiceProviderConfig til URLen.",
          "title": "Provisioneringsendpoint"
        },
        "tokens": {
          "subtitle": "Opret bearer-tokens til Microsoft Entra ID, Okta eller en anden SCIM v2-identitetsudbyder.",
          "title": "SCIM-provisioneringstokens"
        }
      },
      "subtitle": "Indstillinger for din virksomhed.",
      "title": "Kontoindstillinger",
      "tokens": {
        "subtitle": "Få sikker adgang til Moxso's data warehouse fra dine apps og tjenester.",
        "title": "Data warehouse"
      },
      "user": {
        "two_factor_disabled": "Deaktiveret",
        "two_factor_enabled": "Aktiveret",
        "verification_required": "Afventer bekræftelse",
        "verified": "Bekræftet"
      },
      "users": {
        "subtitle": "Indstillinger for dine brugere.",
        "title": "Brugere"
      }
    }
  },
  "simulations": {
    "audience_missing_phone_numbers_all": "Ingen af medarbejderne i den valgte målgruppe har telefonnumre. Ændr målgruppen eller tilføj telefonnumre, og prøv igen.",
    "audience_missing_phone_numbers_some": "Én medarbejder ud af {total} i den valgte målgruppe mangler et telefonnummer. | {count} medarbejdere ud af {total} i den valgte målgruppe mangler telefonnumre.",
    "click_rate": {
      "title": "Klikrate"
    },
    "clicked": "Klik",
    "count": {
      "title": "Behandlede simulationer",
      "unit": "Simulationer"
    },
    "create": {
      "button": "Opret simulation",
      "configuration": {
        "choose_type": "Tilbage",
        "text": "Definér målgruppen og indstillingerne for denne simulering.",
        "title": "Konfigurer din simulation",
        "token": "Indstil en brugerdefineret e-mail-header til allowlisting. Dit token vil blive tilføjet som en {token} header på hver e-mail sendt fra denne simulation."
      },
      "credential_harvest": {
        "description": "Når funktionen er aktiveret, modtager medarbejdere kun simuleringer, der indeholder loginsider. Moxso overvåger formularindsendelser, men gemmer aldrig indtastede adgangsoplysninger.",
        "enable_label": "Aktiver credential harvest",
        "title": "Credential harvest"
      },
      "delivery_rate": {
        "high": {
          "email_description": "1-2 uger imellem emails",
          "sms_description": "1-2 dage imellem sms-beskeder",
          "title": "Høj"
        },
        "low": {
          "email_description": "1-6 uger imellem emails",
          "sms_description": "1-6 dage imellem sms-beskeder",
          "title": "Lav"
        },
        "medium": {
          "email_description": "1-4 uger imellem emails",
          "sms_description": "1-4 dage imellem sms-beskeder",
          "title": "Mellem"
        }
      },
      "help": {
        "audience": "Vælg målgruppen der skal modtage simulationen",
        "email_delivery_rate": "Angiver intervallet mellem de emails, der sendes som en del af denne simulering. Frekvensen tilpasses inden for den valgte indstilling baseret på medarbejdernes præstation.",
        "sms_delivery_rate": "Angiver intervallet mellem de sms-beskeder, der sendes som en del af denne simulering. Frekvensen tilpasses inden for den valgte indstilling baseret på medarbejdernes præstation.",
        "staggered_delivery": "Simulationer leveres tilfældigt på hverdage inden for det valgte antal dage.",
        "test": "Test simulationer påvirker ikke træning eller statistikken."
      },
      "labels": {
        "audience": "Målgruppe",
        "delivery": "Frekvens",
        "delivery_rate": "Leveringsfrekvens",
        "name": "Navn",
        "preview": "Forhåndsvisning",
        "schedule_type": "Leveringsplan",
        "staggered_delivery": "Forskudt levering",
        "template": "Skabelon",
        "test": "Marker som test",
        "token": "Token",
        "token_header": "Indstil en brugerdefineret e-mail-header",
        "use_template": "Brug skabelon"
      },
      "placeholders": {
        "audience": "Vælg venligst en målgruppe",
        "name": "Simulationsnavn",
        "token": "ABC-123"
      },
      "random_template": "Tilfældig skabelon",
      "remove_template": "Fjern skabelon",
      "step_current_of_last": "Step {current_step} af {last_step}",
      "type": {
        "button": "Næste",
        "email": {
          "text_plural": "Send simuleringer som e-mail",
          "text_singular": "Send simulering som e-mail",
          "title": "E-mail"
        },
        "help": {
          "delivery_method": "Vælg, hvordan simuleringen skal leveres",
          "schedule_type": "Vælg, hvor ofte denne simulering skal køre"
        },
        "labels": {
          "delivery_method": "Leveringsmetode",
          "schedule_type": "Leveringsplan"
        },
        "one_off": {
          "text": "Alle i målgruppen modtager et angreb, når simulationen startes",
          "title": "Enkeltstående simulation"
        },
        "recurring": {
          "text": "Angreb afsendes hver måned, indtil simulationen deaktiveres",
          "title": "Automatisk simulation"
        },
        "sms": {
          "text_plural": "Send simuleringer som SMS",
          "text_singular": "Send simulering som SMS",
          "title": "SMS"
        },
        "text": "Definer planlægning og leveringsmetode for denne simulering.",
        "title": "Opsæt levering af simuleringen"
      }
    },
    "delete": {
      "are_you_sure": "Er du sikker på, at du vil slette denne simulering? Handlingen kan ikke fortrydes.",
      "button": "Slet simulering",
      "simulation_deleted": "Simulering slettet"
    },
    "details": {
      "heading": "Oversigt",
      "text": "Simuleringsoversigt"
    },
    "edit": {
      "button": "Rediger indstillinger",
      "button_save": "Gem indstillinger",
      "campaign_updated": "Simulation opdateret",
      "title": "Rediger simulation"
    },
    "filter": {
      "status": {
        "all": "Status: Alle",
        "click": "Status: Klikket",
        "report": "Status: Rapporteret",
        "submission": "Status: Submission"
      }
    },
    "launch": {
      "button": "Start simulation",
      "input_label": "Angiv antallet af modtagere",
      "launched": "Simulation startet",
      "no_recipients": "Den valgte målgruppe har ingen medlemmer. Juster venligst målgruppen og prøv igen.",
      "no_recipients_title": "Ingen medlemmer",
      "title": "Start simulation",
      "warning": "Du er ved at starte en simulation, der vil blive sendt til {count} modtagere. Er du sikker på, at du vil fortsætte?"
    },
    "opened": "Åben",
    "pause": "Sæt på pause",
    "pause_confirmation": {
      "results": "Resultater fra allerede udsendte simulationer bevares.",
      "title": "Sæt simulationen på pause?",
      "warning": "Når du sætter simulationen på pause, annulleres {count} planlagt udsendelse. Når du genoptager den, erstatter en ny tidsplan de oprindelige udsendelsesdatoer. Medarbejderne kan derfor komme til at vente længere på deres næste simulation. | Når du sætter simulationen på pause, annulleres {count} planlagte udsendelser. Når du genoptager den, erstatter en ny tidsplan de oprindelige udsendelsesdatoer. Medarbejderne kan derfor komme til at vente længere på deres næste simulation."
    },
    "play": "Genoptag simulation",
    "received": "Modtaget",
    "report_rate": {
      "title": "Rapporteringsrate"
    },
    "reported": "Rapporteret",
    "scheduled": "Planlagt",
    "send_test": "Send test",
    "send_test_tooltip": "Send en test email til {userEmail}",
    "staggered_delivery": {
      "days": "{count} dag | {count} dage",
      "off": "Fra"
    },
    "stop": {
      "button": "Stop simulering",
      "simulation_stopped": "Simulering stoppet",
      "title": "Stop simuleringen?",
      "warning": "Hvis du stopper simuleringen, annulleres alle resterende planlagte leveringer. Resultater fra simuleringer, der allerede er sendt, bevares. Er du sikker på, at du vil fortsætte?"
    },
    "submission_disabled": "Deaktiveret",
    "submission_enabled": "Aktiveret",
    "submission_rate": {
      "title": "Loginrate"
    },
    "submitted": "Login",
    "summary": {
      "credential_harvest": "Credential harvest",
      "delivery_method": "Leveringsmetode",
      "delivery_rate": "Leveringsfrekvens",
      "group": "Målgruppe",
      "schedule_type": "Leveringsplan",
      "staggered_delivery": "Forskudt levering",
      "test": "Test simulation",
      "type": "Type"
    },
    "templates": {
      "create": {
        "button": "Opret skabelon",
        "success_text": "Skabelon oprettet",
        "title": "Opret skabelon"
      },
      "duplicate": {
        "button": "Duplikér",
        "subject": "Kopi",
        "success_text": "Skabelon duplikeret",
        "title": "Duplikér simuleringsskabelon"
      },
      "edit": {
        "button": "Gem skabelon",
        "success_text": "Skabelon gemt",
        "title": "Rediger skabelon"
      },
      "editor": {
        "ai_modal": {
          "button": "Generer",
          "placeholder": "Beskriv den simuleringsskabelon, du vil generere...",
          "title": "Generer skabelon ved hjælp af AI"
        },
        "attack_link": "Angrebslink",
        "attack_link_already_applied": "Angrebslinks anvendes automatisk på knapper.",
        "buttons": {
          "generate": "Generer",
          "send_preview": "Send mig en forhåndsvisning"
        },
        "change_image": "Skift billede",
        "default_block_content": {
          "button": "Gennemgå nu",
          "container_text": "Indsæt indhold her",
          "footer_text": "Du modtager denne e-mail, fordi du er ansat hos ::workspace.name::.",
          "heading_1": "Overskrift 1",
          "heading_2": "Overskrift 2",
          "heading_3": "Overskrift 3",
          "image_alt": "Billede",
          "text": "Skriv din besked her.",
          "unsubscribe": "Afmeld"
        },
        "generating_template": "Genererer skabelon",
        "google_dmi_enabled": "Direct message injection er aktiveret",
        "insert_image": "Indsæt billede",
        "labels": {
          "custom_domain": "Brugerdefineret domæne",
          "email": "Email",
          "select_domain": "Vælg et domæne",
          "sender": "Afsender",
          "string_templates": {
            "date_last_month": "Samme dag sidste måned",
            "date_last_week": "Samme dag sidste uge",
            "date_last_year": "Samme dag sidste år",
            "date_next_month": "Samme dag næste måned",
            "date_next_week": "Samme dag næste uge",
            "date_next_year": "Samme dag næste år",
            "date_today": "I dag",
            "date_tomorrow": "I morgen",
            "date_yesterday": "I går",
            "department": "Afdeling",
            "email": "Email",
            "first_name": "Fornavn",
            "last_name": "Efternavn",
            "manager_email": "Manager email",
            "manager_first_name": "Manager fornavn",
            "manager_last_name": "Manager efternavn",
            "workspace_address": "Virksomhed addresse",
            "workspace_city": "Virksomhed by",
            "workspace_name": "Virksomhed",
            "workspace_postal_code": "Virksomhed postnummer"
          },
          "subject": "Emne"
        },
        "no_image_selected": "Intet billede valgt",
        "placeholders": {
          "custom_domain": "example.com",
          "email": "Afsender navn",
          "sender_name": "Afsender navn (fx. Anna Andersen)",
          "subject": "Indtast emne her"
        },
        "preview_sent_success": "Preview-email sendt.",
        "qr_code": "QR-kode",
        "sidebar": {
          "blocks": "Blokke",
          "no_tags_found": "Ingen tags fundet",
          "settings": "Indstillinger",
          "settings_title": "Indstillinger for valgt blok",
          "style": "Design",
          "style_title": "Skabelondesign",
          "tags": "Tags",
          "variables_title": "Flettemærker"
        },
        "sidebar_field_options": {
          "center": "Centreret",
          "fixed": "Fast bredde",
          "full_width": "Fuld bredde",
          "left": "Venstre",
          "right": "Højre"
        },
        "sidebar_fields": {
          "alt_text": "Alt-tekst",
          "auto": "Automatisk",
          "background_color": "Baggrundsfarve",
          "border_radius": "Hjørneradius",
          "button_dimensions_hint": "Mål er i pixels. Sæt bredde eller højde til 0 for at tilpasse til teksten.",
          "button_min_height": "Minimumshøjde",
          "color": "Farve",
          "column_width": "Bredde på kolonne {column} (%)",
          "columns": "Kolonner",
          "content_alignment": "Justering",
          "content_width_mode": "Bredde",
          "font_size": "Skriftstørrelse",
          "gap": "Mellemrum",
          "height": "Højde",
          "image_url": "Billede",
          "padding": "Indvendig afstand",
          "text_color": "Tekstfarve",
          "thickness": "Tykkelse",
          "width": "Bredde"
        },
        "sidebar_placeholders": {
          "alt_text": "Describe the image",
          "button_label": "Review now",
          "legal_copy": "You are receiving this email because you are an employee of ::workspace.name::."
        },
        "tooltip_fill_out_all_fields": "Udfyld alle felter for at sende et preview",
        "tooltip_this_will_save_the_template": "Dette vil gemme skabelonen",
        "unsaved_changes": {
          "confirm_exit": "Du har ikke-gemte ændringer. Er du sikker på, at du vil afslutte?",
          "description": "Du har ikke-gemte ændringer. Hvis du forlader siden uden at gemme, vil dine ændringer gå tabt.",
          "discard": "Kassér ændringer",
          "save_and_exit": "Gem og forlad",
          "subtile": "Gem før du forlader siden?",
          "title": "Ikke gemte ændringer"
        },
        "unsaved_changes_badge": "Ikke gemte ændringer"
      }
    },
    "test_sent": "Test email afsendt",
    "tooltip": {
      "click": "Der blev klikket på et link",
      "open": "Denne simulation blev åbnet",
      "report": "Denne simulation blev rapporteret",
      "submit": "Der blev logget ind"
    },
    "updated": "Simulation opdateret"
  },
  "statistics": {
    "activities_by_type": {
      "completed_courses": "Gennemførte kurser",
      "phishing_quiz_correct_answers": "Korrekte phishing-quiz svar",
      "phishing_quiz_incorrect_answers": "Forkerte phishing-quiz svar",
      "quiz_answers": "Quiz-svar",
      "quiz_correct_answers": "Korrekte quiz-svar",
      "quiz_incorrect_answers": "Forkerte quiz-svar",
      "simulations_delivered": "Simulationer leveret",
      "simulations_failed": "Mislykkede simulationer",
      "simulations_passed": "Beståede simulationer",
      "simulations_reported": "Rapporterede simulationer",
      "text": "Hvordan dine medarbejdere træner",
      "threats_reported": "Trusler rapporteret",
      "title": "Udførte aktiviteter",
      "videos_watched": "Videoer set"
    },
    "benchmarks": {
      "above_benchmark_tooltip": "Værdien er over grænseværdien.",
      "average": "Moxso gennemsnit",
      "below_benchmark_tooltip": "Værdien er under grænseværdien.",
      "benchmark_tooltip": "Grænseværdi",
      "peer_avg": "Moxso gennemsnit",
      "score": "Nuværende score",
      "text_higher": "% højere end gennemsnittet på Moxso-netværket.",
      "text_lower": "% lavere end gennemsnittet på Moxso-netværket.",
      "title": "Benchmarks"
    },
    "breaches": {
      "title": "Databrud"
    },
    "competence": {
      "text": "Hvor godt jeres medarbejdere klarer sig i træningen",
      "title": "Kompetence"
    },
    "culture": {
      "text": "Hvor engagerede jeres medarbejdere er i træningen",
      "title": "Kultur"
    },
    "employee_activity": {
      "title": "Medarbejderaktivitet"
    },
    "employees": {
      "title": "Aktive medarbejdere"
    },
    "onboarding": {
      "title": "Onboarding"
    },
    "overdue": {
      "change": "{points} procentpoint ift. {date}",
      "security_program_text": "Procentdel af medarbejdere, der ikke følger deres sikkerhedsprogram (træning, politikker)",
      "security_program_title": "Medarbejdere, der er bagud med sikkerhedsprogrammet",
      "text": "Procentdel af aktive medarbejdere med overskredne træningsdeadlines",
      "title": "Overskredne deadlines",
      "unit": "Forfaldne træningsøvelser"
    },
    "recent_activity": "Seneste aktivitet",
    "resilience_score": {
      "change_last_90_days": "{value}% de seneste 90 dage",
      "text": "Individuel score for denne medarbejder baseret på simulationer og træning.",
      "title": "Modstandsdygtighed"
    },
    "resilience_score_progression": {
      "title": "Modstandsdygtighed over tid"
    },
    "risk_level": {
      "country": "Land",
      "text": "Risikoniveauet bestemmes af land, organisation og et syntetiseret risikoniveau, hvilket giver indsigt i det aktuelle trusselslandskab.",
      "title": "Risikoniveau",
      "workspace": "Organisation"
    },
    "show_more": "Se mere",
    "simulation_coverage": {
      "title": "Omfang af simulationer"
    },
    "simulations": {
      "campaign_overview": "Kampagneoverblik",
      "click_count": {
        "text": "Antallet af gange en simulation er blevet klikket.",
        "title": "Antal klik",
        "unit": "Klik"
      },
      "click_rate": {
        "text": "Beregnet score baseret på procentdelen af klik i forhold til antallet af e-mails sendt.",
        "title": "Klikrate",
        "unit": "%"
      },
      "count": {
        "text": "Det totale antal simulationer sendt.",
        "title": "Antal simulationer",
        "unit": "Simulationer"
      },
      "performance_metrics": "Performance-målinger",
      "reporting_count": {
        "text": "Det totale antal simulationer rapporteret.",
        "title": "Antal rapporteret",
        "unit": "Rapporter"
      },
      "reporting_rate": {
        "text": "Beregnet score baseret på procentdelen af rapporterede e-mails i forhold til antallet af e-mails sendt.",
        "title": "Rapporteringsrate",
        "unit": "%"
      },
      "submission_count": {
        "text": "Det totale antal logins registreret.",
        "title": "Antal logins",
        "unit": "Logins"
      },
      "submission_rate": {
        "text": "Beregnet score baseret på procentdelen af logins i forhold til antallet af e-mails sendt.",
        "title": "Login-rate",
        "unit": "%"
      },
      "submission_sent_count": "Antal login-simulationer"
    },
    "simulations_sent": {
      "title": "Sendte simulationer"
    },
    "threats": {
      "count": {
        "text": "Antal trusler indrapporteret af medarbejdere.",
        "title": "Trusler indrapporteret"
      },
      "fraud_count": {
        "text": "Antal potentielle angreb, der er blevet rapporteret af medarbejdere.",
        "title": "Potentielle angreb"
      },
      "handle_rate": {
        "text": "Beregnet score baseret på procentdelen af rapporterede e-mails, der er blevet håndteret af en medarbejder.",
        "title": "Trusselshåndteringsrate"
      },
      "reporting_rate": {
        "title": "Trusler indrapporteret"
      },
      "status_partition": {
        "title": "Trusselsstatus"
      },
      "text": "Hvor gode jeres medarbejdere er til at håndtere trusler",
      "time_to_handle": {
        "text": "Den gennemsnitlige tid, det tager for dine medarbejdere at håndtere en trussel.",
        "title": "Håndteringstid"
      },
      "title": "Trusselshåndtering"
    },
    "timeframe_nienty_days": "I de sidste 90 dage",
    "training": {
      "courses": {
        "title": "Kurser",
        "unit": "Kurser gennemført"
      },
      "phishing_quizzes": {
        "title": "Phishing quizzer"
      },
      "quizzes": {
        "title": "Quizzer"
      },
      "video_quizzes": {
        "title": "Video quizzer"
      },
      "videos": {
        "title": "Videoer",
        "unit": "Videoer gennemført"
      }
    },
    "training_coverage": {
      "text": "Beregnet score baseret på procentdelen af medarbejdere, der har gennemført sikkerhedstræning.",
      "title": "Omfang af træning"
    }
  },
  "tables": {
    "anonymized_at": "Anonymiseret den",
    "audience": "Målgruppe",
    "audit_completed_status": "Bekræftet den",
    "available_at": "Tilgængelig den",
    "breached_at": "Oprettelsesdato",
    "completed_at": "Gennemførselsdato",
    "created": "Oprettet",
    "created_at": "Oprettelsesdato",
    "deadlines": {
      "deadline": "Deadline",
      "employee": "Medarbejder",
      "last_learning_interaction": "Seneste interaktion",
      "lesson": "Lektion",
      "reminder_sent": "Seneste påmindelse"
    },
    "delivery_method": "Leveringsmetode",
    "deselect_all": "Fravælg alle",
    "domain": "Domæne",
    "employee": "Medarbejder",
    "employees": "Medarbejdere",
    "enrolled_at": "Tilmeldingsdato",
    "error_count": "Sprunget over",
    "filters": {
      "back": "Tilbage",
      "boolean": "{column} er {toggle}",
      "data": "Filtrer data",
      "false": "Falsk",
      "filter_by": "Filtrer efter",
      "group": "Filtrer efter gruppe",
      "numberRange": "{column} fra {minValue} til {maxValue}",
      "search": "Søg",
      "select_date": "Vælg dato",
      "status": "Status",
      "training_type": "Type",
      "true": "Sand"
    },
    "group": "Gruppe",
    "groups": "Grupper",
    "invited": "Inviteret",
    "languages": "Sprog",
    "last_sent_at": "Sidst sendt",
    "lesson_status": "Lektionsstatus",
    "locale": "Sprog",
    "name": "Navn",
    "overdue": "Forfalden",
    "published_at": "Udgivelsesdato",
    "report_count": "Antal rapporter",
    "reports": "Rapporteret",
    "scheduled_at": "Planlagt",
    "score": "Score",
    "sensitivity": "Følsomhedsniveau",
    "sent_to_count": "Angreb",
    "status": "Status",
    "synced_count": "Synkroniseret",
    "title": "Titel",
    "unique_click_count": "Klik",
    "unique_submission_count": "Logins",
    "updated_at": "Sidst opdateret"
  },
  "threats": {
    "analysis": {
      "attachments": {
        "files": "Filer",
        "subtitle": "Vedhæftede filer",
        "title": "Vedhæftninger"
      },
      "indicators": {
        "common": {
          "heading": "Almindelige trusler",
          "help": "E-mailindholdet nævner virksomhedsnavne, der ofte bruges til phishing."
        },
        "credentials": {
          "heading": "Legitimationsoplysninger",
          "help": "E-mailindholdet nævner legitimationsoplysninger eller adgangskoder."
        },
        "detected": "Detekteret",
        "homoglyphs": {
          "heading": "Homoglyffer",
          "help": "Afsenderens navn eller e-mail indeholder homoglyffer."
        },
        "inconsistency": {
          "heading": "Inkonsistens",
          "help": "Inkonsistens i links og/eller afsenderinformation."
        },
        "no_data": "Ingen data",
        "not_detected": "Ikke detecteret",
        "subtitle": "Trusselsindikatorer",
        "title": "Indikatorer",
        "urgency": {
          "heading": "Socialt pres",
          "help": "E-mailindholdet indeholder sprog der lægger pres på modtageren til at foretage en handling."
        }
      },
      "links": {
        "button": "Browser isolation",
        "empty": "Ingen links fundet",
        "showing_links": "Viser {shown} af {total} links",
        "subtitle": "Links der optræder i e-mailen",
        "title": "Links"
      },
      "preview": {
        "not_available": {
          "description": "E-mail forhåndsvisning er ikke tilgængelig for denne trussel.",
          "title": "E-mail forhåndsvisning ikke tilgængelig"
        },
        "subtitle": "E-mail forhåndsvisning",
        "title": "Email"
      },
      "sender": {
        "domain": "Domæne",
        "email": "E-mailadresse",
        "empty": "Ingen afsender analyse fundet",
        "ip": "IP-adresse",
        "mx": "DNS MX",
        "subtitle": "Analyse af afsender",
        "title": "Afsender",
        "type": "Type",
        "type_text": {
          "free": "Gratis service",
          "paid": "Betalt service"
        }
      }
    },
    "anonymized": {
      "title": "Trussel anonymiseret"
    },
    "browser_isolation": {
      "button": "Åbn link i browser isolation",
      "copied": "Link kopieret til udklipsholder",
      "heading": "Browser isolation",
      "host": "vært",
      "notice": "BrowserLing er en tredjepartstjeneste, der leverer et sikkert miljø til åbning af links. Ved at klikke på knappen nedenfor, vil du blive omdirigeret til BrowserLings hjemmeside. Moxso er ikke tilknyttet BrowserLing og kan ikke holdes ansvarlig for noget indhold eller nogen aktivitet, der finder sted på BrowserLings hjemmeside.",
      "path": "sti",
      "scheme": "skema",
      "secured_by": "Sikret af BrowserLing"
    },
    "buttons": {
      "delete": "Slet trussel",
      "download_html": "Download HTML",
      "fraudulent": "Bedrageri",
      "legitimate": "Legitime",
      "mark_as_fraudulent": "Markér som bedrageri",
      "mark_as_legitimate": "Markér som legitim",
      "mark_as_spam": "Markér som spam",
      "notify_reporters": "Underret rapportører",
      "notify_reporters_description": "Underret rapportører om, at dette angreb er blevet behandlet.",
      "show_headers": "Vis e-mailhoveder",
      "show_less": "Vis mindre",
      "show_more": "Vis mere",
      "spam": "Spam"
    },
    "comment_added": "Kommentar tilføjet",
    "created_at": "Oprettelsesdato",
    "current": "Nuværende",
    "disabled": {
      "button": "Gå til indstillinger",
      "heading": "Trusselsmodulet er deaktiveret",
      "text": "Hver dag står dine medarbejdere over for trusler i deres indbakker, der kan true sikkerheden i jeres organisation. Giv dit team en sikker måde at advare dig på, så i kan reagere, inden skaden sker."
    },
    "export_csv": {
      "description": "Download inkluderer kun trusler med den valgte status i CSV-eksporten.",
      "subtitle": "Vælg trusselstatus",
      "title": "Download CSV"
    },
    "filter": {
      "status": {
        "all": "Status: Alle",
        "forwarded": "Status: Videresendt",
        "fraudulent": "Status: Bedrageri",
        "legitimate": "Status: Legitime",
        "spam": "Status: Spam",
        "unhandled": "Status: Nye"
      }
    },
    "forwarding_enabled": "Videresendelse aktiveret",
    "forwarding_warning": "Rapporterede trusler er skrivebeskyttede og skal håndteres i et eksternt system.",
    "from": "Afsender",
    "headers": "E-mailhoveder",
    "mark_as": "Marker som:",
    "no_more_unhandled_threats_button": "Afslut",
    "no_more_unhandled_threats_text": "Du har gennemgået alle rapporterede trusler. Din indbakke er nu sikker.",
    "no_more_unhandled_threats_title": "Ikke flere trusler!",
    "note_placeholder": "Tilføj en note til rapportører...",
    "related_threats": "Relaterede trusler",
    "relative_time": {
      "days_ago": "{count} dag siden | {count} dage siden",
      "hours_ago": "{count} time siden | {count} timer siden",
      "minutes_ago": "{count} minut siden | {count} minutter siden"
    },
    "report_information": "Rapportoplysninger",
    "reported_by": "Rapporteret af: {name}",
    "reports": {
      "clicked_link_warning": "Klikkede på et link",
      "phishing": "Phishing",
      "reported_as_phishing": "Rapporteret som phishing",
      "reported_as_spam": "Rapporteret som spam",
      "reporter_note": "Rapportørens note",
      "spam": "Spam"
    },
    "review_next_threat_button": "Gennemgå næste trussel",
    "review_next_threat_text": "Vil du gennemgå den næste ubehandlede trussel?",
    "status_updated": "Status opdateret",
    "subject": "Emne",
    "this_threat_has_been_forwarded": "Denne trussel er blevet videresendt til et eksternt system. Der er ikke udført nogen analyse.",
    "timeline": {
      "analysis_completed": "Analyse afsluttet",
      "button": "Gem",
      "status_transition": "Status ændret fra {from} til {to}",
      "textarea_placeholder": "Skriv en kommentar...",
      "title": "Aktivitet"
    },
    "transition_description": "Bekræft, hvilke rapporter der får denne status.",
    "x_of_n_selected": "{x} af {n} markeret"
  },
  "titles": {
    "automations": {
      "subtitle": "Løbende træningssekvenser",
      "title": "Automatisering"
    },
    "breaches": {
      "subtitle": "Overvåg medarbejdere omfattet af databrud.",
      "title": "Databrud"
    },
    "dashboard": {
      "subtitle": "Overblik over din organisations sikkerhed",
      "title": "Dashboard"
    },
    "group": {
      "subtitle": "Ét aktivt gruppe medlem. | {count} aktive gruppe medlemmer."
    },
    "groups": {
      "subtitle": "Sammensæt grupper med medarbejdere.",
      "title": "Grupper"
    },
    "integrations": {
      "subtitle": "Overblik over integrationer",
      "title": "Integrationer"
    },
    "resilience": {
      "subtitle": "Overblik over din organisations modstandsdygtighed",
      "title": "Modstandsdygtighed"
    },
    "simulations": {
      "custom_templates": {
        "subtitle": "Oversigt over alle dine custom skabeloner",
        "title": "Custom skabeloner"
      },
      "subtitle": "Udfør simulerede phishing-angreb på dine medarbejdere.",
      "title": "Simulationer"
    },
    "team": {
      "subtitle": "Alle medarbejdere tilknyttet din konto.",
      "title": "Medarbejdere"
    },
    "threat": {
      "title": "Trusselrapport"
    },
    "threats": {
      "subtitle": "Overblik over trusler og deres status",
      "title": "Trusler"
    },
    "training": {
      "course": {
        "subtitle": "Overblik over vores kursuskatalog",
        "title": "Kursusoversigt"
      },
      "course_overview": {
        "title": "Kursusoverblik"
      },
      "deadlines": {
        "subtitle": "Overblik over deadlines",
        "title": "Deadlines"
      },
      "participation": {
        "subtitle": "Overblik over deltagelse",
        "title": "Deltagelse"
      },
      "subtitle": "Oversigt over organisationens E-læring",
      "title": "E-læring",
      "video": {
        "subtitle": "Overblik over vores videokatalog",
        "title": "Videooversigt"
      },
      "video_overview": {
        "title": "Videooverblik"
      }
    }
  },
  "training": {
    "actions": {
      "edit": "Rediger",
      "edit_categories": "Rediger kategorier",
      "save": "Gem"
    },
    "completed_status": {
      "completed": "Træning gennemført",
      "not_completed": "Ikke gennemført"
    },
    "course": {
      "text_editor": {
        "actions": {
          "cancel": "Annuller",
          "edit": "Rediger",
          "save": "Gem"
        },
        "ai_prompt": {
          "button": "Tekst editor AI knap",
          "generate": "Generer",
          "label": "Beskriv hvad AI'en skal gøre",
          "placeholder": "\"Fortæl, hvordan teksten skal forbedres...\"",
          "title": "Generer indhold med AI"
        },
        "ai_viewer": {
          "accept": "Accepter",
          "back": "Annuller",
          "caption": "Gennemgå det AI-genererede indhold",
          "generating": "Genererer kursus indhold",
          "heading": "Gennemgå genereret indhold"
        },
        "heading": {
          "description": "Tekst-editor",
          "title": "Trin {step}"
        },
        "labels": {
          "after": "Efter",
          "before": "Før",
          "excerpt": "Undertitel",
          "image_deleted": "Billede fjernet",
          "image_upload": "Billede",
          "image_uploaded": "Billede uploadet",
          "title": "Titel"
        },
        "placeholders": {
          "content": "Skriv dit indhold",
          "excerpt": "Indtast en undertitel",
          "title": "Indtast en titel"
        }
      }
    },
    "courses": {
      "actions": {
        "collapse_all": "Fold alle sammen",
        "delete_course": "Slet kursus",
        "edit": "Rediger",
        "edit_categories": "Rediger kategorier",
        "edit_course": "Rediger kursus",
        "expand_all": "Udvid alle",
        "preview_course": "Forhåndsvis kursus",
        "save": "Gem"
      },
      "add_step": {
        "quiz": "Quizindhold",
        "text": "Tekstindhold",
        "video": "Videoindhold"
      },
      "create": {
        "button": "Opret kursus"
      },
      "create_button": "Opret kursus",
      "create_success": "Kursus oprettet med succes",
      "create_title": "Opret nyt kursus",
      "default_language_badge": "Standard",
      "default_language_label": "Standardsprog",
      "default_language_placeholder": "Vælg standardsprog",
      "delete": {
        "are_you_sure": "Er du sikker på, at du vil slette dette trin? Denne handling kan ikke fortrydes.",
        "course_are_you_sure": "Er du sikker på, at du vil slette dette kursus? Al obligatorisk træning og alle point, der er knyttet til kurset, bliver også slettet. Denne handling kan ikke fortrydes.",
        "translation_are_you_sure": "Er du sikker på, at du vil slette denne oversættelse? Denne handling kan ikke fortrydes."
      },
      "details": {
        "heading": "Detaljer"
      },
      "edit_name_dialog": {
        "save": "Gem titel",
        "title": "Rediger kursustitel"
      },
      "errors": {
        "select_category": "Vælg mindst én kategori",
        "select_locale": "Vælg mindst ét sprog"
      },
      "form": {
        "labels": {
          "categories": "Kategorier ",
          "risk_categories": "Kategorier",
          "title": "Titel"
        },
        "placeholders": {
          "categories": "Vælg kategorier",
          "title": "Indtast titel"
        }
      },
      "labels": {
        "categories": "Kategori | Kategorier",
        "no_categories": "Ingen kategorier"
      },
      "language_card": {
        "add_language": "Tilføj et sprog",
        "editing": "Redigerer",
        "select_language": "Vælg et sprog",
        "switch": "Skift",
        "translate_with_ai": "Oversæt med AI"
      },
      "navigation": {
        "course": "Kursus",
        "participants": "Deltagere"
      },
      "notifications": {
        "course_deleted": "Kursus slettet",
        "name_updated": "Kursustitel opdateret",
        "saved": "Gemt",
        "settings_saved": "Ændringer gemt",
        "step_deleted": "Trin slettet"
      },
      "preview": "Forhåndsvisning",
      "publish": "Udgiv kursus",
      "publish_confirm": "Ja, udgiv kursus",
      "publish_confirm_description": "Er du sikker på, at du vil udgive dette kursus? Det kan ikke fortrydes og vises straks i hubben.",
      "publish_success": "Kursus udgivet",
      "quiz_editor": {
        "actions": {
          "cancel": "Annuller",
          "save": "Gem"
        },
        "ai_prompt": {
          "button": "AI-prompt",
          "generate": "Generer",
          "label": "Beskriv quizzen, du gerne vil have AI til at lave",
          "no_previous_steps": "Tilføj et video- eller teksttrin tidligere i kurset for at bruge det som kontekst.",
          "placeholder": "Instrukser",
          "select_helper": "Vælg trin",
          "select_label": "Vælg tidligere trin og/eller skriv en brugerdefineret prompt for at generere quizspørgsmål.",
          "step_number": "Trin {order}",
          "step_type": {
            "quiz": "Quiz",
            "text": "Tekst",
            "video": "Video"
          },
          "title": "Generer quiz med AI",
          "untitled": "Uden titel"
        },
        "heading": {
          "description": "Quiz",
          "title": "Trin {step}"
        },
        "select_action": {
          "ai": {
            "description": "Lad AI automatisk generere quizspørgsmål ud fra dit eksisterende indhold i dette kursus.",
            "title": "AI generer ud fra indhold"
          },
          "manual": {
            "description": "Byg din egen quiz fra bunden ved manuelt at tilføje spørgsmål og svar.",
            "title": "Opret quiz manuelt"
          }
        }
      },
      "select_languages_description": "Vælg de sprog, du vil inkludere i dit kursusindhold.",
      "set_current_language_as_default": "Sæt som standard",
      "settings": {
        "edit_description": "Rediger kursusbeskrivelse",
        "save": "Gem"
      },
      "status": {
        "draft": "Kladde",
        "missing_content_warning": "Kurset mangler indhold på et eller flere sprog",
        "published": "Udgivet"
      },
      "steps": {
        "empty": {
          "description": "Klik på rediger-knappen ovenfor for at tilføje indhold",
          "title": "Tomt trin"
        },
        "intro": "Introduktion",
        "knowledge_check": "Videnstjek",
        "missing_translation": "Oversættelse mangler for denne lokalisering",
        "quiz": "Quiz",
        "text": "Tekst",
        "video": "Video"
      },
      "tabs": {
        "course": "Kursus",
        "participants": "Deltagere"
      },
      "text_editor": {
        "actions": {
          "cancel": "Annuller",
          "edit": "Rediger",
          "save": "Gem"
        },
        "ai_prompt": {
          "button": "AI-knap i teksteditor",
          "generate": "Generer",
          "label": "Beskriv, hvad du gerne vil have AI'en til",
          "placeholder": "\"Hjælp mig med at gøre teksten mere formel\"",
          "title": "Generer tekstkort med AI"
        },
        "ai_viewer": {
          "accept": "Acceptér",
          "back": "Annuller",
          "caption": "Gennemgå det AI-genererede indhold, og beslut om du vil acceptere eller regenerere det",
          "generating": "Genererer kursusindhold",
          "heading": "Gennemgå genereret indhold"
        },
        "apply_image": {
          "button": "Anvend på andre sprog",
          "has_image": "Har billede",
          "subtitle": "Vælg sprog, som dette billede skal anvendes på",
          "title": "Anvend billede på andre sprog"
        },
        "course_title_badge": "Kursustitel",
        "heading": {
          "description": "Teksteditor",
          "title": "Trin {step}"
        },
        "labels": {
          "after": "Efter",
          "before": "Før",
          "excerpt": "Uddrag",
          "image_upload": "Billede",
          "remove_image": "Fjern billede",
          "title": "Titel",
          "uploaded_image_alt": "Uploadet billede"
        },
        "placeholders": {
          "content": "Indtast dit indhold",
          "excerpt": "Indtast et uddrag",
          "title": "Indtast en titel"
        },
        "title_linked_tooltip": "Bruges som titel i den {language} version af kurset."
      },
      "title_summary": {
        "course_title": "Kursustitel",
        "description": "Bruges som titel i den {language} version af kurset."
      },
      "translate": {
        "open": "Oversæt kursus",
        "submit": "Oversæt",
        "title": "Oversæt kursus"
      },
      "translate_success": "Kursus oversat.",
      "translation_list_label": "Oversættelse | Oversættelser",
      "unpublish": "Afpublicer kursus",
      "unpublish_confirm": "Ja, afpublicer kursus",
      "unpublish_confirm_description": "Er du sikker på, at du vil afpublicere dette kursus? Det forsvinder straks fra hubben.",
      "unpublish_success": "Kursus afpubliceret",
      "untitled": "Uden titel",
      "validation": {
        "content_missing_in_languages": "Indhold mangler på {count} sprog",
        "missing_content": "Mangler indhold",
        "missing_excerpt": "Mangler uddrag",
        "missing_image": "Mangler billede",
        "missing_questions": "Mangler spørgsmål",
        "missing_title": "Mangler titel",
        "options_missing_text": "Nogle svarmuligheder mangler tekst",
        "questions_missing_correct_options": "Nogle spørgsmål mangler korrekte svarmuligheder",
        "questions_missing_text": "Nogle spørgsmål mangler tekst",
        "step_issues": "Problemer med trin"
      },
      "video_card": {
        "empty_search": {
          "description": "Prøv at justere dine søgeord eller ryd søgningen for at se alle tilgængelige videoer.",
          "title": "Ingen videoer matcher din søgning"
        },
        "empty_state": {
          "description": "Dette trin er tomt. Klik på rediger-knappen ovenfor for at tilføje indhold."
        },
        "fallback_translation_tooltip": "Denne video bruger en fallback-oversættelse",
        "search_placeholder": "Søg efter videoer",
        "selected": {
          "button": "Skift video",
          "title": "VIDEO"
        },
        "title": "Vælg video"
      },
      "video_editor": {
        "empty_search": {
          "description": "Prøv at forbedre dine søgeord eller ryd søgningen for at se alle videoer.",
          "title": "Ingen videoer matcher din søgning"
        },
        "empty_state": {
          "description": "Dette trin er tomt. Klik på rediger-knappen ovenfor for at tilføje indhold."
        },
        "fallback_translation_tooltip": "Denne video bruger en fallback-oversættelse",
        "search_placeholder": "Søg efter videoer",
        "selected": {
          "button": "Skift video",
          "title": "VIDEO"
        },
        "subtitle": "Vælg en video, der skal tilføjes til dette trin.",
        "title": "Vælg video"
      }
    },
    "custom_uploads": {
      "subtitle": "Videos lavet af din organisation",
      "title": "Custom uploads",
      "video": {
        "badges": {
          "quiz": "Quiz",
          "video": "Video"
        },
        "create": {
          "create_video": "Opret video",
          "next_steps_text": "Udfyld oplysningerne nedenfor for at opsætte din video. Efter at have oprettet videoen, bliver du ført til videosiden, hvor du kan vælge denne oversættelse og uploade en videofil.",
          "video_created": "Video oprettet"
        },
        "delete": {
          "are_you_sure": "Er du sikker på, at du vil slette denne video? Denne handling kan ikke fortrydes.",
          "button": "Slet",
          "video_deleted": "Video slettet"
        },
        "form": {
          "labels": {
            "categories": "Kategorier",
            "description": "Beskrivelse",
            "language": "Sprog",
            "title": "Titel"
          },
          "placeholders": {
            "categories": "Vælg kategorier",
            "description": "Indtast en beskrivelse",
            "language": "Vælg sprog",
            "title": "Indtast en titel"
          }
        },
        "publish": "Udgiv",
        "publish_confirm": "Udgiv",
        "publish_confirm_description": "Når videoen udgives, bliver den tilgængelig i hubben og kan bruges på tværs af platformen.",
        "publish_success": "Video udgivet",
        "publish_unavailable": "Upload videoer til alle oversættelser før udgivelse.",
        "quiz": {
          "available_quizzes": "Tilgængelige quizzer",
          "create": "Opret",
          "edit": "Rediger",
          "quiz_deleted": "Quiz slettet",
          "quiz_saved": "Quiz gemt",
          "quizzes": "Quizzer",
          "quizzes_translated": "Quizzer oversat."
        },
        "single": {
          "details": {
            "heading": "Detaljer",
            "text": "Videodetaljer"
          },
          "labels": {
            "categories": "Kategori | Kategorier",
            "created_at": "Oprettelsesdato",
            "published_at": "Udgivelsesdato",
            "updated_at": "Sidst opdateret"
          },
          "title": "Custom video"
        },
        "status": {
          "draft": "Kladde",
          "published": "Udgivet"
        },
        "translations": {
          "add_translation": "Tilføj oversættelse",
          "ai": {
            "done_translate_button": "Færdig",
            "processing_n_languages": "Behandler ét sprog | Behandler {count} sprog",
            "text": "Brug DeepL til automatisk at oversætte videoens titel og beskrivelse til et valgt sprog.",
            "title": "Oversæt videodetaljer med AI",
            "translate_button": "Oversæt",
            "translating_your_video": "Oversætter videodetaljer",
            "video_now_available_in": "Oversættelser er oprettet på ét ekstra sprog | Oversættelser er oprettet på {count} ekstra sprog",
            "video_translate_success": "Succes!"
          },
          "available_translations": "Tilgængelige oversættelser",
          "create_title": "Tilføj oversættelse",
          "default_badge": "Standard",
          "delete": "Slet",
          "delete_are_you_sure": "Er du sikker på, at du vil slette denne oversættelse? Denne handling kan ikke fortrydes.",
          "edit": "Rediger",
          "edit_translation": "Rediger oversættelse",
          "empty": "Ingen oversættelser til denne video",
          "make_default": "Sæt som standard",
          "manual": {
            "text": "Omskriv oversættelsen fra bunden på et nyt sprog.",
            "title": "Oversæt video manuelt"
          },
          "quiz": {
            "create": "Opret quiz",
            "edit": "Rediger quiz",
            "other_translations_have_quizzes": "Andre oversættelser har quizzer",
            "other_translations_have_quizzes_want_to_translate": "Andre oversættelser har allerede quizzer. Vil du automatisk oversætte denne quiz til de sprog?",
            "some_translations_have_no_quizzes": "Nogle oversættelser har i øjeblikket ingen quizzer. Oversæt nu?",
            "this_translation_has_quizzes_in_other_languages_translate_automatically": "Denne oversættelse har quizzer på andre sprog. Oversæt automatisk?",
            "translate_quiz": "Oversæt",
            "update_this_quiz_and_translate_others": "Opdater denne quiz og oversæt andre quizzer",
            "update_this_quiz_only": "Opdater kun denne quiz"
          },
          "save_changes": "Gem ændringer",
          "single": {
            "edit": {
              "subtitle": "Opdater videodetaljerne",
              "title": "Videodetaljer"
            },
            "upload": {
              "subtitle": "Upload videofil til denne oversættelse.",
              "title": "Upload video",
              "video_deleted": "Video slettet",
              "video_uploaded": "Video uploaded"
            }
          },
          "translation_added": "Oversættelse tilføjet",
          "translation_deleted": "Oversættelse slettet",
          "translation_updated": "Oversættelse opdateret",
          "translations": "Oversættelser",
          "video": "Video"
        },
        "unpublish": "Afpublicer",
        "unpublish_confirm": "Afpublicer",
        "unpublish_confirm_description": "Afpublicering skjuler denne video fra hubben. Den vil stadig være tilgængelig i alle automatiseringer, hvor den allerede er brugt.",
        "unpublish_success": "Video afpubliceret"
      }
    },
    "deadlines": {
      "bulk_reminder_dialog_confirm": "Send {count} påmindelse | Send {count} påmindelser",
      "bulk_reminder_dialog_text": "Dette giver besked til {count} medarbejdere. Hver medarbejder modtager én notifikation, selv hvis de har flere opgaver.",
      "bulk_reminder_dialog_title": "Send påmindelser til alle, der matcher dine valgte filtre",
      "bulk_reminders_sent": "Påmindelser afsendt",
      "delete_reminder": "Slet påmindelse",
      "participation_title": "Deltagelse",
      "reminder_deleted": "Påmindelse slettet",
      "reminder_sent": "Påmindelse afsendt",
      "send_bulk_reminder": "Send påmindelse til alle",
      "send_reminder": "Send påmindelse"
    },
    "default_language_updated": "Standardsprog opdateret",
    "default_translation_tooltip": "Dette er i øjeblikket standardsproget. Vælg venligst et andet sprog, før du sletter det.",
    "errors": {
      "select_category": "Vælg mindst én kategori"
    },
    "filter": {
      "course": "Kun kurser",
      "video": "Kun videoer"
    },
    "form": {
      "labels": {
        "categories": "Kategorier",
        "no_categories": "Ingen kategorier"
      },
      "placeholders": {
        "categories": "Vælg kategorier"
      }
    },
    "invited_status": {
      "invited": "Inviteret",
      "not_invited": "Ikke inviteret"
    },
    "moxso_courses": {
      "description": "Kurser leveret af Moxso",
      "title": "Moxso kurser"
    },
    "moxso_uploads": {
      "subtitle": "Videoer leveret af Moxso",
      "title": "Moxso videoer"
    },
    "quiz": "Quiz",
    "search_courses": {
      "description": "Søgeresultater der matcher din søgning",
      "title": "Søgeresultater"
    },
    "type": {
      "course": "Kursus",
      "user_course": "Brugerdefineret kursus",
      "video": "Video"
    },
    "user_defined_courses": {
      "description": "Kurser lavet af din organisation",
      "title": "Brugerdefineret kurser"
    }
  },
  "translations": {
    "ai": {
      "overwrite_existing_translations_text": "Dette vil slette de eksisterende oversættelser og oversætte dem fra bunden",
      "overwrite_existing_translations_title": "Overskriv eksisterende oversættelser",
      "select_languages_to_translate_item_into": "Vælg de sprog, du vil generere oversættelser til",
      "translate_from": "Oversæt fra"
    },
    "deepl_privacy": "DeepL's privatlivspolitik",
    "deepl_text": "Dette vil sende en kopi af din oversættelse til DeepL, en ekstern oversættelsestjeneste. Dit indhold vil blive behandlet eksternt, og {link} vil gælde.",
    "quizzes": {
      "done_translate_button": "Færdig",
      "processing_n_languages": "Behandler ét sprog | Behandler {count} sprog",
      "quiz_now_available_in": "Din quiz er nu tilgængelig på ét ekstra sprog | Din quiz er nu tilgængelig på {count} ekstra sprog",
      "quiz_translate_success": "Succes!",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Vælg de sprog, du vil oversætte din quiz til",
      "translate_button": "Oversæt",
      "translate_from": "Oversæt fra",
      "translate_multiple_choice_quiz": "Oversæt multiple choice-quiz",
      "translating_your_quiz": "Oversætter din quiz"
    }
  },
  "two_factor_challenge": {
    "back_to_login": "Tilbage til login",
    "code": {
      "label": "Godkendelseskode",
      "placeholder": "123456"
    },
    "heading": "Tofaktorgodkendelse",
    "recovery_code": {
      "label": "Gendannelseskode",
      "placeholder": "aaaaaaaaaa-bbbbbbbbbb"
    },
    "submit": "Bekræft",
    "text": "Indtast en kode fra din godkender-app, eller brug en gendannelseskode for at fortsætte.",
    "use_authenticator_code": "Brug en kode fra godkender-app",
    "use_recovery_code": "Brug en gendannelseskode"
  },
  "uploads": {
    "file_upload": {
      "click_to_upload": "Klik for at uploade",
      "delete": {
        "are_you_sure": "Er du sikker på du vil slette denne fil? Denne handling kan ikke fortrydes.",
        "button": "Slet"
      },
      "file_upload_limit": "{fileType} · Op til {fileSize} · {imageRatio} anbefalet",
      "or_drag_and_drop": "{click} eller træk og slip",
      "placeholder": "fil",
      "title": "Upload fil",
      "up_to": "Op til",
      "upload_failed": {
        "button": "Upload ny",
        "subtitle": "Den angivne fil kunne ikke uploades.",
        "title": "Upload mislykkedes"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload fuldført. Du kan roligt forlade siden, mens vi behandler den.",
        "processing_title": "Behandler din fil...",
        "uploading_subtitle": "Din fil bliver uploadet.",
        "uploading_title": "Uploader fil..."
      }
    },
    "image_upload": {
      "click_to_upload": "Klik for at uploade",
      "delete": {
        "are_you_sure": "Er du sikker på du vil slette dette billede? Denne handling kan ikke fortrydes.",
        "button": "Slet"
      },
      "or_drag_and_drop": "eller træk og slip",
      "upload_failed": {
        "button": "Upload ny",
        "subtitle": "Den angivne fil kunne ikke uploades.",
        "title": "Upload mislykkedes"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload fuldført. Du kan roligt forlade siden, mens vi behandler den.",
        "processing_title": "Behandler din fil...",
        "uploading_subtitle": "Din fil bliver uploadet.",
        "uploading_title": "Uploader fil..."
      }
    },
    "video_upload": {
      "click_to_upload": "Klik for at uploade",
      "delete": {
        "are_you_sure": "Er du sikker på du vil slette denne video? Denne handling kan ikke fortrydes.",
        "button": "Slet"
      },
      "format": "MP4",
      "max": "Maks.",
      "or_drag_and_drop": "eller træk og slip",
      "up_to": "Op til",
      "upload_failed": {
        "button": "Upload ny",
        "subtitle": "Den angivne fil kunne ikke uploades.",
        "title": "Upload mislykkedes"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload fuldført. Du kan roligt forlade siden, mens vi behandler den.",
        "processing_title": "Behandler din fil...",
        "uploading_title": "Uploader fil..."
      }
    }
  },
  "upsell": {
    "click_to_open": "Klik for at læse mere",
    "contact": "Underret Customer Success",
    "knowledge_base": "Vidensbase",
    "learn_more": "Læs mere",
    "locked_feature": "Låst modul",
    "notify_success": "Notifikation sendt til Customer Success",
    "upgrade_required": "Dette modul kræver en opgradering"
  },
  "user_settings": {
    "subtitle": "Administrer sikkerhedsindstillingerne for din adminkonto.",
    "title": "Sikkerhed og adgang"
  },
  "validate_domain": {
    "login": "Log ind",
    "success": "Domænevalideringen er blevet gennemført med succes."
  },
  "videos": {
    "error": "Streaming er utilgængelig i øjeblikket"
  },
  "workspace_onboarding": {
    "invite_admins": {
      "form": {
        "button": "Inviter administrator",
        "description": "Tilføj flere administratorer, hvis andre også skal hjælpe med at eje opsætningen eller administrere Moxso. Alle administratorer har samme adgang og ser de samme ændringer.",
        "title": "Inviter endnu en administrator"
      },
      "header": {
        "description": "Beslut, hvem der skal have administratoradgang fra starten. Hvis flere personer skal administrere cybersikkerhed eller Moxso, så inviter dem nu, så opsætning og ejerskab deles fra dag ét. Alle administratorer har samme adgang og ser de samme ændringer.",
        "title": "Inviter administratorer"
      },
      "intro": {
        "admin_added": "Du har allerede mere end én administrator i dette workspace.",
        "description": "En enkelt administrator kan fungere godt for mindre teams, mens flere administratorer kan gøre overdragelse og samarbejde lettere.",
        "eyebrow": "Anbefalet før lancering",
        "recommendation": "Vælg den opsætning, der passer til jeres team, og inviter flere administratorer, hvis ejerskabet deles.",
        "title": "Del administratoradgang"
      },
      "list": {
        "added_on": "Tilføjet den",
        "description": "Gennemgå de administratorer, der i øjeblikket har adgang til dette workspace.",
        "title": "Workspace-administratorer",
        "you": "Dig"
      }
    },
    "kick_off": {
      "complete": "Planlæg kickoff",
      "dates": {
        "description": "Planlæg jeres kickoffdatoer",
        "locked": "Låst",
        "locked_description": "Fuldfør kravene ovenfor for at låse op for planlægning.",
        "simulation": {
          "custom_date": "Brugerdefineret dato",
          "custom_date_description": "Vælg en bestemt dag",
          "label": "Kickoffdato for simulering",
          "one_week_before": "1 uge før træning",
          "recommended": "Anbefalet"
        },
        "title": "Kickoffdatoer",
        "training": {
          "description": "Medarbejderne modtager deres første træningsmodul denne dag.",
          "label": "Kickoffdato for træning",
          "placeholder": "Vælg en dato"
        }
      },
      "header": {
        "description": "Vælg den dag, hvor medarbejderne starter deres awareness-træning. En indledende phishing-simulering kører på forhånd for at måle udgangspunktet.",
        "title": "Planlæg kickoff"
      },
      "validation": {
        "description": "Fuldfør disse trin, før du kan planlægge træningen.",
        "requirements_count": "{count} af {total} gennemført",
        "set_up": "Opsæt",
        "title": "Validering af kickoff"
      }
    },
    "microsoft_manual_setup": {
      "junk": {
        "button": "Sådan omgår du junkfiltre",
        "heading": "Omgå junkfilter",
        "text": "Denne guide giver trin-for-trin-instruktioner til at lade Moxso-e-mails omgå junkfiltre."
      },
      "safe_links": {
        "button": "Sådan omgår du Safe Links",
        "heading": "Omgå Safe Links",
        "text": "Denne guide giver trin-for-trin-instruktioner til at lade Moxso-e-mails omgå Safe Links."
      },
      "spam": {
        "button": "Sådan omgår du spamfiltre",
        "heading": "Omgå spamfilter",
        "text": "Denne guide giver trin-for-trin-instruktioner til at lade Moxso-e-mails omgå spamfiltre."
      },
      "tenant_allow_block": {
        "button": "Sådan allowlister du Moxso via IP i Outlook",
        "heading": "Tilføj Moxso-IP'er til Tenant Allow/Block Lists",
        "text": "Denne guide giver trin-for-trin-instruktioner til at tilføje Moxso-IP-adresser til Tenant Allow/Block Lists i Microsoft Defender for at sikre korrekt e-maillevering."
      },
      "third_party": {
        "button": "Sådan tilføjer du Moxso-IP'er og domæner til Microsoft Defender",
        "heading": "Tilføj Moxsos IP'er og domæner til Microsoft Defender",
        "text": "Denne guide giver trin-for-trin-instruktioner til at tilføje Moxsos IP'er og domæner til indstillingerne for Third-Party Phishing Simulation i Microsoft Defender for at sikre korrekt e-mailtest og levering."
      }
    },
    "onboarding_actions": {
      "back": "Tilbage",
      "continue": "Fortsæt",
      "knowledge_base": "Vidensbase",
      "mark_as_completed": "Marker som fuldført",
      "skip": "Opsæt senere"
    },
    "progress_badge": {
      "kick_off_planned": "Kickoff planlagt",
      "simulation_date": "Startdato for simulering",
      "training_start": "Startdato for træning",
      "workspace_setup": "Opsætning:"
    },
    "reporting_add_in": {
      "confirm_setup": {
        "description": "Hvis Moxso-pluginet er synligt i din mailboks, kan medarbejdere begynde at bruge det til at rapportere mistænkelige e-mails direkte fra deres indbakke.",
        "manage_later": "Se, hvordan rapportering fungerer, i {link}.",
        "subtitle": "Følg guiden til dit e-mailprogram, og fortsæt, når add-in'et er blevet installeret.",
        "this_guide": "denne guide",
        "title": "Er Moxso-pluginet synligt i din mailboks?"
      },
      "continue_disabled_tooltip_text": "Vælg et e-mailprogram for at fortsætte.",
      "follow_guide": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "thunderbird": "Thunderbird",
        "title": "Følg guiden nedenfor"
      },
      "guide_picker": {
        "gmail": {
          "description": "Trinvis guide til at opsætte reporting add-in i Gmail.",
          "title": "Gmail"
        },
        "outlook": {
          "description": "Trinvis guide til at opsætte reporting add-in i Outlook.",
          "title": "Outlook"
        },
        "thunderbird": {
          "description": "Trinvis guide til at opsætte reporting add-in i Thunderbird.",
          "title": "Thunderbird"
        },
        "title": "Vælg dit e-mailprogram"
      },
      "header": {
        "description": "Opsæt Moxso reporting add-in, så medarbejdere hurtigt kan rapportere mistænkelige e-mails direkte fra deres indbakke som en del af deres normale mailworkflow.",
        "title": "Opsæt reporting add-in"
      }
    },
    "setup_provider": {
      "add_simulation": {
        "button": "Opret simulationskladde",
        "continue_disabled_tooltip_text": "Opsæt en phishing-simulationskampagne for at fortsætte",
        "description": "Vi har opsat en phishing-simulationskampagne baseret på din virksomhedsprofil. Denne kampagne fungerer som en baseline til at identificere forbedringsområder.",
        "description_cta": "Klik på knappen nedenfor for at oprette simulationen",
        "header": {
          "description": "Opsæt en phishing-simulationskampagne, der sender realistiske e-mails løbende for at hjælpe medarbejdere med at øve sig i at opdage trusler. Du kan justere kampagneindstillinger og målgruppe efter kampagnen er startet.",
          "title": "Opsæt din første phishing-simulation"
        },
        "settings_card": {
          "Audience": "Målgruppe",
          "Credential harvest": "Credential harvest",
          "Delivery rate": "Leveringsrate",
          "Name": "Navn",
          "all_employees": "Alle medarbejdere",
          "baseline_campaign": "Baseline-kampagne",
          "credential_harvest": "Aktiveret",
          "delivery_rate": "Mellem"
        },
        "simulation_created": "Simulationskladde oprettet",
        "subtitle": "Klar til lancering",
        "title": "Anbefalede indstillinger"
      },
      "buttons": {
        "back": "Tilbage",
        "continue": "Fortsæt"
      },
      "header": {
        "description": "Opsæt en integration for automatisk at synkronisere dine medarbejderdata med systemet. Det holder medarbejderoplysninger opdateret og fjerner behovet for manuelle opdateringer.",
        "title": "Konfigurer integrationer"
      },
      "integration": {
        "header": {
          "description": "Vælg om du vil integrere med din HR-database (identitetsudbyder) eller i stedet importere dine medarbejdere manuelt via en CSV-fil. Vi anbefaler ikke den manuelle mulighed, da det ikke giver systemet mulighed for automatisk at synkronisere og opdatere over tid (holde styr på nye eller inaktive brugere).",
          "title": "Synkroniser medarbejdere"
        },
        "warning": "En administratorkonto med globale rettigheder er påkrævet for at opsætte synkronisering med Microsoft Entra ID eller Google Workspace."
      },
      "provider": {
        "csv_import": "CSV-import",
        "description": "Vælg den platform, du bruger til at administrere identiteter og medarbejdere.",
        "employees": "Medarbejdere",
        "google": "Google Workspace",
        "google_sync": "Google Sync",
        "microsoft": "Microsoft",
        "microsoft_sync": "Microsoft Entra ID",
        "okta": "Okta",
        "title": "Vælg din udbyder"
      },
      "recommendations": {
        "create_target_group": {
          "description": "Opret en gruppe med de medarbejdere, du vil målrette, så du nemt kan tildele simulationer og træning ved at vælge gruppen direkte.",
          "title": "Opret målgruppe"
        },
        "heading": {
          "description": "Følg disse trin inden import af medarbejdere for at sikre, at de korrekte data synkroniseres. Selvom det ikke er obligatorisk, sparer det dig tid senere.",
          "title": "Forbered til integration"
        },
        "verify_language_settings": {
          "description": "Sørg for, at medarbejdernes sprogindstillinger er korrekte, så det rigtige sprog synkroniseres til Moxso.",
          "title": "Kontroller sprogindstillinger"
        },
        "warning": "Sørg for, at nye medarbejdere altid tilføjes til de grupper, der er synkroniseret med Moxso."
      },
      "saml_scim": {
        "header": {
          "description": "Konfigurer single sign-on og automatisk brugerklargøring. Fuldfør begge sektioner nedenfor, og fortsæt, når din identitetsudbyder er forbundet.",
          "title": "Opsæt SAML og SCIM"
        }
      },
      "setup_method": {
        "header": {
          "description": "Brug SAML og SCIM til sikkert login og automatisk brugerklargøring, eller forbind en udbyder via standardintegrationen.",
          "title": "Vælg din opsætning"
        },
        "provider_integration": {
          "description": "Synkroniser medarbejdere direkte fra Microsoft Entra ID, Google Workspace, Slack eller en CSV-fil.",
          "title": "Standardintegration"
        },
        "recommended": "Anbefalet",
        "saml_scim": {
          "description": "Aktivér single sign-on og automatisér brugerklargøring.",
          "title": "SAML og SCIM"
        }
      },
      "whitelisting": {
        "buttons": {
          "change_guides": "Skift guide",
          "confirm_whitelist": "Bekræft allowlist",
          "manual": "Manuel",
          "test_whitelist": "Test allowlist"
        },
        "continue_disabled_tooltip_text": "Bekræft venligst at allowlisting virker før du fortsætter.",
        "follow_guide": {
          "gmail": "Gmail",
          "outlook": "Outlook",
          "title": "Følg guiden nedenfor"
        },
        "guide_picker": {
          "gmail": {
            "description": "Trin-for-trin guide til at tillade e-mails i Gmail.",
            "title": "Gmail"
          },
          "outlook": {
            "description": "Trin-for-trin guide til at tillade e-mails i Outlook.",
            "title": "Outlook"
          },
          "title": "Vælg din e-mailudbyder"
        },
        "header": {
          "description": "Opsæt allowlisting af vores IP-adresser og domæner for at sikre at phishing-simulationer leveres til medarbejdernes indbakker og ikke blokeres af spamfiltre.",
          "title": "Sørg for at beskeder ikke markeres som spam"
        },
        "send_test": {
          "buttons": {
            "no": "Nej, hjælp mig",
            "send_test": "Send testmail",
            "yes": "Ja, jeg modtog den"
          },
          "confirm": {
            "text": "Tjek din indbakke (og spammappe).",
            "title": "Modtog du e-mailen | Modtog du e-mailsene"
          },
          "description": "Send en testmail for at bekræfte at den leveres til din indbakke på {email} (ikke spam). {try_a_few_times}, hver e-mail bruger forskelligt indhold og domæner.",
          "subtitle": "Send testmail",
          "success": {
            "text": "Din konfiguration er korrekt. Du kan nu fortsætte til næste trin.",
            "title": "Allowlisting virker"
          },
          "title": "Bekræft at allowlisting virker",
          "try_a_few_times": "Prøv et par gange"
        }
      }
    },
    "simulation": {
      "targeting": {
        "add_services": "Tilføj tjenester",
        "ceo": "CEO-kontaktoplysninger",
        "cfo": "CFO-kontaktoplysninger",
        "content_description": "Tilføj kontaktoplysninger for ledelsen og jeres tjenester for mere realistiske simulationer.",
        "content_title": "Gør jeres simulationer personlige",
        "cto": "CTO-kontaktoplysninger",
        "description": "Konfigurer realistisk målretning for jeres organisation.",
        "edit_services": "Rediger tjenester",
        "no_services": "Ingen tjenester valgt",
        "services": "Tjenester",
        "services_title": "Vælg tjenester",
        "title": "Opsæt simulationer"
      }
    },
    "steps": {
      "add_simulation": "Simulationer",
      "invite_admins": "Administratorer",
      "kick_off": "Kickoff",
      "reporting_add_in": "Rapporterings-add-in",
      "setup_provider": "Integrationer",
      "training": "Træning",
      "verify_domains": "Domæner",
      "welcome": "Velkommen",
      "whitelisting": "Allowlisting"
    },
    "training": {
      "header": {
        "description": "Vælg, om Moxso automatisk tildeler træning, eller om I selv planlægger den, og tilpas derefter opsætningen til jeres organisation.",
        "title": "Opsæt træning"
      },
      "mode": {
        "continue_disabled": "Vælg en træningsform for at fortsætte.",
        "description": "Vælg en træningsform for at afslutte dette trin.",
        "title": "Vælg træningsform"
      }
    },
    "verify_domains": {
      "buttons": {
        "add": "Tilføj",
        "resend": "Send igen",
        "verify": "Bekræft"
      },
      "continue_disabled_tooltip_text": "Bekræft mindst ét domæne før du fortsætter",
      "domain_placeholder": "company.com",
      "empty": {
        "subtitle": "Tilføj dine virksomhedsdomæner ovenfor for at fortsætte",
        "title": "Ingen domæner tilføjet endnu"
      },
      "heading": {
        "description": "Tilføj alle virksomhedsdomæner, der bruges i medarbejdernes e-mailadresser, for at importere dine medarbejdere. En bekræftelsesmail sendes til {email} for at bekræfte hvert domæne.",
        "title": "Bekræft dine domæner"
      },
      "labels": {
        "add_domain": "Tilføj domæne",
        "not_verified": "Ikke bekræftet",
        "verification_pending": "Bekræftelse afventer",
        "verified": "Bekræftet",
        "verified_on": "Bekræftet den: {date}"
      },
      "verification_email_sent": "Bekræftelsesmail sendt",
      "your_domains": "Dine domæner"
    },
    "welcome": {
      "connect_provider": {
        "description": "Forbered til integration og synkronisering af medarbejdere",
        "title": "Konfigurer integrationer"
      },
      "description": "Du kender måske allerede trinene nedenfor, men vi vil nu sikre, at alle er fuldført, så du kan gå live. Eventuelle testdata, du måtte have oprettet tidligere, er nu fjernet.",
      "get_started": "Kom i gang",
      "invite_admins": {
        "description": "Beslut, om andre også skal hjælpe med opsætning og løbende administratorarbejde.",
        "title": "Inviter administratorer"
      },
      "launch_phishing_simulation": {
        "description": "Opret en baseline-simulation, og konfigurer CEO-fraud og softwaremålretning.",
        "title": "Simulationer"
      },
      "reporting_add_in": {
        "description": "Tilføj Moxso-reportknappen til medarbejdernes indbakker.",
        "title": "Opsæt reporting add-in"
      },
      "review_and_start": {
        "description": "Gennemgå jeres opsætning, og begynd at bruge Moxso.",
        "title": "Begynd at bruge Moxso"
      },
      "subtitle": "Velkommen til Moxso",
      "title": "Lad os gøre dig klar til lancering.",
      "training": {
        "description": "Vælg en træningsform og de rammeværk, der er relevante for jeres organisation.",
        "title": "Træning"
      },
      "verify_domains": {
        "description": "Bekræft de domæner, du vil bruge med Moxso.",
        "title": "Bekræft domæner"
      },
      "whitelist_email": {
        "description": "Sørg for at beskeder ikke markeres som spam.",
        "title": "Opsæt allowlisting"
      }
    }
  },
  "workspace_report": {
    "assignments": "Tildelinger",
    "avg_score": "Gns. score",
    "compared_against": "Sammenlignet med {period}",
    "department": "Afdeling",
    "employee": "Medarbejder",
    "employees_at_risk": "Medarbejdere i risiko",
    "generated": "Genereret {date}",
    "group": "Gruppe",
    "group_breakdown": "Gruppeopdeling",
    "group_breakdown_description": "Samlede signaler, tildelinger og indsatser pr. gruppe",
    "group_breakdown_description_without_hri": "Samlede tildelinger pr. gruppe",
    "group_breakdown_note": "Gennemsnitsscoren er vægtet efter antal medarbejdere i hver gruppe. Signalbjælken opdeler aktiviteten i negativ, neutral og positiv stemning.",
    "group_breakdown_note_without_hri": "Gennemsnitsscoren er vægtet efter antal medarbejdere i hver gruppe.",
    "hri_summary": "HRI-oversigt for arbejdsområdet",
    "human_risk_intelligence": "Human Risk Intelligence",
    "interventions": "Indsatser",
    "interventions_by_type": "Indsatser efter type",
    "last_six_months": "Seneste 6 måneder",
    "loading": "Indlæser arbejdsområderapport…",
    "missed": "Overskredet",
    "no_employees_at_risk": "Ingen medarbejdere i risiko",
    "no_groups": "Ingen gruppedata tilgængelige",
    "no_risk_indicators": "Ingen risikoindikatorer",
    "operational_metrics": "Driftsmålinger",
    "performance_by_team": "Resultater efter team",
    "resilience_score": "Robusthedsscore",
    "risk_index": "Risikoindeks {value}/10 · lavere er bedre",
    "risk_indicator": "Risikoindikator",
    "risk_level": "Risikoniveau",
    "risk_levels": {
      "high": "Høj",
      "low": "Lav",
      "moderate": "Moderat"
    },
    "security_behaviour_overview": "Oversigt over sikkerhedsadfærd",
    "signals": "Signaler",
    "signals_by_sentiment": "Signaler efter stemning",
    "signals_by_severity": "Signaler efter alvorlighedsgrad",
    "threshold": "Tærskel {value}% · sorteret fra lav til høj",
    "title": "Arbejdsområderapport",
    "top_five_period": "Top 5 i denne periode",
    "total": "{count} i alt",
    "total_employees": "{count} medarbejdere i alt",
    "total_groups": "{count} grupper",
    "total_signals": "{count} signaler",
    "training": "Træningsmålinger",
    "training_simulations_risk": "Træning, simuleringer og risiko",
    "trend": "Tendens",
    "trend_title": "Robustheds-, klik- og rapporteringsrate",
    "trending_risk_indicators": "Aktuelle risikoindikatorer",
    "unavailable": "Rapporten er ikke tilgængelig",
    "unavailable_description": "Rapporten kunne ikke indlæses. Kontrollér, at rapportens URL er gyldig og ikke er udløbet.",
    "workspace_summary": "Oversigt over arbejdsområdet"
  }
}
